      // src/i18n.js
      import i18n from 'i18next';
      import { initReactI18next } from 'react-i18next';
      import { spaWaitlistTranslations } from './locales/spaWaitlist';
      import { spaCommunicationTranslations } from './locales/spaCommunications';
      import { spaDailyDashboardTranslations } from './locales/spaDailyDashboard';
      import { spaWorkflowTranslations } from './locales/spaWorkflow';
      import { spaClinicalTranslations } from './locales/spaClinical';

      // Lettura lingua salvata e lingua browser
      const saved = (typeof window !== 'undefined' && window.localStorage)
        ? window.localStorage.getItem('appLang')
        : null;
      const browserIt =
        typeof navigator !== 'undefined' &&
        navigator.language?.toLowerCase().startsWith('it');
      const defaultLng = saved || (browserIt ? 'it' : 'en');

      // Risorse linguistiche
      const resources = {
        en: {
          translation: {
            login: 'Login',
            home: 'Home',
            ospiti: "Guests",
            optional: '(Optional)',
            all: "All",
            azienda: "Company (Optional)",
            datascadenzapreventivo: "Quote valid until",
            qta: "Qty",
            dacatalogo: "From catalog",
            Messaggioemail: "Email message",
            prezzo: "Price",
            orarioServizioOpzionale: "Service time",
            show: "Show",
            descrizionemodificabile: "Editable description",
            search: "Search",
            data: "Date",
            clients: 'Clients',
            giornata: "Day",
            FasceOrarie: "Time Slots",
  InserisciFasceOrarie: "Enter time slots such as breakfast, lunch, and dinner. The active slot name will be shown at the top based on the current time.",
  Fascia: "Slot",
  Rimuovi: "Remove",
  NomeFascia: "Slot Name",
  PlaceholderNomeFascia: "BREAKFAST",
  Da: "From",
  A: "To",
  EsempioFasciaOraria: "Example: from 08:00 to 12:00 = BREAKFAST",
  AggiungiFascia: "Add Slot",
  Salvataggio: "Saving...",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  SalvaFasceOrarie: "Save Time Slots",
  TimeSlotsRequired: "Add at least one valid time slot.",
  TimeSlotInvalid: "Check the entered times.",
  TimeSlotsSaved: "Time slots saved successfully.",
            emailattiva: "Previous recipient email",
            saleassegnate: "Assigned rooms",
            giornateesala: "Days and rooms",
            completata: "Completed",
            checkIn: "Check-in",
            eventoInCorso: "Event in progress",
            eventoCompletato: "Completed event",
            prenotazioniConfermate: "Confirmed reservations",
            preventiviScaduti: "Expired quotes",
            preventivoScaduto: "Expired quote",
            destinatarioLibero: "Free recipient",
            destinatarioLiberoHelp: "Client or company not yet registered.",
            partitaIvaOpzionale: "VAT number (optional)",
            creaCliente: "Create client",
            creaAzienda: "Create company",
            client: 'Client',
            tipiutilizzo: "Usage types (Optional)",
            server: "Server",
            tipiutilizzo: "Usage types",
            Noteorganizzative: "Organizational notes",
            mostrannullateneltabellone: "Show cancelled on board",
            righeperpagina: "Rows per page",
            cerca: "Search",
            transferFrom: "Transfer from:",
            confirmCovers: "Confirm Covers",
                  Puliscifiltrilista: "Clear list filters",
            transferTo: "Transfer to:",
            transfer: "Transfer",
            pratichetrovatesu: "practices found on",
            nessunapractica: "No practice found",
            removeTimeSlot: "Remove time slot",
            tipoPractica: "Practice type",
            nomeEvento: "Event name",
              riepilogoPratiche: "Practice summary",
            placeholdercerca: "Search client, company or event",
            giorno: "Day",
tregiorni: "3 days",
settegiorni: "7 days",
settlavorativa: "Work week",
settimana: "Week",
agenda: "Agenda",
            roomNameExists: "Room Name Already Exists",
            noTableOnStandBy: "No Table In Stand-By",
            pacchetti: "Packages",oggi: "Today",
            nessunapraticanelgiornoselezionato: "No practice found on the selected day",
sale: "Rooms",
capienza: "Capacity",
bloccatada: "Blocked by",
sallacollegata: "linked room",
riepilogopratiche: "Practice summary",
praticheritrovatesu: "practices found on",
Pulisicifiltrilista: "Clear list filters",
tipoPratica: "Practice type",
tutti: "All",
pratica: "Practice",
stato: "Status",
destinatario: "Recipient",
sala: "Room",
periodo: "Period",
invii: "Sends",
azioni: "Actions",
clienteaziendaeventoo: "Client (Optional)",
azienda: "Company (Optional)",
uso: "Use",
motivo: "Reason",
converti: "Convert",
conferma: "Confirm",
modifica: "Edit",
elimina: "Delete",
nessunapraticatrovata: "No practices found",
preventivo: "Quote",
daconfermare: "To confirm",
confermata: "Confirmed",
annullata: "Cancelled",
noshow: "No-show",
giornateeSale: "Days and rooms",
aggiungidata: "Add date",
righepreventivoservizi: "Quote / services rows",
aggiungiriga: "Add row",
Inviopreventivo: "Quote sending",
emailattiva: "Email enabled",
inviaemaildoposalvataggio: "Send email after saving",
Allegatiextra: "Extra attachments",
Caricaallegati: "Upload attachments",
salvapratica: "Save practice",
annulla: "Cancel",
Allestimenticompatibili: "Compatible setups",
durante: "During the booking of this room, only these setups will be selectable.",
parentRoomOptional: "Parent room (optional)",
noParentRoom: "No parent room",
parentRoomHelp: "If this room is a subdivision, select the main room here.",
salvacompatibilita: "Save compatibility",
InviaRiepilogoFiltrato: "Send filtered summary",
inviaPDF: "Send PDF",
Annullapratica: "Cancel practice",
Perannullareunapratica: "To cancel a practice, you must provide the cancellation reason.",
confermaanullamento: "Confirm cancellation",
indietro: "Back",
avanti: "Forward",
nuovapratica: "New practice",
filtri: "Filters",
filtriPerStampa: "Print filters",
filtriPlannerHelp: "Filter the practices shown in the planner and included in PDF or email summaries.",
duplica: "Duplicate",
stato: "Status",
tutti: "All",
sala: "Room",
tutte: "All",
clienteaziendaevento: "Client, company or event",
da: "From",
a: "To",
categorieprodottinelreport: "Product categories in report",
pdfsenzaprezzietotali: "PDF without prices and totals",
mostrannullateneltabellone: "Show cancelled on board",
mostraannullateneltabellone: "Show cancelled on board",
pulisci: "Clear",
modalita: "Mode",
            plannersubtitle: "Manage quotes, reservations, and events from room availability.",
            allestimentisale: "Room setups",
            reparti: "Departments",
            reparto: "Department",
            noteRepartoServizio: "Department notes",
            invioConfermaOpzione: "Confirmation/option email",
            invioRiepilogoEvento: "Event summary email",
            planner: "Planner",
            tableSession: {
              inUse: "Assigned to another operator",
            },
            horizontalPlease: "In order to use this App, Please rotate the screen horizontally",
            numberOfPeople: "Number of people",
            booking_newClient: 'New Client',
            client_page_error_duplicate_email: "Email already exists",
            client_page_error_duplicate_phone: "Phone number already exists",
            client_page_error_create: "Error creating client",
            client_page_error_required_fields: "Name and surname are required",
            client_page_error_email_or_phone_required: "Email or phone number is required",
            client_page_success_create: "Client registered successfully!",
            selectorders: "Select Orders",
            selectTable: "Select Table",
            selectedarticles: "Selected Articles",
            CustomerOrderHistory: "Customer Order History",
            accountsView: "Accounts view",
            serviceAccountsTitle: "Service accounts",
            serviceOrdersTitle: "Service orders",
            serviceAccountsSubtitle: "List of service accounts with aggregated charges.",
            serviceOrdersSubtitle: "List of individual service orders.",
            ordersView: "Orders view",
            accountColumn: "Account",
            orderColumn: "Order",
            date: "Date",
            orders: "Orders",
            status: "Status",
            rows: "Rows",
            total: "Total",
            noOrdersPeriod: "No orders in this period",
            noServiceAccounts: "No service accounts found",
            noProductData: "No product data available",
            noEventsToday: "No events scheduled today.",
            guests: "Guests",
            noServicesToday: "No services to deliver today.",
            noServicesPeriod: "No services in this period.",
            noCharges: "No charges in this period.",
            topServices: "Top services in period",
            topProducts: "Best-selling products",
            servizi: "Services",
            loading: "Loading...",
            monitorEventi: {
              menu: "Event monitor",
              title: "Today's events",
              ended: "Ended",
              realtimeShort: "Live",
              events: "events",
              services: "Services",
              noOperations: "No operational services listed",
              moreOperations: "more activities",
              noEventsForRoom: "Try selecting all rooms.",
              waitingRealtime: "This view updates automatically in real time.",
              moreEvents: "events not visible: filter by room",
              enterFullscreen: "Fullscreen",
              loadError: "Error loading events.",
            },
          
            menuGroups: {
              operativity: "Operations",
              reservationsCrm: "Reservations & CRM",
              catalogMenu: "Catalog & menu",
              administration: "Administration",
              system: "System",
              operationsLog: "Operations log",
              systemSettings: "System settings",
              landingPage: "Landing page",
            },
            issuedDocuments: {
              menu: "Issued documents",
              title: "Issued documents",
              subtitle: "Punto Cassa payments, commercial documents, and HElite room charges.",
              from: "From",
              to: "To",
              refresh: "Refresh",
              refreshed: "Issued documents updated",
              loadError: "Error loading issued documents",
              normalPayments: "Normal payments",
              helitePayments: "HElite charges",
              prepaymentDocuments: "Prepayments",
              countSummary: "{{count}} rows | {{total}}",
              searchPlaceholder: "Search account, client, room, service...",
              account: "Account",
              date: "Date",
              clientContext: "Client / context",
              payments: "Payments",
              document: "Document",
              event: "Event",
              operation: "Operation",
              sourceDocument: "Source document",
              total: "Total",
              actions: "Actions",
              noDocuments: "No issued document found.",
              details: "Details",
              detailTitle: "Account detail #{{id}}",
              prepaymentDetailTitle: "Prepayment detail #{{id}}",
              client: "Client",
              context: "Context",
              paidTotal: "Total paid",
              orderStatus: "Order status",
              method: "Method",
              type: "Type",
              roomHolder: "Room / holder",
              amount: "Amount",
              fiscal: "Fiscal",
              courtesy: "Courtesy",
              historicalHeliteCharge: "Historical HElite charge",
              noHeliteCharges: "No linked HElite charge.",
              codes: "Codes",
              status: "Status",
              error: "Error",
              orderRows: "Order rows",
              extraCounter: "Counter surcharge",
              item: "Item",
              quantity: "Qty",
              commercialDocuments: "Commercial documents",
              noCommercialDocuments: "No linked commercial document.",
              documentCount: "{{count}} documents",
              documentNumber: "Document #{{id}}",
              invoiceNumber: "Invoice {{number}}",
              sourceDocumentNumber: "Source {{number}}",
              eventFallback: "Event #{{id}}",
              prepaymentMovements: "Prepayment movements",
              close: "Close",
              clientFallback: "Client #{{id}}",
              tableFallback: "Table {{id}}",
              counter: "Counter",
              helite: "HElite",
              deduct: "Reverse",
              heliteDeducted: "HElite charge reversed.",
              deductConfirmTitle: "Reverse HElite charge?",
              deductConfirmText: "This will send a reversal to HElite for the selected charge.",
              restore: "RESTORE",
              heliteRestored: "HElite account restored in Point of Sale.",
              restoreHeliteConfirmTitle: "Restore HElite account?",
              restoreHeliteConfirmText: "A new account will be created in Point of Sale with the original items, table, customer and reservation. No new HElite charge will be sent automatically.",
              chargeStatuses: {
                SUCCESS: "Success",
                FAILED: "Failed",
                REVERSED: "Reversed",
                PARTIALLY_REVERSED: "Partially reversed",
                PENDING: "Pending",
              },
              paymentMethods: {
                cash: "Cash",
                card: "Card",
                bankTransfer: "Bank transfer",
                voucher: "Voucher",
                roomCharge: "HElite charge",
                invoice: "Invoice",
              },
              prepaymentTypes: {
                DEPOSIT: "Deposit",
                ADVANCE: "Fiscal advance",
              },
              prepaymentOperations: {
                RECEIPT: "Received",
                REFUND: "Refund",
                REVERSAL: "Reversal",
                APPLICATION: "Applied",
              },
              prepaymentDocumentTypes: {
                PLAIN_RECEIPT: "Plain receipt",
                COMMERCIAL_DOCUMENT: "Commercial document",
                INVOICE_TD02: "Advance invoice",
                COMMERCIAL_CANCELLATION: "Commercial cancellation",
                COMMERCIAL_RETURN: "Commercial return",
                CREDIT_NOTE_TD04: "Credit note",
              },
              lineTypes: {
                product: "Product",
                package: "Package",
                menu: "Menu",
                adjustment: "Adjustment",
              },
            },
            fixedPriceMenu: {
              title: "Fixed-price menu",
              subtitle: "Configure the price, courses, choices, and supplements.",
              newMenu: "New menu",
              editMenu: "Edit menu",
              defaultMenuName: "Lunch Menu",
              defaultFirstCourse: "First course",
              defaultSecondCourse: "Main course",
              defaultDessertCourse: "Dessert",
              defaultCourse: "Course {{index}}",
              restaurantOnly: "This feature is available only for RISTORANTE.",
              loading: "Loading...",
              noMenus: "No menus configured.",
              active: "Active",
              inactive: "Inactive",
              choicesAndDishes: "{{min}}-{{max}} choices, {{count}} dishes",
              edit: "Edit",
              deactivate: "Deactivate",
              deleteConfirm: "Delete \"{{name}}\"?",
              name: "Name",
              date: "Date",
              basePrice: "Base price",
              courseName: "Course name",
              courseOrder: "Order",
              minimum: "Min",
              maximum: "Max",
              availableDishes: "Available dishes",
              optionalSupplement: "Optional supplement",
              extraPrice: "Extra EUR",
              addCourse: "Add course",
              cancel: "Cancel",
              save: "Save",
              saving: "Saving...",
              selectDishes: "Choose dishes",
              selectDishesDescription: "Choose the dishes for each course.",
              choose: "Choose {{count}}",
              chooseRange: "Choose {{min}}-{{max}}",
              chooseUpTo: "Choose up to {{count}} items (optional)",
              noDishesConfigured: "No dishes configured.",
              menuPrice: "Menu price",
              supplements: "Supplements",
              addToOrder: "Add to order",
              menuFallback: "Fixed-price menu",
              productFallback: "Product #{{id}}",
              supplementLabel: "Supplement EUR {{price}}",
              saved: "Fixed-price menu saved",
              deactivated: "Menu deactivated",
              deleted: "Menu deleted",
              loadError: "Error loading menus",
              saveError: "Error while saving",
              deactivateError: "Error while deactivating",
              deleteError: "Error while deleting",
              validationMainFields: "Enter name and price.",
              validationAddCourse: "Add at least one course.",
              validationCourseOrderPositive: "Course order must be a positive number.",
              validationCourseOrderUnique: "Each course must have a different order.",
              validationActiveDate: "Another active menu already exists for this date.",
              validationCourseContent: "Each course must have a name and at least one dish.",
              validationSelectionLimits: "The minimum/maximum choices are invalid.",
              validationMinimumMaximum: "Minimum choices cannot exceed maximum choices.",
              validationMaximumOptions: "Maximum choices exceed the available dishes.",
              checkoutDeleteBlocked: "The fixed-price menu cannot be deleted from checkout.",
              checkoutPriceSnapshot: "The menu price is stored in the order snapshot.",
              checkoutChangesBlocked: "The fixed-price menu cannot be modified in checkout.",
              checkoutSplitBlocked: "The fixed-price menu cannot be split.",
              checkoutQuantitySnapshot: "The menu quantity is stored in the order snapshot.",
            },
            logsPage: {
              title: "Operations log",
              exportCsv: "Export CSV",
              exportSuccess: "CSV export completed",
              exportError: "CSV export error",
              loadError: "Error loading logs",
              action: "Action",
              entity: "Entity",
              entityId: "Entity ID",
              userId: "User ID",
              userName: "Name",
              email: "Email",
              path: "Path",
              reason: "Reason",
              requestId: "Request ID",
              dateTime: "Date/Time",
              from: "From",
              to: "To",
              refresh: "Refresh",
              all: "All",
              noLogs: "No logs found",
            },
            reports: {
              orderStatus: { OPEN: "Open", IN_PROGRESS: "In progress", CLOSED: "Closed", CANCELLED: "Cancelled", PAID: "Paid" },
              eventStatus: { PREVENTIVO: "Quote", TO_CONFIRM: "To confirm", CONFIRMED: "Confirmed", CHECKED_IN: "Check-in", COMPLETED: "Completed", CANCELLED: "Cancelled", NO_SHOW: "No-show" },
              recipientMissing: "Recipient not assigned",
              tablesMissing: "No tables assigned",
              service: "Service",
              package: "Package",
              product: "Product",
              table: "Table",
              counter: "Counter",
              order: "Order #{{id}}",
              event: "Event",
              adminReports: "Admin reports",
              title: "Operational statistics",
              subtitle: "Service orders, future events, today's events, services to deliver and period production.",
              from: "From",
              to: "To",
              refresh: "Refresh",
              today: "Today",
              last7: "Last 7 days",
              last30: "Last 30 days",
              currentMonth: "Current month",
              eventsToday: "Events today",
              serviceRows: "{{count}} service rows",
              deliverToday: "To deliver today",
              plannedServices: "Planned services and packages",
              periodProduction: "Period production",
              serviceOrders: "{{count}} service orders",
              adminReports: "Admin reports",
    title: "Operational statistics",
    subtitle: "Service orders, future events, today’s events, services to deliver and period production.",
    from: "From",
    to: "To",
    refresh: "Refresh",
    today: "Today",
    last7: "Last 7 days",
    last30: "Last 30 days",
    currentMonth: "Current month",
    showEventsSection: "Show events section",
    hideEventsSection: "Hide events section",
    eventsToday: "Events today",
    serviceRows: "Service rows",
    deliverToday: "To deliver today",
    plannedServices: "Planned services",
    periodProduction: "Period production",
    serviceOrders: "Service orders",
    plannedEvents: "Planned events",
    daysInPeriod: "Days in period",
    openOrders: "Open orders",
    openOrdersSubtitle: "Open, in progress or closed",
    counterSales: "Counter sales",
    counterSalesSubtitle: "Orders without table",
    servicesToday: "Services to deliver today",
    servicesTodaySubtitle: "Operational production list by room/table.",
    serviceAccountsTitle: "Service accounts",
    serviceOrdersTitle: "Service orders",
    serviceAccountsSubtitle: "List of service accounts with aggregated charges.",
    serviceOrdersSubtitle: "Orders and charges in the selected period.",
    accountsView: "Accounts view",
    ordersView: "Orders view",
    accountColumn: "Account",
    orderColumn: "Order",
    date: "Date",
    orders: "Orders",
    status: "Status",
    rows: "Rows",
    total: "Total",
    noOrdersPeriod: "No orders in this period.",
    noServiceAccounts: "No service accounts found.",
    noProductData: "No product data available.",
    noEventsToday: "No events scheduled today.",
    noServicesToday: "No services to deliver today.",
    noServicesPeriod: "No services in this period.",
    noCharges: "No charges in this period.",
    topServices: "Top services in period",
    topServicesSubtitle: "Planned production from events.",
    usageTypeStatsTitle: "Statistics by usage type",
    usageTypeStatsSubtitle: "Conference room practice distribution in the selected period.",
    noPracticesPeriod: "No practices in the selected period.",
    withoutUsageType: "No usage type",
    practiceCount: "{{count}} practices",
    daysCount: "{{count}} days",
    guestsCount: "{{count}} guests",
    productionTitle: "Period production",
    productionSubtitle: "Charges from orders and planned services.",
    actual: "Actual",
    planned: "Planned",
    source: "Source",
    item: "Item",
    context: "Context",
    historical: "Historical",
    historicalSubtitle: "Data from existing statistics views.",
    latestDailySales: "Latest daily sales",
    noHistoricalData: "No historical data available.",
    topProducts: "Best-selling products",
    loadError: "Error loading reports",
    recipientMissing: "Recipient not assigned",
    tablesMissing: "No tables assigned",
    service: "Service",
    package: "Package",
    event: "Event",
    anonymousClient: "Anonymous client",
    counter: "Counter",
    table: "Table",
    client: "Client",
    noEvent: "No event",
              plannedEvents: "Planned events",
              daysInPeriod: "{{count}} days in period",
              openOrders: "Open orders",
              openOrdersSubtitle: "Open, in progress or closed",
              counterSales: "Counter sales",
              counterSalesSubtitle: "{{count}} orders without table",
              futureCalendar: "Future events calendar",
              futureCalendarSubtitle: "Compact view of the next 14 days.",
              futureDays: "{{count}} future days",
              noEvent: "No event",
              eventsOfDay: "Today's events",
              eventsOfDaySubtitle: "Today's operational agenda.",
              noEventsToday: "No events scheduled today.",
              guests: "guests",
              servicesToday: "Services to deliver today",
              servicesTodaySubtitle: "Operational production list by room/table.",
              time: "Time",
              quantity: "Qty",
              value: "Value",
              noServicesToday: "No services to deliver today.",
              serviceOrdersTitle: "Service orders",
              serviceOrdersSubtitle: "Orders and charges in the selected period.",
              orderColumn: "Order",
              date: "Date",
              status: "Status",
              rows: "Rows",
              total: "Total",
              noOrdersPeriod: "No orders in this period.",
              topServices: "Top services in period",
              topServicesSubtitle: "Planned production from events.",
              noServicesPeriod: "No services in this period.",
              productionTitle: "Period production",
              productionSubtitle: "Charges from orders and planned services.",
              actual: "Actual",
              planned: "Planned",
              source: "Source",
              item: "Item",
              context: "Context",
              noCharges: "No charges in this period.",
              historical: "Available historical statistics",
              historicalSubtitle: "Data from existing statistics views.",
              latestDailySales: "Latest daily sales",
              orders: "orders",
              noHistoricalData: "No historical data available.",
              topProducts: "Best-selling products",
              noProductData: "No product data available.",
              loadError: "Error loading reports",
              quotesConverted: "Quotes converted",
              quotesConvertedSubtitle: "{{converted}} of {{total}} quotes",
              chartsOverviewTitle: "Sales at a glance",
              chartsOverviewSubtitle: "Animated charts linked to the selected reporting period.",
              chartCollectionTitle: "Collection progress",
              chartCollectionSubtitle: "Collected revenue compared with the outstanding value.",
              chartCollected: "Collected",
              chartToCollect: "To collect",
              chartChannelTitle: "Sales channels",
              chartChannelSubtitle: "Revenue split between counter and table service.",
              chartCounter: "Counter",
              chartTable: "Table service",
              chartQuoteConfirmationTitle: "Quotes and confirmations",
              chartQuoteConfirmationSubtitle: "Quotes still open compared with confirmations generated in the selected period.",
              chartQuotes: "Quotes",
              chartConfirmations: "Confirmations",
              chartPractices: "{{count}} practices",
              chartCompositionTitle: "Sales composition",
              chartCompositionSubtitle: "Revenue distribution by item type.",
              chartNoData: "No data",
              dynamicChartTitle: "Filtered sales trend",
              dynamicChartSubtitle: "Updates instantly with every filter in the dynamic sales table.",
              dynamicTopArticlesTitle: "Top filtered items",
              dynamicTopArticlesSubtitle: "Highest revenue items in the current result.",
              chartRows: "rows",
              chartRevenue: "Revenue",
              chartNoFilteredData: "No sales match the selected filters.",
              soldPeriodTitle: "Dynamic sales table",
              soldPeriodSubtitle: "Filter sales by category, item, room, operator, time slot, date/time, sale type, and payment type.",
              salesFilterCategory: "Category",
              salesFilterArticle: "Item",
              salesFilterRoom: "Sales room",
              salesFilterOperator: "Operator",
              salesFilterTimeSlot: "Time slot",
              salesFilterSaleType: "Sale type",
              salesFilterPaymentType: "Payment types",
              clearFilters: "Clear filters",
              salesExtractionStart: "Extraction start",
              salesExtractionEnd: "Extraction end",
              salesDateTime: "Sale date/time",
              saleTypeHotel: "Hotel guest",
              saleTypeWalkIn: "Walk-in customer",
              operatorMissing: "Operator not detected",
              paymentCash: "Cash",
              paymentCard: "Cards",
              paymentVoucher: "Suspended payments",
              paymentRoomCharge: "Room charge",
              paymentInvoice: "Invoice",
              timeSlotMorning: "Morning 06:00-12:00",
              timeSlotLunch: "Lunch 12:00-15:00",
              timeSlotAfternoon: "Afternoon 15:00-18:00",
              timeSlotDinner: "Dinner 18:00-24:00",
              timeSlotNight: "Night 00:00-06:00",
            },
            eventPanel: {
              loadError: "Error loading event data.",
              eventNameRequired: "Event name is required.",
              selectCompany: "Select a company.",
              selectClient: "Select a client.",
              oneDayRequired: "Add at least one day.",
              dayNeedsStartEnd: "Each day requires a start and end time.",
              dayEndAfterStart: "Day end time must be after the start time.",
              invalidGuests: "Invalid guest count.",
              tableRequiredWhenConfirmed: "When status is not QUOTE, select at least one table for each day.",
              invalidQuoteEmail: "Invalid quote email.",
              dayPrefix: "Day {{number}}",
              packageUnit: "package",
              serviceUnit: "service",
              quoteSubject: "Event quote - {{eventName}}",
              eventCreated: "Event \"{{name}}\" created with status {{status}}.",
              createError: "Error creating event.",
              deleteConfirm: "Delete this event and all linked days?",
              deleted: "Event deleted.",
              deleteError: "Error deleting event.",
              statusUpdated: "Event updated to {{status}}.",
              statusUpdateError: "Error updating event status.",
              title: "Multi-day event (Quote / Reservation)",
              subtitle: "Optional flow: create an event with multiple days, services/packages and initial QUOTE status.",
              loading: "Loading event data...",
              eventName: "Event name",
              initialStatus: "Initial status",
              recipient: "Recipient",
              company: "Company",
              client: "Client",
              eventNotes: "Event notes",
              day: "Day",
              start: "Start",
              end: "End",
              people: "People",
              dayNote: "Day note",
              tables: "Tables",
              packages: "Packages",
              singleServices: "Single services",
              addDay: "Add day",
              sendQuoteAfterCreate: "Send quote email after creation",
              recipientEmail: "Recipient email",
              subject: "Subject",
              message: "Message",
              saving: "Saving...",
              createEvent: "Create event",
              latestEvents: "Latest created events",
              dayStatuses: "Day statuses",
              period: "Period",
              guests: "Guests",
              days: "Days",
              actions: "Actions",
              confirm: "Confirm",
              delete: "Delete",
              noEvents: "No events available.",
            },
            quoteAdmin: {
              packageUnit: "package",
              packageSubtitle: "Package - {{count}} services",
              unitEach: "unit",
              catalogLoadError: "Error loading catalog.",
              sendQuoteError: "Error sending quote",
              eventCreateRequired: "To create the QUOTE event, select a client or a company.",
              customServicesNote: "Custom services not mapped:",
              quoteEventName: "Quote - {{name}}",
              recipientFallback: "Recipient",
              eventCreateError: "Error creating QUOTE event",
              sentAndEventCreated: "Quote sent and QUOTE event created.",
              eventCreatedEmailFailed: "QUOTE event created, but email not sent: {{error}}",
              emailNotSent: "Email not sent: {{error}}",
              eventNotCreated: "Event not created: {{error}}",
              operationNotCompleted: "Operation not completed.",
              client: "Client",
              company: "Company",
              manualEmail: "Manual email",
              noEmail: "no email",
              searchCompany: "Search company",
              noEmailWarning: "The selected recipient does not have a valid email.",
              realCatalog: "Real services catalog",
              realCatalogSubtitle: "Select packages or individual services.",
              guestCount: "Number of people",
              table: "Table",
              seats: "seats",
              tablesOptional: "Tables (optional)",
              selectTables: "Select one or more tables",
              compatibleTables: "{{count}} tables compatible with {{guests}} people",
              insertGuestsFirst: "Enter the number of people first to filter by capacity",
              search: "Search",
              type: "Type",
              all: "All",
              packages: "Packages",
              servicesSingle: "Single services",
              results: "results",
              catalogLoading: "Loading catalog...",
              name: "Name",
              detail: "Detail",
              price: "Price",
              package: "Package",
              service: "Service",
              added: "Added",
              add: "Add",
              noResults: "No results for the selected filters.",
              eventDateTime: "Event date and time",
            },
            orderHistoryPage: {
              noProducts: "No products in this order.",
              title: "Order history",
              clients: "Clients",
              companies: "Companies",
              heliteRooms: "HElite rooms",
              search: "Search...",
              noClients: "No clients found.",
              noCompanies: "No companies found.",
              noHeliteRooms: "No HElite rooms found.",
              selectTarget: "Select a client, company, or HElite room to view order history.",
              heliteRoomsPanel: "Live HElite guests",
              heliteGuestsCount: "{{count}} checked-in rooms",
              inHouse: "In house",
              spentShort: "Spent",
              orders: "Orders",
              lastOrder: "Last order",
              searchHeliteRoom: "Search room {{roomNumber}}",
              searchHeliteRoomHint: "Search orders and room charges for this HElite room.",
              roomLabel: "Room {{roomNumber}}",
              heliteBill: "HElite booking {{billNumber}}",
              spent: "Spent: {{amount}}",
              ordersCount: "{{count}} orders",
              noOrders: "No orders found.",
              order: "Order",
              date: "Date",
              status: "Status",
              total: "Total",
              productFallback: "Product #{{id}}",
              packageFallback: "Package #{{id}}",
              fixedMenuFallback: "Fixed price menu",
            },
            bookingExtra: {
              multiEventQuote: "Multi-day event / Quote",
              quotes: "Quotes",
              classicReservation: "Classic reservation",
              showCancelled: "Show cancelled",
              showNoShow: "Show no-show",
              companyAlternative: "Company (alternative to client)",
              companyHelper: "Select a company if you want to book without a named client.",
              newCompanyUpper: "New company",
              newCompany: "New company",
              eventNameOptional: "Event name (optional)",
              eventNameHint: "Use it as a discriminator to link this reservation to an event.",
              companyNameRequired: "Company name is required.",
              companyCreated: "Company created successfully.",
              companyName: "Company name *",
              vatOptional: "VAT number (optional)",
              sdiOptional: "SDI (optional)",
              emailOptional: "Email (optional)",
              phoneOptional: "Phone (optional)",
              addressOptional: "Address (optional)",
              legalAddressOptional: "Legal address (optional)",
              createCompany: "Create company",
              event: "Event:",
              services: "Services",
            },
            miscUi: {
              destination: "Destination",
              newCourse: "New course",
              selectedCourse: "Selected course",
              orderReprinted: "Order reprinted",
              viewOrder: "View order",
              transferToAnotherTable: "Transfer to another table",
              destinationTable: "Destination table",
              transferItems: "Transfer",
              moveSelectedProduct: "Move {{count}} product",
              moveSelectedProducts: "Move {{count}} products",
              occupiedTableWarningTitle: "Warning: occupied table",
              occupiedDestinationTableConfirm: "The destination table is occupied. Do you want to continue with the transfer anyway?",
              transferSuccess: "Products transferred",
              noClientsAvailable: "No clients available",
              noCompaniesAvailable: "No companies available",
            },

      errorDefault: "Something goes wrong!",
      planning_title: "Meeting Planning",
      planning: {
        title: "Meeting Planning",
        today: "Today",
        help: "Click a free slot to create a reservation, then refine details in the dialog.",
        legend_available: "Available slots",
        legend_reserved: "Reserved slots",
        room_summary: "{{count}} tables",
        empty_day: "No reservations for this room today",
        no_rooms: "No rooms configured.",
        add_at: "Add reservation at",
        reservation_detail: "Reservation Detail",
        time: "Time",
        guests: "Guests",
        note: "Note",
        notes: "Notes",
        new_reservation: "New Reservation",
        start_time: "Start",
        end_time: "End",
        confirm: "Confirm",
        error_client: "Select a client.",
        error_dates: "Set start and end time.",
        error_no_table: "No table found for this room.",
        delete_reservation: "Delete reservation",
        deleting: "Deleting..."
      },
      confirm_delete: "Delete reservations",
confirm_delete_msg: "Are you sure you want to delete {{count}} reservation(s)? This cannot be undone.",
preventivi: {
  page:                  "Quotations",
  subtitle:              "Create and send a quotation/offer via e-mail to the client.",
  step_client:           "Client",
  step_services:         "Services",
  step_preview:          "Preview & Send",
  select_recipient:      "Select recipient",
  existing_client:       "Existing client",
  insert_email:          "Enter e-mail",
  search_client:         "Search by name or email…",
  recipient_name:        "Recipient name",
  email_address:         "E-mail address",
  to:                    "To",
  available_services:    "Available services",
  click_to_add:          "Click a service to add it to the quotation.",
  quote_items:           "Quote items",
  no_services_selected:  "No services selected. Click the chips above to add.",
  col_service:           "Service",
  col_unit:              "Unit",
  col_qty:               "Qty",
  col_unit_price:        "Unit price (€)",
  col_unit_price_short:  "Unit.",
  col_total:             "Total (€)",
  grand_total:           "Quote total",
  add_custom:            "Add custom item",
  custom_name:           "Service name",
  custom_unit:           "Unit",
  custom_unit_placeholder: "e.g. day",
  custom_price:          "Unit price",
  add:                   "Add",
  email_details:         "E-mail details",
  subject:               "Subject",
  event_date:            "Event date",
  valid_until:           "Quote valid until",
  intro_message:         "Intro message (optional)",
  intro_placeholder:     "Write a personalised message for the client…",
  email_preview:         "E-mail preview",
  include_logo:          "Include logo in the e-mail",
  email_header_title:    "Quotation Offer",
  email_header_sub:      "Congress Halls",
  email_greeting:        "Dear",
  email_default_body:    "Thank you for your interest. Please find below the detailed quotation for the requested services.",
  email_footer:          "Quotation generated automatically — Congress Halls",
  sent_title:            "Quotation sent!",
  sent_desc:             "The quotation has been sent to",
  new_quote:             "New quotation",
  send:                  "Send quotation",
  sending:               "Sending…",
  send_error:            "Send error",
  send_error_label:      "Error while sending",
  back:                  "Back",
  next:                  "Next",
  services: {
    hall_half_day:   "Congress Hall – half day",
    hall_full_day:   "Congress Hall – full day",
    projector:       "Projector + screen",
    microphone:      "Wireless microphone",
    coffee_break:    "Coffee break",
    business_lunch:  "Business lunch",
    gala_dinner:     "Gala dinner",
    floral:          "Floral arrangement",
    parking:         "Reserved parking",
    wifi:            "Dedicated high-speed Wi-Fi",
    photography:     "Photography service",
  },
  units: {
    session:   "session",
    day:       "day",
    unit_day:  "unit/day",
    person:    "person",
    set:       "set",
    spot_day:  "spot/day",
    hour:      "hour",
    unit:      "unit",
  },
},
            comunicazioni: {
        title:              "Reservation Communications",
        subtitle:           "Select a reservation to view and add operator notes.",
        select_reservation: "Reservations",
        search_reservation: "Search guest or room...",
        no_reservations:    "No reservations found.",
        select_to_start:    "Select a reservation to start the conversation.",
        room:               "Room",
        write_placeholder:  "Write a message... (Enter to send)",
        publish:            "Send",
        no_notes:           "No messages yet. Start the conversation.",
        error_empty:        "Message cannot be empty.",
        error_publish:      "Error sending message.",
        success_publish:    "Message sent!",
        user_fallback:      "User #{{id}}",
        tables_title:   "Tables",
      tables_subtitle: "Click a table to view or add communications.",
    page: "Communications",
      },

            spa: {
              common: {
                all: "All",
                cancel: "Cancel",
                clear: "Clear",
                save: "Save",
                spaOnly: "This area is available only for SPA tenants.",
              },
              planner: {
                menu: "SPA Planner",
                title: "SPA Planner",
                subtitle: "Daily appointment board for SPA treatments, operators, and cabins.",
                day: "Day",
                week: "Week",
                today: "Today",
                newAppointment: "New Appointment",
                editAppointment: "Edit Appointment",
                loading: "Loading SPA planner...",
                empty: "No appointments for the selected filters.",
                backendPending: "Backend pending: appointments are temporary until `/api/spa/*` endpoints are available.",
                metrics: {
                  appointments: "Appointments",
                  inProgress: "In progress",
                  completed: "Completed",
                  noShow: "No-show",
                },
              },
              settings: {
                title: "Settings",
                loading: "Loading settings",
                saving: "Saving...",
                loadError: "Unable to load SPA scheduling settings.",
                saveError: "Unable to save SPA scheduling settings.",
                interval: "Planner interval",
                timeZone: "Time zone",
                openingHours: "Opening hours",
                noOpeningHours: "No opening hours configured for this day",
                closedDays: "Closed days",
                closedDay: "Closed day",
                holidays: "Holidays",
                day: "Day",
                start: "Start",
                end: "End",
                addOpeningHour: "Add opening hour",
                addHoliday: "Add holiday",
                holidayDate: "Date",
                holidayName: "Name",
                invalidDate: "Invalid appointment date.",
                closedDayWarning: "This date is closed in SPA settings.",
                holidayWarning: "This date is marked as holiday: {{name}}.",
                intervalWarning: "Start time must follow the {{interval}} minute planner interval.",
                outsideOpeningHoursWarning: "Start time is outside configured opening hours.",
                days: {
                  0: "Sunday",
                  1: "Monday",
                  2: "Tuesday",
                  3: "Wednesday",
                  4: "Thursday",
                  5: "Friday",
                  6: "Saturday",
                },
              },
              statuses: {
                OPTION: "Option",
                CONFIRMED: "Confirmed",
                GUARANTEED: "Guaranteed",
                ARRIVED: "Arrived",
                IN_PROGRESS: "In progress",
                COMPLETED: "Completed",
                CANCELLED: "Cancelled",
                NO_SHOW: "No-show",
              },
              customerTypes: {
                hotelGuest: "Hotel guest",
                external: "External",
              },
              fields: {
                actions: "Actions",
                area: "Area",
                cabin: "Cabin",
                capacity: "Capacity",
                category: "Category",
                client: "Client",
                date: "Date",
                duration: "Duration",
                durationMinutes: "Duration minutes",
                email: "Email",
                name: "Name",
                notes: "Notes",
                operator: "Operator",
                price: "Price",
                quantity: "Quantity",
                room: "Room",
                skills: "Skills",
                start: "Start",
                status: "Status",
                treatment: "Treatment",
                type: "Type",
                vat: "VAT",
                vatPercent: "VAT %",
              },
              catalog: {
                menu: "SPA Catalog",
                title: "SPA Catalog",
                operatorSaved: "Operator saved.",
                operatorCreated: "Operator created. You can now add qualifications and shifts.",
                subtitle: "Treatments, operators, and equipment prepared for backend API wiring. Cabins are managed from the cabin map.",
                addItem: "Add {{item}}",
                editItem: "Edit {{item}}",
                loading: "Loading SPA catalog...",
                backendPending: "Backend pending: catalog changes are temporary until `/api/spa/*` endpoints are available.",
                commaSeparated: "Comma separated",
                engagementReminderMinutes: "Engagement reminder minutes",
                engagementReminderHelp: "From 5 minutes to 7 days before the appointment.",
                externalInvitations: "External invitations",
                appointmentId: "Appointment ID",
                expiresInDays: "Expires in days",
                createInvitation: "Create invitation",
                selectAppointment: "Select appointment",
                selectAssignedAppointment: "Assigned appointments for this week.",
                noAssignedAppointments: "No assigned appointments found for this week.",
                oneTimeToken: "One-time token",
                copyToken: "Copy token",
                invitationUrl: "Invitation URL",
                copyUrl: "Copy URL",
                openInvitation: "Open",
                expiresAt: "Expires at",
                respondedAt: "Responded at",
                resend: "Resend",
                revoke: "Revoke",
                noInvitations: "No invitations yet.",
                invitationCreated: "Invitation created.",
                invitationCreatedEmailFailed: "Invitation created, but email was not sent.",
                invitationResent: "Invitation resent.",
                invitationResentEmailFailed: "Invitation resent, but email was not sent.",
                invitationRevoked: "Invitation revoked.",
                invitationCreateError: "Could not create invitation",
                invitationResendError: "Could not resend invitation",
                invitationRevokeError: "Could not revoke invitation",
                invitationTokenCopied: "Invitation token copied.",
                invitationTokenCopyError: "Could not copy token",
                invitationUrlCopied: "Invitation URL copied.",
                invitationUrlCopyError: "Could not copy URL",
                managedInProducts: "Managed in Products",
                managedInUsers: "Managed in Users",
                tabs: {
                  treatments: { label: "Treatments", singular: "Treatment" },
                  operators: { label: "Operators", singular: "Operator" },
                  equipment: { label: "Equipment", singular: "Equipment" },
                },
                statuses: {
                  active: "Active",
                  inactive: "Inactive",
                  available: "Available",
                  cleaning: "Cleaning",
                  maintenance: "Maintenance",
                  out_of_service: "Out of service",
                },
              },
            },

            tenantDomain: {
              RISTORANTE: {
                addTable: "Add Table",
                editTable: "Edit Table",
                tableName: "Table Name",
                tablePrefix: "Table Name Prefix",
                tableSuffix: "Table Name Suffix",
                tableQuantity: "Table Quantity",
                selectedTable: "Selected Table",
                room: "Room",
                roomName: "Room Name",
                addRoom: "Add Room",
                editRoom: "Edit Room",
                deleteRoom: "Delete Room",
                seats: "Number of Seats",
                seatNumber: "Nr of Seats",
                occupiedSeats: "Occupied Seats",
                bookingTable: "Table",
                bookingGuests: "Guests number",
                reservationTable: "Table",
                reservationRoom: "Room",
                clearTableTitle: "Confirm table clearance",
                clearTableAlert: "Are you sure you want to clear table",
                tablesMap: "Table map",
                newTable: "New Table",
                noTable: "No Tables Available",
                selectTable: "Select Table",
                freeTables: "Free Tables",
                activeTables: "Active Tables",
                occupiedTables: "Occupied Tables",
                addTableQuestion: "Add table?",
                deleteTableRequestTitle: "Confirm Delete Table",
                deleteTableRequest: "Are you sure you want to delete this table? The action cannot be undone.",
                deleteRoomRequestTitle: "Confirm Delete Room",
                deleteRoomRequest: "Warning! By deleting the selected room you will also delete all associated tables. Do you want to proceed?",
                newOrder: "New Order",
                selectorders: "Select articles",
                noOrders: "No Active Orders",
                closeBill: "Close Bill",
                split: "Split Order",
                transferOrder: "Transfer Order",
                confirmCovers: "Confirm Covers",
                activeOrders: "Active Orders",
                orderSummary: "Order Summary",
                noProductPresent: "No product present in this Order",
                products: "Items",
                add_product: "Add Item",
                allestimenti: {
                  pageTitleShort: "Packages",
                },
          realTimeOrders: "Real-Time Orders",
                send_order: "Send Order",
                orderDetails: "Order Details",
                draftPayment: "Draft Payment",
                No_table_selected: "No table selected",
                checkoutPage: "Checkout",
                checkout_page: {
                  noRegisteredOrders: "No Registered Orders",
                  pending: "Pending",
                  occupied: "Occupied",
                },
                menu_config: {
                  page: "Menu",
                },
                clearAllTablesAndPay: "[DEV] CLEAR TABLES AND PAY ORDERS",
              },
              SPA: {
                addTable: "Add Cabin",
                editTable: "Edit Cabin",
                tableName: "Cabin Name",
                tablePrefix: "Cabin Prefix",
                tableSuffix: "Cabin Suffix",
                tableQuantity: "Cabin Quantity",
                selectedTable: "Selected Cabin",
                room: "Area",
                roomName: "Area Name",
                addRoom: "Add Area",
                editRoom: "Edit Area",
                deleteRoom: "Delete Area",
                seats: "Number of People",
                seatNumber: "Nr of People",
                occupiedSeats: "Occupied People",
                bookingTable: "Cabin",
                bookingGuests: "Number of people",
                reservationTable: "Cabin",
                reservationRoom: "Area",
                clearTableTitle: "Confirm cabin clearance",
                clearTableAlert: "Are you sure you want to clear cabin",
                tablesMap: "Cabin map",
                newTable: "New Cabin",
                noTable: "No Cabins Available",
                selectTable: "Select Cabin",
                freeTables: "Free Cabins",
                activeTables: "Active Cabins",
                occupiedTables: "Occupied Cabins",
                addTableQuestion: "Add cabin?",
                deleteTableRequestTitle: "Confirm Delete Cabin",
                deleteTableRequest: "Are you sure you want to delete this cabin? The action cannot be undone.",
                deleteRoomRequestTitle: "Confirm Delete Area",
                deleteRoomRequest: "Warning! By deleting the selected area you will also delete all associated cabins. Do you want to proceed?",
                newOrder: "New Appointment",
                noOrders: "No Active Appointments",
                closeBill: "Close Session",
                split: "Split Session",
                transferOrder: "Transfer Appointment",
                confirmCovers: "Confirm Guests",
                activeOrders: "Active Appointments",
                orderSummary: "Appointment Summary",
                noProductPresent: "No service present in this Appointment",
                products: "Services",
          realTimeOrders: "Real-Time Appointments",
                send_order: "Send Appointment",
                orderDetails: "Appointment Details",
                draftPayment: "Draft Payment",
                No_table_selected: "No cabin selected",
                checkoutPage: "Session Checkout",
                checkout_page: {
                  noRegisteredOrders: "No Registered Appointments",
                  pending: "Pending appointments",
                  occupied: "Active appointments",
                },
                menu_config: {
                  page: "Service price list",
                },
                clearAllTablesAndPay: "[DEV] CLEAR CABINS AND PAY ORDERS",
              },
              SALE_CONGRESSI: {
                planning: {
  title:              "Meeting Planning",
  today:              "Today",
  help:               "Click a free slot to create a reservation, then refine details in the dialog.",
  legend_available:   "Available slots",
  legend_reserved:    "Reserved slots",
  room_summary:       "{{count}} tables",
  empty_day:          "No reservations for this room today",
  delete_reservation: "Delete reservation",
  deleting:           "Deleting...",
  no_rooms:           "No rooms configured.",
  add_at:             "Add reservation at",
  reservation_detail: "Reservation Detail",
  time:               "Time",
  guests:             "Guests",
  note:               "Note",
  notes:              "Notes",
  new_reservation:    "New Reservation",
  start_time:         "Start",
  end_time:           "End",
  confirm:            "Confirm",
  error_client:       "Select a client.",
  error_dates:        "Set start and end time.",
  error_no_table:     "No table found for this room.",
},
                addTable: "Add Hall",
                editTable: "Edit Hall",
                tableName: "Hall Name",
                tablePrefix: "Hall Prefix",
                tableSuffix: "Hall Suffix",
                tableQuantity: "Hall Quantity",
                selectedTable: "Selected Hall",
                room: "Area",
                roomName: "Area Name",
                addRoom: "Add Area",
                editRoom: "Edit Area",
                deleteRoom: "Delete Area",
                seats: "Number of Participants",
                seatNumber: "Nr of Participants",
                occupiedSeats: "Occupied Participants",
                bookingTable: "Hall",
                eventPanel: {
                  tables: "Halls",
                  tableRequiredWhenConfirmed: "When status is not QUOTE, select at least one hall for each day.",
                },
                bookingGuests: "Number of participants",
                reservationTable: "Hall",
                reservationRoom: "Area",
                clearTableTitle: "Confirm hall clearance",
                clearTableAlert: "Are you sure you want to clear hall",
                tablesMap: "Room setup",
                newTable: "New Hall",
                noTable: "No Halls Available",
                selectTable: "Select Hall",
                freeTables: "Free Halls",
                activeTables: "Active Halls",
                occupiedTables: "Occupied Halls",
                addTableQuestion: "Add hall?",
                deleteTableRequestTitle: "Confirm Delete Hall",
                deleteTableRequest: "Are you sure you want to delete this hall? The action cannot be undone.",
                deleteRoomRequestTitle: "Confirm Delete Area",
                deleteRoomRequest: "Warning! By deleting the selected area you will also delete all associated halls. Do you want to proceed?",
                newOrder: "New Practice",
                noOrders: "No Active Events",
                closeBill: "Close Event",
                split: "Split Event",
                transferOrder: "Transfer Event",
                confirmCovers: "Confirm Participants",
                activeOrders: "Active Events",
                orderSummary: "Event Summary",
                noProductPresent: "No service present in this Event",
                products: "Services",
          realTimeOrders: "Real-Time Events",
                send_order: "Send Event",
                orderDetails: "Event Details",
                draftPayment: "Draft Payment",
                No_table_selected: "No hall selected",
                checkoutPage: "Event Checkout",
                checkout_page: {
                  noRegisteredOrders: "No Registered Events",
                  pending: "Pending events",
                  occupied: "Active events",
                },
                menu_config: {
                  page: "Service price list",
                },
                clearAllTablesAndPay: "[DEV] CLEAR HALLS AND PAY ORDERS",
                allestimenti: {
            pageTitle: "Package management",
            pageSubtitle: "Create packages for bookings and direct sales. Conference halls can add them in reservations, while restaurants can add fixed menus directly to tables.",
            pageTitleShort: "Packages",
            productsAvailable: "Available services",
            packageCapacityPeople: "participants",
          },
        },
            },
        order:    "Ordine",
        date:     "Data",
        table:    "Tavolo",
        room:     "Stanza",
            client_page: {
              title: "Client Management",
              or_create_company: "Or create a new company:",
              address: "Address",
              street_number: "Street Number",
              zip_code: "ZIP Code",
              city: "City",
              province: "Province",
              tax_code: "Tax Code",
              rea_number: "REA Number",
              rea_office: "REA Office",
              search_label: "Search by name or room number",
              insert_passenger: "Add External Client",
              name: "Name",
              surname: "Surname",
              email: 'Email address',
              phone: 'Telephone number',
              add_client: "Add Client",
              order_history: "Order history for",
              order: "Order",
              toCheckout: "Send to Checkout",
              no_orders: "No orders found",
              room: "Room number",
              treatment: "Treatment (External or Client)",
              internal: "Client",
        external: "External",
        no_client_search: "Use the search bar to find the client",
              client_type: "Client Type",
              type_company: "Company",
              type_individual: "Individual",
              type_reference: "Reference Contact",
              company_name: "Company Name",
              contact_person: "Contact Person",
              email_or_phone_required: "Email or phone number is required",
              name_optional: "Name (Optional)",
              surname_optional: "Surname (Optional)",
        btn_clienti:  "Clienti",
          btn_aziende:  "Aziende",
          add_company: "Add Company",

          // clienti section — add form

        legal_address: "Legal address",
        company_email: "Company email",

        company_hint:        "No companies yet — create one in the Companies section",
        company_search_hint: "Search or select an existing company",
        company_no_options:  "No companies found",
        search_companies_label: "Search by company name, VAT or email",

        no_results:       "No clients found.",
        no_clienti:       "No clients registered yet.",
        linked_clients:   "Linked clients",

        add_company_and_client:  "Add Company & Client",
        add_company_subtitle:    "Register a new company and its primary linked client.",
        client_info:             "Client Details",
        company_info:            "Company Details",
        register_company_client: "Register Company & Client",

        company_management: "Company Management",
        no_companies:       "No companies registered yet.",


        success_create:                "Client registered successfully!",
        success_create_company_client: "Company and client registered successfully!",
        error_required_fields:         "Name and surname are required.",
        error_company_required:        "Company name is required.",
        error_create:                  "Error during registration.",
            },
            confirmOperation: {
              deleteProduct: "Delete product in order?",
              cancel: "Cancel",
              confirm: "Confirm",
              editOrder: "Edit Order",
            },
            heliteGuestPicker: {
              title: "Select HElite guest",
              searchPlaceholder: "Search by room, name, or booking",
              loading: "Loading HElite guests...",
              loadingShort: "Loading guests...",
              empty: "No HElite guest found.",
              room: "Room",
              guest: "Guest",
              board: "Board",
              booking: "Booking",
              arrival: "Arrival",
              departure: "Departure",
              roomWithNumber: "Room {{room}}",
              bookingShort: "Booking {{number}}",
              linkedGuest: "HElite guest",
              noLinkedGuest: "No HElite guest linked",
              selectButton: "HElite guest",
              selectRequired: "Select an HElite guest",
              confirmCharge: "Confirm charge",
              missingBillId: "HElite guest without billId: cannot register the room charge.",
              invalidAmount: "Invalid HElite amount.",
              loadError: "Error loading HElite guests",
              invalidCheckoutTotal: "Invalid checkout total",
              paymentRoomCharge: "HElite charge",
              restaurantChargeDescription: "Restaurant charge {{room}}{{table}}",
              reservationRecipientRequired: "Select a client, company, or HElite guest for the reservation",
              reservationGuestsRequired: "Enter how many seats to reserve",
              reservationDateTimeRequired: "Select date and time slot",
              reservationTableRequired: "Select at least one table",
              reservationInvalidTimeRange: "Invalid time range",
              reservationPastDate: "The reservation date is in the past.",
            },
            sameClient: "SameClient?",
            openDrawer: "open drawer",
            Passante: "Passerby",
            Cliente: "Client",
            Orders: "Orders",
            orderList: "Order List",
            orderDetail: "Order Detail to",
            orderDetails: "Order Details",
            seeOrder: "See Order",
            send_order: "Send Order",
            follow: "Follow",
            showPic: "Show Images",
            addTimeSlot: "Add time slot",
            hidePic: "Hide Images",
            systemSettings: {
              page: "System Settings",
              pageSubtitle: "Configure the default operational preferences of the system.",
              showOrderImages: "Show images in order taking",
              showOrderImagesHelp: "Show or hide product images while taking orders.",
              kitchenPrintMenuName: "Print fixed-menu name on kitchen orders",
              kitchenPrintMenuNameHelp: "Adds the fixed-menu name in brackets next to each selected dish.",
              kitchenPrintMenuNameOn: "Shown",
              kitchenPrintMenuNameOff: "Hidden",
              defaultTableMapView: "Default table map view",
              defaultTableMapViewHelp: "Sets the initial view when opening Table Map.",
              draftPrintersLabel: "Draft payment printers",
              draftPrintersHelp: "These printers will be used for draft payment (independent from products).",
              invoiceCourtesyPrintersLabel: "Invoice courtesy copy printers",
              invoiceCourtesyPrintersHelp: "These printers will be used for compact courtesy copies of invoices.",
              defaultVatRate: "Default VAT (%)",
              defaultVatRateHelp: "Used when a product category does not have a specific VAT rate.",
              defaultVatRateInvalid: "Enter a VAT rate between 0 and 100.",
              defaultVatRateSaved: "Default VAT rate saved successfully.",
              congressAgendaColors: "Conference agenda colors",
              congressAgendaColorsHelp: "Configure the colors used in the planner for confirmed, Check-in, completed events and expired quotes.",
              none: "None",
              ready: "Ready",
              sectionGeneral: "General",
              sectionBilling: "Billing",
              sectionEasyInvoice: "EasyInvoice",
              tenantTypes: {
                SALE_CONGRESSI: "Conference rooms",
                RISTORANTE: "Restaurant",
                SPA: "Spa",
              },
              billingOwnerData: "Provider Data",
              billingOwnerDataHelp: "Tax data used in documents and integrations.",
              ownerName: "Name/Business Name",
              ownerSurname: "Surname (if individual)",
              ownerTaxCode: "Tax Code",
              ownerVat: "VAT Number",
              ownerAddress: "Address",
              ownerPostalCode: "Postal Code",
              ownerCity: "City",
              ownerProvince: "Province",
              ownerEmail: "Email",
              ownerPhone: "Phone",
              edit: "Edit",
              save: "Save",
              saving: "Saving...",
              cancel: "Cancel",
              saveBillingSuccess: "Billing data saved successfully.",
              easyInvoiceTitle: "Access credentials",
              easyInvoiceHelp: "Credentials used to connect to the EasyInvoice service.",
              saveEasyInvoiceSuccess: "Credentials saved successfully.",
              user: "User",
              password: "Password",
              client_id: "Client ID",
              secret: "Secret",
              validation: {
                ownerNameRequired: "Enter at least a name or business name.",
                provinceTooLong: "Province must be at most 2 characters.",
                emailInvalid: "Invalid email.",
              },
              smtp: {
                title: "SMTP configuration",
                help: "Email server used by this tenant for quotes, summaries and communications.",
                portInvalid: "PORTA_SMTP must be between 1 and 65535.",
                passwordPlaceholder: "Password saved: leave blank to keep it.",
                saveSuccess: "SMTP configuration saved successfully.",
              },
              logo: {
                title: "Logo",
                empty: "No logo uploaded",
                upload: "Upload logo",
                change: "Change logo",
                remove: "Remove",
                alt: "Tenant logo",
                invalidType: "Upload a PNG, JPG, WEBP or SVG logo.",
                tooLarge: "The logo must be under 2 MB.",
                readError: "Could not read the selected file.",
                saveSuccess: "Logo saved successfully.",
              },
              pms: {
                title: "PMS HElite",
                help: "Credentials for connecting to the HElite PMS.",
                urlInvalid: "Invalid HElite URL.",
                passwordPlaceholder: "Password saved: leave blank to keep it.",
                saveSuccess: "PMS configuration saved successfully.",
              },
            },
            departments: {
              title: "Departments",
              subtitle: "Manage operating departments and link the users who need to receive or handle service notes.",
              conferenceOnly: "This registry is available only for conference rooms.",
              newDepartment: "New department",
              editDepartment: "Edit department",
              registryTitle: "Department registry",
              registrySubtitle: "Kitchen, maintenance, reception, audio/video technical team, etc.",
              department: "Department",
              status: "Status",
              users: "Users",
              actions: "Actions",
              noDescription: "No description",
              empty: "No departments configured.",
              usersTitle: "Users and departments",
              usersSubtitle: "Each user can belong to one or more departments.",
              assignedDepartments: "Assigned departments",
              departmentName: "Department name",
              description: "Description",
              departmentActive: "Active department",
              userFallback: "User {{id}}",
              validation: { nameRequired: "Enter the department name." },
              loadError: "Error loading departments.",
              created: "Department created.",
              updated: "Department updated.",
              saveError: "Error saving department.",
              deleteConfirm: "Delete department \"{{name}}\"?",
              deleted: "Department deleted.",
              deleteError: "Error deleting department.",
              userDepartmentsUpdated: "User departments updated.",
              userDepartmentsError: "Error updating user departments.",
            },
            setups: {
              shortLabel: "Setups",
              title: "Room setups",
              subtitle: "Free registry for layouts such as U-shape, stage, theatre or custom setups.",
              conferenceOnlyTitle: "Registry available only for conference rooms",
              conferenceOnlySubtitle: "Restaurants keep using the normal package/menu management, without this setup registry.",
              newSetup: "New setup",
              editSetup: "Edit setup",
              search: "Search setups",
              noPhoto: "No photo",
              photoCount: "Photos: {{count}}",
              empty: "No setups found.",
              setupName: "Setup name",
              description: "Description",
              setupActive: "Active setup",
              uploadImages: "Upload images",
              imageAlt: "Setup",
              validation: { nameRequired: "Enter the setup name." },
              loadError: "Error loading setups",
              uploadError: "Image upload error",
              saved: "Setup saved.",
              saveError: "Error saving setup",
              deleteConfirm: "Delete setup \"{{name}}\"?",
              deleted: "Setup deleted.",
              deleteError: "Error deleting setup",
            },
            usageTypes: {
              title: "Usage types",
              subtitle: "Define custom categories such as meeting, training, assembly, private event.",
              conferenceOnly: "This registry is available only for conference rooms.",
              newType: "New type",
              newUsageType: "New usage type",
              editType: "Edit usage type",
              name: "Name",
              description: "Description",
              typeActive: "Active type",
              noDescription: "No description.",
              empty: "No usage types configured.",
              validation: { nameRequired: "Enter the usage type name." },
              loadError: "Error loading usage types.",
              created: "Usage type created.",
              updated: "Usage type updated.",
              saveError: "Error saving usage type.",
              deleteConfirm: "Delete usage type \"{{name}}\"?",
              deleted: "Usage type deleted.",
              deleteError: "Error deleting usage type.",
            },
            congressReservations: {
              validation: {
                eventNameRequired: "Enter the event/practice name.",
                quoteEmailRequired: "A valid recipient email is required for quotes.",
                sendEmailRequired: "A valid recipient email is required to send the email.",
                dayRequired: "Add at least one day.",
                dayDateTimeRequired: "Complete day dates and times.",
                dayEndAfterStart: "Each day must have an end time after the start time.",
                guestsPositive: "Guests must be greater than zero.",
                roomRequiredForReservation: "Assign at least one room for each day before converting to reservation.",
                departmentRequired: "Select a reference department for each service.",
                serviceTimeOutsideDay: "Service time {{time}} for {{service}} on {{day}} must be between {{start}} and {{end}}.",
              },
              loadError: "Error loading congress data.",
              emailSubject: {
                quote: "Quote - {{name}}",
                confirmed: "Reservation confirmation - {{name}}",
                option: "Reservation option - {{name}}",
                summary: "Event summary - {{name}}",
              },
              rowCategory: {
                serviceDepartment: "Service - {{department}}",
                extraDepartment: "Extra - {{department}}",
                extra: "Extra",
              },
              genericClientNameRequired: "Enter the generic client name first.",
              genericClientCreated: "Client created and linked to the practice.",
              genericClientCreateError: "Error creating client.",
              genericCompanyNameRequired: "Enter the generic company name first.",
              genericCompanyCreated: "Company created and linked to the practice.",
              genericCompanyCreateError: "Error creating company.",
              mailWarning: "Practice saved, but email not sent: {{error}}.",
              sendError: "send error",
              practiceSaved: "Practice saved.",
              practiceSavedWithWarning: "Practice saved. {{warning}}",
              practiceSaveError: "Error saving practice.",
              savingPractice: "Saving practice...",
              cancellationReasonRequired: "Enter the cancellation reason.",
              cancelConfirmWithPrepayments: "This practice still has {{amount}} in outstanding prepayments. Cancel it anyway?",
              cancelPracticeWarningTitle: "Outstanding prepayments",
              confirmActionHelp: "Review the open balance before continuing.",
              reservationConfirmed: "Reservation confirmed.",
              reservationConfirmError: "Reservation confirmation error.",
              restoreCheckIn: "Restore reservation",
              restoreCheckInTitle: "Restore check-in",
              restoreCheckInConfirm: "Restore the check-in for \"{{name}}\" and return it to a confirmed reservation?",
              restoreCheckInHelp: "Use this action only to correct an operator error.",
              restoreCheckInSuccess: "Check-in restored. The event is a confirmed reservation again.",
              restoreCheckInError: "Error while restoring check-in.",
              deleteConfirm: "Delete \"{{name}}\"?",
              deleteConfirmWithPrepayments: "This practice still has {{amount}} in outstanding prepayments. Delete it anyway?",
              deletePracticeTitle: "Delete practice",
              deletePracticeWarningTitle: "Delete practice with prepayments",
              practiceDeleted: "Practice deleted.",
              practiceDeleteError: "Error deleting practice.",
              practiceDeleteBlockedByPrepayments: "This practice cannot be deleted because it has linked prepayment history. Cancel or reverse the financial movements first.",
              practiceDeleteBlockedByAccount: "This practice cannot be deleted because an account has already been issued.",
              plannerStartDate: "Start date",
              serviceQuantityOverageTitle: "Service quantity exceeds guests",
              serviceQuantityOverageConfirm: "Some services exceed the room guest count:\n{{details}}\n\nSave anyway?",
              saveAnyway: "Save anyway",
              assignRoomBeforeCheckout: "Assign a room before going to checkout.",
              compatibilityUpdated: "Compatible setups updated.",
              compatibilityUpdateError: "Error updating compatibility.",
              pdfError: "PDF generation error.",
              summaryEmailSent: "Summary sent by email.",
              summaryEmailError: "Summary email sending error.",
              goToCheckout: "Go to checkout",
              editPractice: "Edit practice",
              newPractice: "New practice",
              freeRecipientVat: "Free recipient VAT number",
              freeRecipientEmail: "Free recipient email",
              optionalClient: "Client (optional)",
              clientVat: "Client VAT number",
              clientEmail: "Client email",
              optionalCompany: "Company (optional)",
              companyVat: "Company VAT number",
              companyEmail: "Company email",
              activeFlag: "Active",
              cancellationReason: "Cancellation reason",
              cancellationReasonHelp: "Required when the practice is cancelled.",
              cancellationReasonPlaceholder: "Write the cancellation reason...",
              emailAddresses: "Email addresses",
              emailAddressesHelp: "You can enter multiple addresses separated by comma, semicolon or newline.",
              none: "None",
              setupNotePlaceholder: "E.g. stage layout, microphones, maintenance...",
              rowNotePlaceholder: "E.g. gluten free, prepare technician, maintenance passage...",
              quoteRow: "Quote row",
              attachment: "Attachment",
              savedAttachment: "{{name}} (saved)",
              emailPreview: "Email preview",
              defaultQuoteEmailMessage: "Thank you for your interest. Below you will find the detailed quote for the requested services. The quote validity date is shown below. We remain available for any clarification or changes.",
              defaultConfirmationEmailMessage: "We confirm the reservation details shown below. We remain available for any requests or changes.",
              send: "send",
              resends: "resends",
              moreThan: "more than",
              prepayments: {
                action: "Prepayments",
                column: "Prepayments",
                title: "Prepayments - {{name}}",
                eventTotal: "Event total",
                totalDeposits: "Deposits",
                totalAdvances: "Fiscal advances",
                totalPrepayments: "Total prepayments",
                amountDue: "Remaining to pay",
                remainingShort: "{{amount}} remaining",
                sessionInfo: "Totals and movements are loaded from the backend prepayment history.",
                loadingSummary: "Loading prepayment history...",
                summaryLoadError: "Could not load prepayment history.",
                receive: "Receive prepayment",
                refund: "Refund",
                deposit: "Deposit",
                fiscalAdvance: "Fiscal advance",
                defaultDescription: "Prepayment {{name}}",
                amount: "Amount",
                refundAmount: "Refund amount",
                paymentMethod: "Payment method",
                vatRate: "VAT rate",
                vatNature: "VAT nature",
                document: "Document",
                refundDocument: "Refund document",
                invoiceId: "Invoice ID",
                creditNoteId: "Credit note ID",
                documentNumber: "Document number",
                documentDate: "Document date",
                description: "Description",
                notes: "Notes",
                noRefundable: "No refundable movement is available in this session. The backend must return prepayment history to refund after a refresh.",
                sourceMovement: "Movement to refund",
                originalDocument: "Original document: {{documentType}} {{documentNumber}}",
                movementOption: "#{{id}} - {{type}} - {{amount}} - {{documentType}}",
                movementOptionAvailable: "#{{id}} - {{type}} - original {{amount}} - available {{available}} - {{documentType}}",
                register: "Register",
                saving: "Saving...",
                receivedSuccess: "Prepayment registered.",
                refundSuccess: "Refund registered.",
                reverseSuccess: "Prepayment reversed.",
                fullReversalInfo: "This fiscal advance will be reversed in full: {{amount}}.",
                invoiceDelivery: {
                  SENT: "Invoice #{{invoiceId}} saved and sent.",
                  FAILED: "Movement and invoice #{{invoiceId}} were saved, but sending failed. Retry from issued documents. {{message}}",
                  SKIPPED: "Movement saved. Invoice #{{invoiceId}} was already sent or is processing.",
                },
                paymentMethods: {
                  cash: "Cash",
                  card: "Card",
                  bankTransfer: "Bank transfer",
                  voucher: "Voucher",
                  roomCharge: "Room charge",
                },
                documentTypes: {
                  commercialDocument: "Commercial document",
                  invoiceTd02: "TD02 advance invoice",
                  plainReceiptRefund: "Refund receipt",
                  commercialCancellation: "Commercial cancellation",
                  commercialReturn: "Commercial return",
                  creditNoteTd04: "TD04 credit note",
                },
                vatNatureOptions: {
                  N1: "N1",
                  N2: "N2",
                  N3: "N3",
                  N4: "N4",
                  N5: "N5",
                  N6: "N6",
                  N7: "N7",
                },
                validation: {
                  validAmountRequired: "Enter a valid amount.",
                  sourceRequired: "Select the movement to refund.",
                  td04IdRequired: "Enter the TD04 credit note ID.",
                  refundDocumentRequired: "Complete refund document number and date.",
                  vatRateRequired: "Enter a valid VAT rate.",
                  descriptionRequired: "Enter the advance description.",
                  td02IdRequired: "Enter the TD02 invoice ID.",
                  vatNatureRequired: "Select VAT nature for a zero-VAT TD02 invoice.",
                  commercialDocumentRequired: "Complete commercial document number and date.",
                },
                errors: {
                  exceedsTotal: "Prepayments exceed the practice total. Total: {{practiceTotal}}, already registered: {{currentPrepayments}}, requested: {{requestedAmount}}.",
                  refundExceeds: "The refund exceeds the available amount. Available: {{refundableAmount}}, requested: {{requestedAmount}}.",
                  idempotencyKeyReused: "This request key was already used with different data. Try the operation again.",
                  invalidReversalDocument: "This advance requires {{documentType}}.",
                  td02NotSent: "The TD02 invoice must be sent successfully before it can be reversed with TD04.",
                  generic: "Error registering prepayment.",
                },
              },
            },
            orderSummary: "Order Summary",
            noProductPresent: "No product present in this Order",
            perPerson: "per person",
            description: "Description",
            visible: "Visible",
            wait: "Wait time",
            guests: "Guests",
            noOrders: "No Active Orders",
            realTimeOrders: "Real-Time Orders",
            newOrder: "New Order",
            closeBill: "Close Bill",
            togglePasswordVisibility: "Toggle password visibility",
            addTable: "Add Table",
            noTable: "No Tables Available",
            No_table_selected: "No table selected",
            menu: "Menu",
            yes: "Yes",
            noEventsInRange: 'There are no events in this range.',
            no: "No",
            support: "Help",
            dailySales: "Daily Sales (last days)",
            total: "Total",
            occupiedTables: "Occupied Tables",
            noTableOccupied: "No Occupied Table",
            confirmReservationClient: "Confirm that this is the reservation client?",
            syncRequests: "Sync {{count}} requests",
            confirmSeats: "Confirm the number of seats",
            addTableQuestion: "Add table?",
            activeOrders: "Active Orders",
            avgTime: "Average Time",
            revenueToday: "Today's Revenue",
            split: "Split Order",
            mostSold: "Best-Selling Products",
            sold: "Sold",
            checkoutPage: "Checkout",
            singleCreate: "Single Create",
            bulkCreate: "Bulk Create",
            tableMapPage: {
              columnNames: {
                name: "NAME",
                seats: "SEATS",
                status: "STATUS"
              },
              print: "Print",
              reprintOrders: "Reprint Orders",
              transferOrders: "Transfer Orders",
              transferFrom: "Transfer from:",
              transferTo: "Transfer to:",
              transferButton: "Transfer",
              noTableInWaiting: "No Table In Stand-By",
              noTableOccupied: "No Occupied Table",
              draftPayment: "Draft Payment",
              roomChargeCheckout: "Room charge",
              CRMclients: "CRM Clients",
              seeOrders: "See Orders",
              minute: "Minute",
              minutes: "Minutes",
              course: "Course",
              details: "Details",
              close: "Close",
              open: "Open",
              sendToCheckout: "Send to Checkout",
              error_move_product_1: "Error moving product:",
              error_delete_order_1: "Error removing order:",
              error_patch_order_1: "Error patching order:",
        success_savedCoordinates: "Coordinates saved to DB!",
              error_coordinates_table_1: "Error retrieving coordinates:",
              error_coordinates_table_2: "Error saving coordinates:",
              error_categories_1: "Error retrieving categories:",
              error_transfer_order_1: "Error while transferring order",
              unknown_error: "Unknown Error",
              error_print_1: "Error while printing order",
            },
            sortName: "Sort by Name",
            sortPrice: "Sort by Price",
            showDetails: "View",
            blankname: 'Name can not be blank',
            editLayout: "Edit Layout",
            editLayoutTitle: "Edit Table Layout",
            cancel: "Cancel",
            clearAllTablesAndPay: "[DEV] CLEAR TABLES AND PAY ORDERS",
            courseAddedSuccess: "Course added successfully!",
            invalidRoleSelected: "Invalid role selected",
            save: "Save",
            confirm: "Confirm",
            select: "Select",
            work_selection: "Select Today's Working Area",
            operator: "Operator",
            freetables: "Free Table",
            activetables: "Active Table",
            selectTable: "Select Table",
            noTableSelected: "No Data Available. Select a Table.",
            formats: "Supported Formats",
            generalstatus: "Service's General Status",
            active: "Active",
            products: 'Products',
            orders: 'Orders',
            select_orders: 'Select Orders',
            selected_articles: 'Selected Articles',
            variants: 'Variants',
            reservations: 'Reservations',
            reservation: 'Reservation',
            selectedOrders_alert: {
              successAddProduct: "Course added successfully!",
              orderSaved: "Order received and saved successfully!",
              errExceedSeatingCapacity: "Number of seats selected exceeds the maximum limit allowed by the table",
            },
            handleCategory_alert: {
              errorAddCategory: "Error adding Category:",
              errorAddSubCategory: "Error adding Subcategory:",
              errorRecoveryCat: "Error recovering Category/Subcategory",
              errorUpdateCat: "Error updating Category",
              errorUpdateSubCat: "Error updating Subcategory",
              errorDeleteCat: "Error deleting Category",
              errorDeleteSubCat: "Error deleting Subcategory",
            },
            orderDetails_alert: {
              errorMoveProduct: "Error moving product:",
              errorDeleteOrder: "Error deleting order:",
              errorPatchOrder: "Error patching order:",
            },
      productList_alert:{
        success_dateslot: "Time slot updated for product ID:",
        error_dateslot: "Time slot update error:",
        success_duplicate: "Product duplicated successfully",
        error_duplicate: "Error duplicating product:",
      },
      menu_alert:{
        error_sorting:"Error sorting products:",
      },
      modals_alert:{
        error_sending:"Error sending order:",
        error_getTable:"Error getting table:",
        error_createTable:"Error creating table:",
        error_editTable:"Error editing table:",
        error_deleteTable:"Error deleting table:",
        error_createRoom:"Error creating room:",
        error_deleteRoom:"Error deleting room:",
      },
      user_alert:{
        error_registration: "Error while registering:",
        error_updateUser: "User Update Error:",
      },
            confirmClientQuestion: "Confirm that this is the reservation client?",
            booking: {
              name: "Client name",
              guests: "Guests number",
              calendar_help: "Select a slot on the calendar or adjust the time manually below",
              today: "Today",
              back: "Back",
              next: "Next",
              week: "Week",
              day: "Day",
              event: "Event",
              allDay: 'All Day',
              work_week: 'Work Week',
              month: 'Month',
              tomorrow: 'Tomorrow',
              yesterday: 'Yesterday',
              agenda: 'Agenda',
              date: "Date",
              time: "Time",
              room: "Room",
              table: "Table",
              notes: "Note",
              submit: "Submit",
              error: "Reservation error:",
              room_error: "Error recovering rooms:",
        packagesLabel: "Packages (optional)",
        packagesSelect: "Select packages",
        packagesBookedNoteTitle: "Booked packages",
        packageFallbackName: "Package",
      },
      orderPackages: {
        label: "Package",
        tastingMenu: "Tasting menu",
        select: "Select package",
        add: "Add package",
        invalidSelection: "No valid package selected",
        addedSuccess: "Package added to order",
            },
            list_reservation: "Reservations list",
            reservations_details: {
              title: "Reservations",
              client: "Client",
              table: "Table",
              room: "Room",
              date: "Reservation Date",
              status: "Status",
              change_status: "Change status",
              status_update_error: "Failed to update status",
              status_values: {
                TO_CONFIRM: "To confirm",
                CONFIRMED: "Confirmed",
                COMPLETED: "Completed",
                CANCELLED: "Cancelled",
                NO_SHOW: "No-show",
              },
              cancellation_reason: "Cancellation reason",
              cancellation_reason_placeholder: "Write why this reservation was cancelled",
              provide_cancellation_reason: "Please provide a cancellation reason",
              add_cancellation_reason: "To set status as cancelled, enter a reason.",
              createdAt: "Created at",
              clientDetails: "Client Details",
              edit_pending_hint: "This reservation is pending confirmation. You can edit date, time, guests, table and notes.",
              edit_booking: "Edit reservation",
              save_booking: "Save reservation changes",
              save_booking_error: "Failed to update reservation",
              error: "Error",
              none: "No Reservation found",
              noClient: "No Client",
              noOrder: "No Order"
            },
            clearModal: {
              dialogTitle: "Confirm table clearance",
              dialogAlert: "Are you sure you want to clear table",
            },
            chart: {
              title: "Order Distribution",
              noData: "No orders found for the selected room",
              loading: "Loading data...",
            },
            selectRoom: "Select room",
            hello: "Hello",
            selected: "Selected",
            quantity: "Quantity",
            no_room: 'No room available',
            add_product: 'Add Product',
            new_product: 'New Product',
            delete_product: "Delete product",
            edit_product: 'Edit Product',
            delete_button: 'Delete',
            allTablesAlreadyFree: "All tables are already free and/or all orders have already been paid!",
            allTablesCleared: "All tables have been cleared and/or all orders have been paid!",
            tables: 'Table map',
            new_room_name: 'New Room Name',
            new_table: 'New Table',
            add_table: 'Add Table',
            edit_table: 'Edit Table',
            table_name: 'Table Name',
            table_name_prefix: 'Table Name Prefix',
            table_name_suffix: 'Table Name Suffix',
            table_quantity: 'Table Quantity',
            selected_table: 'Selected Table',
            deleteTableRequestTitle: "Confirm Delete Table",
            deleteTableRequest: "Are you sure you want to delete this table? The action cannot be undone.",
            deleteRoomRequestTitle: "Confirm Delete Room",
            deleteRoomRequest: "Warning! By deleting the selected room you will also delete all associated tables. Do you want to proceed?",
            addRoom: 'Add Room',
            editRoom: 'Edit Room',
            deleteRoom: 'Delete Room',
            roomName: "Room Name",
            seatNumber: "Nr of Seats",
            seats: "seat(s)",
            occupiedSeats: "Occupied Seats",
            add_button: 'Add',
            update_button: "Update",
            cancel_button: 'Cancel',
            changeTo_it: 'Switch to IT',
            changeTo_en: 'Switch to ENG',
            changeTo_sq: 'Switch to SQ',
            dashboard: 'Dashboard',
            welcome_message: 'Welcome to the home page',
            email: 'Email',
            password: "Password",
            product: "Product",
            product_name: 'Name',
            price: 'Price',
            category: 'Category',
            subcategory: 'Subcategory',
            cover_room: 'Associated room',
            cover_room_default: 'All rooms (default)',
            product_room: 'Associated room',
            product_room_all: 'All rooms',
            product_printer_targets: 'Product printers',
            bulkPrinters: {
              selectVisible: 'Select visible',
              deselectVisible: 'Deselect visible',
              selectedCount: '{{count}} selected',
              assignPrinters: 'Assign printers',
              title: 'Assign department printers',
              productsSelected: '{{count}} products selected',
              noPrintersConfigured: 'No printers configured. Configure department printers first.',
              printers: 'Printers',
              saving: 'Saving...',
              assign: 'Assign',
              selectProductFirst: 'Select at least one product.',
              selectPrinterFirst: 'Select at least one printer.',
              updatedSuccess: 'Printers updated on {{count}} products.',
              assignError: 'Error assigning printers.',
            },
            bulkDelete: {
              selectVisible: 'Select visible',
              deselectVisible: 'Deselect visible',
              selectedCount: '{{count}} selected',
              deleteSelected: 'Delete selected',
              productsTitle: 'Delete products',
              productsConfirm: 'Permanently delete the {{count}} selected products?',
              categoriesTitle: 'Delete categories',
              categoriesConfirm: 'Permanently delete the {{count}} selected categories?',
              confirm: 'Delete',
              deleting: 'Deleting...',
              productsDeleted: '{{count}} products deleted.',
              categoriesDeleted: '{{count}} categories deleted.',
              deleteProductsError: 'Error deleting products.',
              deleteCategoriesError: 'Error deleting categories.',
            },
            NoCategory: "No Category",
            waiter: 'Waiter',
            time: 'Time',
            no_products: 'No products found',
            addImage: "Add Image",
            changeImage: "Change Image",
            fromTime: 'From',
            toTime: 'To',
            Standard: "Standard View",
            Detailed: "Detailed View",
            stats: { page: "Statistics" },
            allRoom: "All Rooms",
            selectDate: "Select Date and Time From Calendar",
            user_management: {
              page: "Users",
              title: "User Management",
              add_edit_title: "Add / Edit User",
              name: "Name",
              surname: "Surname",
              email: "Email",
              role: "Role",
              password: "Password",
              new_password: "New Password",
              cancel_button: "Cancel",
              active: "Active",
              inactive: "Inactive",
              add_button: "Add",
              update_button: "Update",
              user_list: "User List",
              noUserAvailable: "No User Available",
            },
            manage_categories: {
              page: "Categories",
              title: "Menu Configuration - Categories and Subcategories",
              category_name: "Category Name",
              new_category: "New Category",
              add_category: "Add Category",
              add_subcategory: "Add Subcategory",
              add_button: "Add",
              vat_rate: "VAT (%)",
              vat_short: "VAT",
              vat_default: "Default VAT",
              vat_default_help: "Leave empty to use the tenant default VAT.",
              vat_invalid: "Enter a VAT rate between 0 and 100.",
              order_help: "Drag categories or use the arrows to choose the order shown in order entry.",
              drag: "Drag to move",
              move_up: "Move up",
              move_down: "Move down",
              order_error: "Unable to save category order: ",
            },
            checkout_page: {
              delete: "delete",
              invoice: "Invoice",
              surcharge: "Surcharge",
              edit_price: "Edit Price",
              clear_percent: "Clear %",
              remove_discount: "Remove Discount",
              move_to_pending: "Move To Pending",
              edit_qty: "Edit Quantity",
              split: "Split",
              print: "Print",
              subtotal: "SubTotal",
              closeCheckout: "Close Checkout",
              partialPayment: "Partial Payment",
              totalPayment: "Total Payment",
              printInvoice: "Create invoice",
              invoiceCloseConfirmTitle: "Invoice created",
              invoiceCloseConfirmNote: "Close the checkout without payment, or exit and keep the order open for payment.",
              closeCheckoutWithoutPayment: "Close checkout",
              exitInvoiceCloseConfirm: "Exit",
              invoiceCheckoutClosed: "Checkout closed without payment.",
              toPay: "To Pay",
              searchProduct: "Search Product",
              noRegisteredOrders: "No Registered Orders",
              NoCategory: "No Category found",
              totalPaid: "Total Paid",
              confirmedPayment: "Confirmed Payment!",
              confirmedPayment_note: "The payment was successful.",
              referenceNumber: "Reference Number",
              paymentDate: "Payment Date",
              paymentMethod: "Payment Method",
              send: "Send",
              pending: "Pending",
              occupied: "Occupied",
              toCheckout: "To Checkout",
              editPrice_note_1: "No products selected for price modification",
              editPrice_note_2: "Select products to edit, or leave unselected to apply to all",
              splitWeightProductWarning: "You cannot split products sold by weight",
              editQty_note_1: "No products selected for quantity modification",
              editQty_note_2: "Select one product at a time to change the quantity",
              delete_title: "Confirm Delete Order(s)",
              delete_note_1: "No products selected for delete",
              delete_note_2: "Proceed to delete? The order can't be restored",
              delete_note_3: "Error while removing",
              delete_note_4: "Error while removing order",
              delete_note_5: "Error while removing order (split)",
              delete_note_6: "Error while removing order (joined)",
              fetch_note_1: "Error fetching reservations",
              selectPaymentMethode: "Select Payment Methode",
              cash:"Cash",
              cards:"Cards",
              other:"Other",
              newCounterSale: "New counter sale",
              counterSale: "Counter sale",
              noBookedClient: "No booked client",
              notBookedClient: "Not this booked client",
              multipleCheckout: "Multiple checkout",
              multipleCheckoutHelp: "Select the tables to merge into one bill. Every open order for each table will be included.",
              multipleCheckoutActiveWarning: "Multiple checkout in progress: select a table to add items",
              multipleCheckoutMinOrders: "Select at least two orders to merge",
              invalidCheckoutTotal: "Invalid checkout total",
              multipleCheckoutOrderCount: "Multiple checkout ({{count}} orders)",
              orderColumn: "Order",
              itemsColumn: "Items",
              amount: "Amount",
              given: "Given",
              rowChange: "Row change",
              addPaymentMethod: "+ Method",
              romanSplit: "Split equally",
              romanSplitParts: "Number of parts",
              remaining: "Remaining",
              totalChange: "Total change",
              confirmPayment: "Confirm payment",
              cashGiven: "Cash given",
              change: "Change",
              prepaymentsLoading: "Loading available prepayments...",
              prepaymentsApplied: "Prepayments applied",
              amountDueAfterPrepayments: "Amount due after prepayments",
              prepaymentsWillApply: "{{amount}} will be applied before checkout.",
              noAvailablePrepayments: "No available prepayment for this checkout.",
              zeroBalanceCovered: "The final balance is already covered. No extra payment is needed.",
              prepaymentsCovered: "Covered by prepayments",
              prepaymentApplyNote: "Applied during final checkout",
              prepaymentsLoadError: "Unable to load prepayments for this event.",
              prepaymentApplyError: "Unable to apply prepayments to the final checkout.",
              prepaymentCommercialVatBlocked: "The advance exceeds the final commercial document total for the same VAT rate.",
              prepaymentExceedsOrder: "The selected prepayments exceed the order total.",
              prepaymentOrderNotApplicable: "Prepayments cannot be applied because the order is already closed.",
              prepaymentSourceMissing: "One or more selected prepayments are no longer available.",
              prepaymentSourceInvalid: "Only received prepayments can be applied at checkout.",
              prepaymentAdvanceAlreadyApplied: "This fiscal advance has already been applied.",
              prepaymentApplicationExceedsAvailable: "The selected amount exceeds the available prepayment balance.",
              prepaymentAdvanceMustApplyInFull: "Fiscal advances must be applied in full.",
              prepaymentInvalidFinalInvoice: "An advance invoice or credit note cannot be used as the final invoice.",
              prepaymentFinalInvoiceAlreadySent: "Prepayments cannot modify an invoice that was already sent.",
              prepaymentInvoiceNotFound: "Final invoice not found.",
              prepaymentInvoiceVatBlocked: "The advance exceeds the final invoice total for the same VAT rate.",
              prepaymentInvoiceVatWarning: "An advance exceeds the matching VAT group on the final invoice. Continue anyway?",
              invoicePrepaymentsWillApply: "{{amount}} in prepayments will be applied to the final invoice before checkout closes.",
              prepaymentPos: {
                deposits: "Deposits",
                advances: "Advances",
                depositProducts: "Deposit services",
                advanceProducts: "Advance services",
                subtitle: "Dedicated prepayment room for this practice.",
                receive: "Receive",
                refund: "Refund",
                reverse: "Reverse",
                totalDeposits: "Total deposits",
                totalAdvances: "Total advances",
                paymentMethod: "Payment method",
                vatRate: "VAT rate",
                vatNature: "VAT nature",
                documentType: "Document type",
                sourceMovement: "Original movement",
                invoiceId: "Invoice ID",
                documentNumber: "Document number",
                documentDate: "Document date",
                description: "Description",
                note: "Note",
                noEvent: "Select a Sale Congressi practice before opening Deposits or Advances.",
                noProducts: "No deposit/advance services found. Check product/category names.",
                saved: "Prepayment movement saved.",
                fiscalPending: "Automatic fiscal document printing is still pending; enter the document references manually after printing.",
                invoiceDelivery: {
                  SENT: "Invoice #{{invoiceId}} saved and sent.",
                  FAILED: "Movement and invoice #{{invoiceId}} were saved, but sending failed. Retry from issued documents. {{message}}",
                  SKIPPED: "Movement saved. Invoice #{{invoiceId}} was already sent or is processing.",
                },
                paymentMethods: {
                  CASH: "Cash",
                  CARD: "Card",
                  BANK_TRANSFER: "Bank transfer",
                  VOUCHER: "Voucher",
                  ROOM_CHARGE: "Room charge",
                },
                documentTypes: {
                  COMMERCIAL_DOCUMENT: "Commercial advance document",
                  INVOICE_TD02: "TD02 advance invoice",
                  COMMERCIAL_CANCELLATION: "Commercial cancellation",
                  COMMERCIAL_RETURN: "Commercial return",
                  CREDIT_NOTE_TD04: "TD04 credit note",
                },
                vatNatureOptions: {
                  N1: "N1",
                  N2: "N2",
                  N3: "N3",
                  N4: "N4",
                  N5: "N5",
                  N6: "N6",
                  N7: "N7",
                },
                errors: {
                  amountRequired: "Enter an amount.",
                  sourceRequired: "Select the original movement.",
                  documentRequired: "Enter document number and date.",
                  invoiceRequired: "Enter the invoice ID.",
                  vatNatureRequired: "Select VAT nature for a zero-VAT TD02 invoice.",
                  vatRequired: "Enter the VAT rate.",
                  descriptionRequired: "Enter the advance description.",
                  exceedsTotal: "Prepayments exceed the practice total.",
                  refundExceeds: "The refund exceeds the available amount.",
                  advanceProcessed: "This advance already has a refund or reversal movement.",
                  td02NotSent: "The TD02 invoice must be sent successfully before it can be reversed with TD04.",
                  generic: "Error saving prepayment movement.",
                },
              },
              warning: "Warning",
              incompleteBillingWarning: "The provider billing information is incomplete. Please fix it in the Billing section of System Settings before creating an invoice.",
            },
            menu_config: {
              page: "Menu",
              categories: "Categories",
              category_name: "Category Name",
              select_category: "Select a category",
              product_ordering: "Product Ordering",
              lunch: "Lunch",
              dinner: "Dinner",
              noProductsMenuFound: "No products found. Please check time availability of products.",
              save_order: "Save order",
            },
            quickActions: {
              quickActions: "Quick Actions",
              closeOrder: "Close Order",
              cashRegister: "Checkout",
              directAccess: "Direct Access",
            },
            modalVariant: {
              title: "Product Variants",
              addVariant: "Add Variant",
              editVariant: "Edit Variant",
              deleteVariant: "Delete Variant",
              variantName: "Variant Name",
              variantPrice: "Price",
              variantDesc: "Note",
              delete_note: "Confirm deletion of variant?",
            },
            variantManagement: {
              title: "Generic variants",
              subtitle: "Create a variant and link it to products.",
              addVariant: "Add variant",
              noVariants: "No variants configured",
              priceLabel: "Price: {{price}} EUR",
              linkedProductsCount: "{{count}} products linked",
              linkProducts: "Link products",
              editVariant: "Edit variant",
              newVariant: "New variant",
              variantName: "Variant name",
              notes: "Notes",
              linkedProducts: "Linked products",
              searchProduct: "Search product",
              close: "Close",
              deleteVariant: "Delete variant",
              deleteConfirm: "Delete \"{{name}}\"? Linked products will be removed too.",
              linkedToProduct: "Linked to this product",
              notLinkedToProduct: "Not linked to this product",
              linkProductsTitle: "Link products - {{name}}",
            },
            error_password_length: 'Password must be at least 8 characters.',
            error_password_upper: 'Password must include at least one uppercase letter.',
            error_password_lower: 'Password must include at least one lowercase letter.',
            error_password_number: 'Password must include at least one number.',
            error_password_special: 'Password must include at least one special character.',
            error_username_required: 'Username required',
            error_password_required: 'Password required',
            error_password_incorrect: 'Incorrect password',
            error_products_load: 'Error loading products',
            error_number_of_seats: "Number of Seats Can Not Be 0 or Lower",
            Logout: 'Logout',
            LIBERO: "Unoccupied",
            IN_ATTESA: "On Stand-By",
            OCCUPATO: "Occupied",
            RISERVATO: "Reserved",
            NON_DISPONIBILE: "Unavailable",
            common: {
              actions: {
                create: "Create",
                delete: "Delete",
                cancel: "Cancel",
                save: "Save",
                edit: "Edit",
                refresh: "Refresh",
                retry: "Retry",
                clearFilter: "Clear filter",
              },
              status: { active: "active", inactive: "inactive" },
              pagination: {
                rowsPerPage: "Rows per page:",
                displayedRows: "{{from}}-{{to}} of {{count}}"
              },
              errors: { loading: "Loading error", updateFailed: "Update failed" },
              loading: "Loading...",
              changeLanguage: "Change language",
              noResults: "No results",
            },
            admin: {
              smtp: {
                title: "SMTP defaults",
                help: "These values are copied into new tenants when the backend creates them. Tenants can change their own settings later.",
              },
              tenants: {
                title: "Tenant Management",
                actions: { newTenant: "New tenant" },
                search: { placeholder: "Search tenants..." },
          miss: "TenantType missing or invalid:",
                empty: {
                  noneTitle: "No tenants yet",
                  noneSubtitle: "Create your first tenant to get started.",
                  noResultsTitle: "No results",
                  noResultsSubtitle: "No tenants match current filters."
                },
                table: { tenantId: "Tenant ID", id: "Id", tenantType: "Tenant Type", status: "Status", createdAt: "Created", actions: "Actions" },
                switchAria: "Set tenant {{id}} {{state}}",
                dialogs: {
                  create: { title: "Create new tenant", label: "Tenant ID" },
                  edit: { title: "Edit tenant" },
                  delete: {
                    title: "Confirm tenant deletion",
                    subtitle: "To delete tenant \"{{id}}\" please enter your password.",
                    passwordLabel: "Administrator password"
                  }
                },
                confirm: { delete: "Permanently delete tenant {{id}}? Its DB will be removed as well." },
                notifications: {
                  created: "Tenant created",
                  deleted: "Tenant deleted",
                  activated: "Tenant {{id}} activated",
                  deactivated: "Tenant {{id}} deactivated"
                }
              },
              users: {
                title: "User Management",
                tabs: { superadmin: "Superadmin", adminByTenant: "Admins by tenant" },
                search: { superadmin: "Search superadmins...", admin: "Search admins..." },
                buttons: {
                  newSuperadmin: "New Superadmin",
                  createSuperadmin: "Create Superadmin",
                  newAdmin: "New Admin",
                  createAdmin: "Create Admin"
                },
                empty: {
                  noSuperadminTitle: "No superadmins",
                  noSuperadminSubtitle: "Create the first superadmin to access global management.",
                  noAdminTitle: "No admins",
                  noAdminSubtitle: "This tenant has no administrators yet.",
                  noResultsTitle: "No results",
                  noResultsSubtitleSuperadmin: "No superadmins match current filters.",
                  noResultsSubtitleAdmin: "No admins match current filters."
                },
                table: { name: "Name", surname: "Surname", email: "Email", actions: "Actions" },
                dialogs: {
                  createUser: {
                    titleSuperadmin: "Create Superadmin",
                    titleAdmin: "Create Tenant Admin",
                    fields: { name: "Name", surname: "Surname", email: "Email", password: "Password", tenant: "Tenant" }
                  }
                },
                confirm: { deleteUser: "Delete {{email}}?" },
                notifications: {
                  superadminCreated: "Superadmin created",
                  superadminDeleted: "Superadmin deleted",
                  adminCreated: "Admin created",
                  adminDeleted: "Admin deleted"
                },
              },
            },
      allestimenti: {
        pageTitle: "Package management",
        pageSubtitle: "Create packages for bookings and direct sales. Conference halls can add them in reservations, while restaurants can add fixed menus directly to tables.",
        pageTitleShort: "Packages",
        summaryTotalPackages: "Total packages",
        summaryActivePackages: "Active packages",
        summaryInactivePackages: "Inactive packages",
        searchPlaceholder: "Search packages or services...",
        newPackage: "New package",
        productsAvailable: "Available services",
        noProductsAvailable: "No services available",
        noProductsAvailableHint: "Create services from the products page to use them here.",
        packageStatusInactive: "Inactive",
        packageStatusActiveNow: "Active now",
        packageStatusOutOfTime: "Outside time range",
        packagePrice: "Price",
        packageCapacity: "Capacity",
        packageCapacityPeople: "participants",
        packageTimeRange: "Active time range",
        includedProducts: "Included services",
        packageContent: "Package content",
        noPackagesFound: "No package found",
        noPackagesHint: "Create a package with available services.",
        editPackage: "Edit package",
        newPackageModal: "New package",
        packageName: "Package name",
        packageType: "Type",
        packageTypeStandard: "Package",
        packageTypeTastingMenu: "Tasting menu",
        courseIndex: "Course",
        courseName: "Course name",
        currentCourse: "Current course",
        courseNameOptional: "Course name (optional)",
        nextCourse: "Next course",
        courseFlowHint: "Add the products for this course, then continue to the next one.",
        capacity: "Capacity",
        manualPriceOptional: "Manual price (optional)",
        packageActive: "Package active",
        activeFrom: "Active from",
        activeTo: "Active until",
        description: "Description",
        selectIncludedProducts: "Select included services",
        remove: "Remove",
        add: "Add",
        quantityShort: "Qty",
        uploadImages: "Upload images",
        uploadingImages: "Uploading images...",
        imageFormats: "JPG, PNG, WEBP",
        selectionSummary: "Selection summary",
        selectedProducts: "Selected services",
        productsTotal: "Services total",
        finalPackagePrice: "Final package price",
        cancel: "Cancel",
        saveChanges: "Save changes",
        createPackage: "Create package",
        deletePackageTitle: "Delete package",
        deletePackageConfirm: "Are you sure you want to delete this package?",
        delete: "Delete",
      },
            billing: {
              page: "Billing",
              subtitle: "Manage invoices, commercial documents and draft bills",
              actions: {
                newDocument: "New document",
                export: "Export",
                exportSelected: "Export ({{count}})",
                exporting: "Exporting...",
                view: "View",
                duplicate: "Duplicate",
                print: "Print",
                download: "Download",
                sendSelectedInvoices: "Send selected ({{count}})",
                sendingInvoices: "Sending...",
                sendInvoice: "Send invoice",
                cancelInvoice: "Cancel invoice",
                printCourtesyCopy: "Print courtesy copy",
              },
              export: {
                selectAtLeastOne: "Select at least one invoice to export",
                success: "{{count}} invoices exported",
                partialError: "{{success}} invoices exported, {{failed}} could not be exported",
              },
              summary: {
                totalDocuments: "Total documents",
                totalDocumentsSubtitle: "All issued and draft documents",
                invoices: "Invoices",
                invoicesSubtitle: "Tax invoices",
                commercialDocuments: "Commercial documents",
                commercialDocumentsSubtitle: "Receipts and similar documents",
                totalAmount: "Total amount",
                totalAmountSubtitle: "Sum of visible totals",
                title: "Invoice created successfully",
                subtitle: "Invoice created successfully. It is now available to view.",
                fileName: "File name",
                name: "Denomination",
                date: "Due date",
              },
              filters: {
                searchPlaceholder: "Search by number, customer, VAT/fiscal code, reference, location, operator",
                documentType: "Document type",
                status: "Status",
                from: "From",
                to: "To",
                reset: "Reset",
              },
              table: {
                recordsFound: "records found",
                columns: {
                  isSent: "Sent",
                  isSent_notes: "Message",
                  documentType: "Document Type",
                  number: "Number",
                  date: "Date",
                  customer: "Customer",
                  vatOrFiscalCode: "VAT/Fiscal Code",
                  taxableAmount: "Taxable Amount",
                  vat: "VAT",
                  total: "Total",
                  paymentMethod: "Payment Method",
                  status: "Status",
            incassoStatus: "Collection status",
            paymentDate: "Collection date",
                  reference: "Reference",
                  locationTable: "Room",
                  operator: "Operator",
                  actions: "Actions",
                },
              },
        incassoOptions: {
          collected: "Collected",
          notCollected: "Not collected",
          postponed: "Not collected with postponed collection",
        },
              empty: {
                title: "No documents found",
                subtitle: "Try changing the filters or create a new document.",
              },
              documentTypes: {
                all: "All",
                invoice: "Invoice",
                commercialDocument: "Commercial Document",
                draftBill: "Draft Bill",
                creditNote: "Credit Note",
              },
              status: {
                all: "All",
                draft: "Draft",
                issued: "Issued",
                paid: "Paid",
                cancelled: "Cancelled",
                reversed: "Reversed",
                sending: "Sending",
                sent: "Sent",
                error: "Error",
                cancelling: "Cancelling",
              },
              creditNote: {
                originalInvoice: "Reverses invoice {{id}}",
                creditNote: "Credit note {{number}}",
              },
              batchResults: {
                title: "Invoice sending result",
                invoice: "Invoice #{{id}}",
                generic: "Send",
              },
              cancelDialog: {
                title: "Cancel invoice",
                draftMessage: "This draft will be deleted.",
                sentMessage: "This invoice was already sent. A draft credit note will be created.",
                confirm: "Confirm",
                cancelling: "Cancelling...",
              },
              errors: {
                fetchClients: "Error fetching clients",
                missingAuth: "Authentication token not found",
              },
              createDialog: {
                title: "Create invoice",
                fields: {
                  sdiCode: "SdI code",
                  subjectType: "Subject Type",
                  invoiceLineDiscountSurcharge: "Discount/Surcharge",
                  subjectTypeOptions: {
                    private: "Private",
                    company: "Company",
                  },
                  client: "Client",
                  customerName: "Customer name",
                  emailPec: "Email / PEC",
                  customerId: "Customer ID",
                  companyId: "Company ID",
                  documentType: "Document type",
                  customerAddress: "Customer address",
                  streetNumber: "Street number",
                  zip: "ZIP",
                  city: "City",
                  province: "Province",
                  taxCode: "Tax code",
                  vatNumber: "VAT number",
                  reaOffice: "REA office",
                  reaNumber: "REA number",
                  taxableAmount: "Taxable amount",
                  vatPercent: "VAT %",
                  vatAmount: "VAT amount",
                  total: "Total",
                  paymentConditions: "Payment conditions",
                  paymentMethod: "Payment method",
                  dueDate: "Due date",
                  paymentAmount: "Payment amount",
                  reason: "Reason",
                  invoiceLines: "Invoice lines",
                  invoiceLineDescription: "Description",
                  invoiceLineQuantity: "Quantity",
                  invoiceLineUnitPrice: "Unit price",
                },
                actions: {
                  cancel: "Cancel",
                  save: "Save invoice",
                  saving: "Saving...",
                  addInvoiceLine: "Add line",
                  removeLine: "Remove",
                },
              },
            },
            month: {
              jan: "Jan", feb: "Feb", mar: "Mar", apr: "Apr",
              may: "May", jun: "Jun", jul: "Jul", aug: "Aug",
              sep: "Sep", oct: "Oct", nov: "Nov", dec: "Dec",
              error: "Error finding month",
            },
            price_per_weight: "Price per weight",
            weight_unit: "Weight unit",
          },
        },

        // ─────────────────────────────────────────────
        //  ITALIAN
        // ─────────────────────────────────────────────
        it: {
          translation: {
            login: 'Accedi',
            home: 'Home',
            optional: '(Opzionale)',
            emailattiva: "Email destinatario preventivo",
            all: "Tutti",
            show: "Vedi",
            giornateesala: "Giornate e sale",
            Messaggioemail: "Messaggio email",
            prezzo: "Prezzo",
            orarioServizioOpzionale: "Ora servizio",
            qta: "Qta",
            search: "Cerca",
            giornata: "Giornata",
            Noteorganizzative: "Note organizzative",
            ospiti: "Ospiti",
            clients: 'Clienti',
            descrizionemodificabile: "Descrizione modificabile",
            saleassegnate: "Sale assegnate",
            dacatalogo: "Da catalogo",
            data: "Data",
            righeperpagina: "Righe per pagina",
            azienda: "Azienda (Opzionale)",
            datascadenzapreventivo: "Data scadenza preventivo",
            tipiutilizzo: "Tipi di utilizzo",
            server: "Server",
            nomeEvento: "Nome evento",
            client: 'Cliente',
            FasceOrarie: "Fasce orarie",
  InserisciFasceOrarie: "Inserisci fasce come colazione, pranzo e cena. Il nome della fascia attiva verrà mostrato in alto in base all’orario corrente.",
  Fascia: "Fascia",
  Rimuovi: "Rimuovi",
  NomeFascia: "Nome fascia",
  PlaceholderNomeFascia: "COLAZIONE",
  Da: "Da",
  A: "A",
  breakfast: "Colazione",
  lunch: "Pranzo",
  dinner: "Cena",
  EsempioFasciaOraria: "Esempio: da 08:00 a 12:00 = COLAZIONE",
  AggiungiFascia: "Aggiungi fascia",
  Salvataggio: "Salvataggio...",
  SalvaFasceOrarie: "Salva fasce orarie",
  TimeSlotsRequired: "Aggiungi almeno una fascia oraria valida.",
  TimeSlotInvalid: "Controlla gli orari inseriti.",
  TimeSlotsSaved: "Fasce orarie salvate con successo.",
            tipoPractica: "Tipo pratica",
            tipoPratica: "Tipo pratica",
            completata: "Completata",
            checkIn: "Check-in",
            eventoInCorso: "Evento in corso",
            eventoCompletato: "Evento completato",
            prenotazioniConfermate: "Prenotazioni Confermate",
            preventiviScaduti: "Preventivi Scaduti",
            preventivoScaduto: "Preventivo scaduto",
            destinatarioLibero: "Destinatario libero",
            destinatarioLiberoHelp: "Cliente o ditta non ancora in anagrafica.",
            partitaIvaOpzionale: "Partita IVA (opzionale)",
            creaCliente: "Crea cliente",
            creaAzienda: "Crea azienda",
            nessunapractica: "Nessuna pratica trovata",
            transferFrom: "Trasferisci da:",
            tipiutilizzo: "Tipi di utilizzo (Opzionale)",
            clienteaziendaeventoo: "Cliente (Opzionale)",
            transferTo: "Trasferisci a:",
            planner: "Planner",
            transfer: "trasferisci",
            confirmCovers: "Conferma Coperti",
            pratichetrovatesu : "pratiche trovate su",
            roomNameExists: "Nome Sala Già Esistente",
            noTableOnStandBy: "Nessun Tavolo In Attesa",
            riepilogoPratiche: "Riepilogo pratiche",
            horizontalPlease: "Per l'utilizzo di questa App, per favore ruotare lo schermo orizzontalmente",
            numberOfPeople: "Numero di persone",
            confirm_delete: "Elimina prenotazioni",
            selectorders: "Seleziona prenotazioni",
            placeholdercerca: "Cerca per cliente, azienda o evento",
            planning_title: "Pianificazione",
            plannersubtitle: "Gestisci preventivi, prenotazioni ed eventi dalla disponibilita sale.",
            selectTable: "Seleziona tavolo",
            selectedarticles: "Articoli selezionati",
            cerca: "Cerca",
            CustomerOrderHistory: "Storico ordini cliente",
            giorno: "Giorno",
tregiorni: "3 giorni",
settegiorni: "7 giorni",
settlavorativa: "Sett. lavorativa",
settimana: "Settimana",
agenda: "Agenda",
            accountsView: "Conti",
            oggi: "Oggi",
            indietro: "Indietro",
            avanti: "Avanti",
            nuovapratica: "Nuova pratica",
            filtri: "Filtri",
            filtriPerStampa: "Filtri",
            filtriPlannerHelp: "Filtra le pratiche visualizzate nel planner e incluse nei riepiloghi PDF o email.",
            duplica: "Duplica",
            stato: "Stato",
            tutti: "Tutti",
            sala: "Sala",
            tutte: "Tutte",
            clienteaziendaevento: "Cliente, azienda o evento",
            da: "Da",
            a: "A",
            categorieprodottinelreport:"Categorie prodotti nel report", 
            pdfsenzaprezzietotali:"PDF senza prezzi e totali",
            mostrannullateneltabellone: "Mostra annullate nel tabellone",
            nessunapraticanelgiornoselezionato: "Nessuna pratica nel giorno selezionato",
sale: "Sale",
capienza: "Capienza",
bloccatada: "Bloccata da",
sallacollegata: "sala collegata",
riepilogopratiche: "Riepilogo pratiche",
praticheritrovatesu: "pratiche trovate su",
Pulisicifiltrilista: "Pulisci filtri lista",
tutti: "Tutti",
pratica: "Pratica",
stato: "Stato",
destinatario: "Destinatario",
sala: "Sala",
periodo: "Periodo",
invii: "Invii",
azioni: "Azioni",
uso: "Uso",
motivo: "Motivo",
converti: "Converti",
conferma: "Conferma",
modifica: "Modifica",
elimina: "Elimina",
nessunapraticatrovata: "Nessuna pratica trovata",
preventivo: "Preventivo",
daconfermare: "Da confermare",
confermata: "Confermata",
annullata: "Annullata",
noshow: "No-show",
giornateeSale: "Giornate e sale",
aggiungidata: "Aggiungi data",
righepreventivoservizi: "Righe preventivo / servizi",
aggiungiriga: "Aggiungi riga",
Inviopreventivo: "Invio preventivo",
emailattiva: "Email attiva",
inviaemaildoposalvataggio: "Invia email dopo salvataggio",
Allegatiextra: "Allegati extra",
Caricaallegati: "Carica allegati",
salvapratica: "Salva pratica",
annulla: "Annulla",
Allestimenticompatibili: "Allestimenti compatibili",
durante: "Durante la prenotazione di questa sala saranno selezionabili solo questi allestimenti.",
parentRoomOptional: "Sala madre (opzionale)",
noParentRoom: "Nessuna sala madre",
parentRoomHelp: "Se questa sala e una suddivisione, indica qui la sala principale.",
salvacompatibilita: "Salva compatibilità",
InviaRiepilogoFiltrato: "Invia riepilogo filtrato",
inviaPDF: "Invia PDF",
Annullapratica: "Annulla pratica",
Perannullareunapratica: "Per annullare una pratica devi indicare il motivo dell'annullamento.",
confermaanullamento: "Conferma annullamento",
            pulisci: "Pulisci",
            modalita: "Modalità",
            serviceAccountsTitle: "Conti di servizio",
            serviceOrdersTitle: "Ordini di servizio",
            serviceAccountsSubtitle: "Conti aperti, chiusi e in lavorazione nel periodo selezionato.",
            serviceOrdersSubtitle: "Comande e addebiti da servizi pianificati nel periodo selezionato.",
            ordersView: "Ordini",
            accountColumn: "Account",
            orderColumn: "Ordine",
            date: "Data",
            orders: "Ordini",
            allestimentisale: "Allestimenti di sala",
            reparti: "Reparti",
            reparto: "Reparto",
            noteRepartoServizio: "Note per il reparto",
            invioConfermaOpzione: "Invio conferma/opzione",
            invioRiepilogoEvento: "Invio riepilogo evento",
            status: "Status",
            rows: "Righe",
            pacchetti: "Pacchetti",
            total: "Total",
            noOrdersPeriod: "Nessun ordine in questo periodo.",
            noServiceAccounts: "Nessun conto di servizio trovato",
            noProductData: "Nessun dato prodotto disponibile",
            noEventsToday: "Nessun evento programmato oggi.",
            guests: "Ospiti",
            noServicesToday: "Nessun servizio da erogare oggi.",
            noServicesPeriod: "Nessun servizio in questo periodo.",
            noCharges: "Nessun addebito in questo periodo.",
            topServices: "Servizi principali nel periodo",
            topProducts: "Prodotti più venduti",
            servizi: "Servizi",
            loading: "Caricamento...",
            monitorEventi: {
              menu: "Monitor eventi",
              title: "Eventi di oggi",
              ended: "Terminato",
              realtimeShort: "Live",
              events: "eventi",
              services: "Servizi",
              noOperations: "Nessun servizio operativo indicato",
              moreOperations: "altre attivita",
              noEventsForRoom: "Prova a selezionare tutte le sale.",
              waitingRealtime: "La vista si aggiorna automaticamente in tempo reale.",
              moreEvents: "eventi non visibili: filtra per sala",
              enterFullscreen: "Schermo intero",
              loadError: "Errore nel caricamento eventi.",
            },
            menuGroups: {
              operativity: "Operativita",
              reservationsCrm: "Prenotazioni e CRM",
              catalogMenu: "Catalogo e menu",
              administration: "Amministrazione",
              system: "Sistema",
              operationsLog: "Log operazioni",
              systemSettings: "Impostazioni sistema",
              landingPage: "Landing page",
            },
            issuedDocuments: {
              menu: "Documenti emessi",
              title: "Documenti emessi",
              subtitle: "Pagamenti da Punto Cassa, documenti commerciali e addebiti HElite.",
              from: "Da",
              to: "A",
              refresh: "Aggiorna",
              refreshed: "Documenti emessi aggiornati",
              loadError: "Errore nel caricamento dei documenti emessi",
              normalPayments: "Pagamenti normali",
              helitePayments: "Addebiti HElite",
              prepaymentDocuments: "Acconti",
              countSummary: "{{count}} righe | {{total}}",
              searchPlaceholder: "Cerca conto, cliente, camera, servizio...",
              account: "Conto",
              date: "Data",
              clientContext: "Cliente / contesto",
              payments: "Pagamenti",
              document: "Documento",
              event: "Evento",
              operation: "Operazione",
              sourceDocument: "Documento origine",
              total: "Totale",
              actions: "Azioni",
              noDocuments: "Nessun documento emesso trovato.",
              details: "Dettagli",
              detailTitle: "Dettaglio conto #{{id}}",
              prepaymentDetailTitle: "Dettaglio acconto #{{id}}",
              client: "Cliente",
              context: "Contesto",
              paidTotal: "Totale pagato",
              orderStatus: "Stato ordine",
              method: "Metodo",
              type: "Tipo",
              roomHolder: "Camera / titolare",
              amount: "Importo",
              fiscal: "Fiscale",
              courtesy: "Cortesia",
              historicalHeliteCharge: "Addebito HElite storico",
              noHeliteCharges: "Nessun addebito HElite collegato.",
              codes: "Codici",
              status: "Stato",
              error: "Errore",
              orderRows: "Righe ordine",
              extraCounter: "Extra banco",
              item: "Voce",
              quantity: "Qta",
              commercialDocuments: "Documenti commerciali",
              noCommercialDocuments: "Nessun documento commerciale collegato.",
              documentCount: "{{count}} documenti",
              documentNumber: "Documento #{{id}}",
              invoiceNumber: "Fattura {{number}}",
              sourceDocumentNumber: "Origine {{number}}",
              eventFallback: "Evento #{{id}}",
              prepaymentMovements: "Movimenti acconto",
              close: "Chiudi",
              clientFallback: "Cliente #{{id}}",
              tableFallback: "Tavolo {{id}}",
              counter: "Banco",
              helite: "HElite",
              deduct: "Storna",
              heliteDeducted: "Addebito HElite stornato.",
              deductConfirmTitle: "Stornare addebito HElite?",
              deductConfirmText: "Questa operazione invia uno storno a HElite per l'addebito selezionato.",
              restore: "RIPRISTINO",
              heliteRestored: "Conto HElite ripristinato nel Punto Cassa.",
              restoreHeliteConfirmTitle: "Ripristinare il conto HElite?",
              restoreHeliteConfirmText: "Verrà creato un nuovo conto nel Punto Cassa con articoli, tavolo, cliente e prenotazione originali. Non verrà inviato automaticamente un nuovo addebito a HElite.",
              chargeStatuses: {
                SUCCESS: "Riuscito",
                FAILED: "Fallito",
                REVERSED: "Stornato",
                PARTIALLY_REVERSED: "Stornato parzialmente",
                PENDING: "In attesa",
              },
              paymentMethods: {
                cash: "Contanti",
                card: "Carta",
                bankTransfer: "Bonifico",
                voucher: "Voucher",
                roomCharge: "Addebito HElite",
                invoice: "Fattura",
              },
              prepaymentTypes: {
                DEPOSIT: "Deposito",
                ADVANCE: "Anticipo fiscale",
              },
              prepaymentOperations: {
                RECEIPT: "Incassato",
                REFUND: "Rimborsato",
                REVERSAL: "Stornato",
                APPLICATION: "Applicato",
              },
              prepaymentDocumentTypes: {
                PLAIN_RECEIPT: "Ricevuta semplice",
                COMMERCIAL_DOCUMENT: "Documento commerciale",
                INVOICE_TD02: "Fattura di acconto",
                COMMERCIAL_CANCELLATION: "Annullo commerciale",
                COMMERCIAL_RETURN: "Reso commerciale",
                CREDIT_NOTE_TD04: "Nota di credito",
              },
              lineTypes: {
                product: "Prodotto",
                package: "Pacchetto",
                menu: "Menu",
                adjustment: "Rettifica",
              },
            },
            fixedPriceMenu: {
              title: "Menu a prezzo fisso",
              subtitle: "Configura prezzo, portate, scelte e supplementi.",
              newMenu: "Nuovo menu",
              editMenu: "Modifica menu",
              defaultMenuName: "Menu Pranzo",
              defaultFirstCourse: "Primo",
              defaultSecondCourse: "Secondo",
              defaultDessertCourse: "Dolce",
              defaultCourse: "Portata {{index}}",
              restaurantOnly: "Funzione disponibile solo per RISTORANTE.",
              loading: "Caricamento...",
              noMenus: "Nessun menu configurato.",
              active: "Attivo",
              inactive: "Disattivo",
              choicesAndDishes: "{{min}}-{{max}} scelte, {{count}} piatti",
              edit: "Modifica",
              deactivate: "Disattiva",
              deleteConfirm: "Eliminare \"{{name}}\"?",
              name: "Nome",
              date: "Data",
              basePrice: "Prezzo base",
              courseName: "Nome portata",
              courseOrder: "Ordine",
              minimum: "Min",
              maximum: "Max",
              availableDishes: "Piatti disponibili",
              optionalSupplement: "Supplemento opzionale",
              extraPrice: "Extra EUR",
              addCourse: "Aggiungi portata",
              cancel: "Annulla",
              save: "Salva",
              saving: "Salvataggio...",
              selectDishes: "Scegli piatti",
              selectDishesDescription: "Seleziona i piatti per ogni portata.",
              choose: "Scegli {{count}}",
              chooseRange: "Scegli {{min}}-{{max}}",
              chooseUpTo: "Puoi scegliere fino a {{count}} articoli (facoltativo)",
              noDishesConfigured: "Nessun piatto configurato.",
              menuPrice: "Prezzo menu",
              supplements: "Supplementi",
              addToOrder: "Aggiungi alla comanda",
              menuFallback: "Menu a prezzo fisso",
              productFallback: "Prodotto #{{id}}",
              supplementLabel: "Supplemento EUR {{price}}",
              saved: "Menu a prezzo fisso salvato",
              deactivated: "Menu disattivato",
              deleted: "Menu eliminato",
              loadError: "Errore nel caricamento dei menu",
              saveError: "Errore durante il salvataggio",
              deactivateError: "Errore durante la disattivazione",
              deleteError: "Errore durante l'eliminazione",
              validationMainFields: "Compila nome e prezzo.",
              validationAddCourse: "Aggiungi almeno una portata.",
              validationCourseOrderPositive: "L'ordine delle portate deve essere un numero positivo.",
              validationCourseOrderUnique: "Ogni portata deve avere un ordine diverso.",
              validationActiveDate: "Esiste gia un menu attivo per questa data.",
              validationCourseContent: "Ogni portata deve avere un nome e almeno un piatto.",
              validationSelectionLimits: "Le scelte minime/massime non sono valide.",
              validationMinimumMaximum: "Le scelte minime non possono superare le massime.",
              validationMaximumOptions: "Le scelte massime superano i piatti disponibili.",
              checkoutDeleteBlocked: "Il menu a prezzo fisso non puo essere eliminato dal checkout.",
              checkoutPriceSnapshot: "Il prezzo del menu e salvato nello snapshot dell'ordine.",
              checkoutChangesBlocked: "Il menu a prezzo fisso non supporta modifiche nel checkout.",
              checkoutSplitBlocked: "Il menu a prezzo fisso non puo essere diviso.",
              checkoutQuantitySnapshot: "La quantita del menu e salvata nello snapshot dell'ordine.",
            },
            logsPage: {
              title: "Log operazioni",
              exportCsv: "Export CSV",
              exportSuccess: "Export CSV completato",
              exportError: "Errore export CSV",
              loadError: "Errore nel caricamento log",
              action: "Azione",
              entity: "Entita",
              entityId: "Entita ID",
              userId: "User ID",
              userName: "Nominativo",
              email: "Email",
              path: "Path",
              reason: "Motivo",
              requestId: "Request ID",
              dateTime: "Data/Ora",
              from: "Dal",
              to: "Al",
              refresh: "Aggiorna",
              all: "Tutte",
              noLogs: "Nessun log trovato",
            },
            reports: {
              orderStatus: { OPEN: "Aperto", IN_PROGRESS: "In lavorazione", CLOSED: "Chiuso", CANCELLED: "Annullato", PAID: "Pagato" },
              eventStatus: { PREVENTIVO: "Preventivo", TO_CONFIRM: "Da confermare", CONFIRMED: "Confermato", CHECKED_IN: "Check-in", COMPLETED: "Completato", CANCELLED: "Annullato", NO_SHOW: "No-show" },
              recipientMissing: "Destinatario non assegnato",
              tablesMissing: "Tavoli non assegnati",
              service: "Servizio",
              package: "Pacchetto",
              product: "Prodotto",
              table: "Tavolo",
              counter: "Banco",
              order: "Ordine #{{id}}",
              event: "Evento",
              adminReports: "Reports admin",
              title: "Statistiche operative",
              subtitle: "Ordini di servizio, eventi futuri, eventi del giorno, servizi da erogare e produzione economica del periodo.",
              from: "Dal",
              to: "Al",
              refresh: "Aggiorna",
              today: "Oggi",
              last7: "Ultimi 7 giorni",
              last30: "Ultimi 30 giorni",
              currentMonth: "Mese corrente",
              eventsToday: "Eventi oggi",
              serviceRows: "{{count}} righe servizio",
              deliverToday: "Da erogare oggi",
              plannedServices: "Servizi e pacchetti pianificati",
              adminReports: "Report amministrativi",
    title: "Statistiche operative",
    subtitle: "Ordini di servizio, eventi futuri, eventi di oggi, servizi da consegnare e produzione del periodo.",
    from: "Da",
    to: "A",
    refresh: "Aggiorna",
    today: "Oggi",
    last7: "Ultimi 7 giorni",
    last30: "Ultimi 30 giorni",
    currentMonth: "Mese corrente",
    showEventsSection: "Mostra sezione eventi",
    hideEventsSection: "Nascondi sezione eventi",
    eventsToday: "Eventi di oggi",
    serviceRows: "Righe servizi",
    deliverToday: "Da consegnare oggi",
    plannedServices: "Servizi pianificati",
    periodProduction: "Produzione del periodo",
    serviceOrders: "Ordini di servizio",
    plannedEvents: "Eventi pianificati",
    daysInPeriod: "Giorni nel periodo",
    openOrders: "Ordini aperti",
    openOrdersSubtitle: "Aperti, in lavorazione o chiusi",
    counterSales: "Vendite al banco",
    counterSalesSubtitle: "Ordini senza tavolo",
    servicesToday: "Servizi da consegnare oggi",
    servicesTodaySubtitle: "Lista operativa della produzione per sala/tavolo.",
    serviceAccountsTitle: "Conti di servizio",
    serviceOrdersTitle: "Ordini di servizio",
    serviceAccountsSubtitle: "Conti aperti, chiusi e in lavorazione nel periodo selezionato.",
    serviceOrdersSubtitle: "Comande e addebiti da servizi pianificati nel periodo selezionato.",
    accountsView: "Vista conti",
    ordersView: "Vista ordini",
    accountColumn: "Conto",
    orderColumn: "Ordine",
    date: "Data",
    orders: "Ordini",
    status: "Stato",
    rows: "Righe",
    total: "Totale",
    noOrdersPeriod: "Nessun ordine in questo periodo.",
    noServiceAccounts: "Nessun conto di servizio trovato.",
    noProductData: "Nessun dato prodotto disponibile.",
    noEventsToday: "Nessun evento programmato per oggi.",
    noServicesToday: "Nessun servizio da consegnare oggi.",
    noServicesPeriod: "Nessun servizio in questo periodo.",
    noCharges: "Nessun addebito in questo periodo.",
    topServices: "Servizi principali nel periodo",
    topServicesSubtitle: "Produzione pianificata dagli eventi.",
    usageTypeStatsTitle: "Statistiche per tipo di utilizzo",
    usageTypeStatsSubtitle: "Distribuzione delle pratiche sale congressi nel periodo selezionato.",
    noPracticesPeriod: "Nessuna pratica nel periodo selezionato.",
    withoutUsageType: "Senza tipo",
    practiceCount: "{{count}} pratiche",
    daysCount: "{{count}} giornate",
    guestsCount: "{{count}} ospiti",
    productionTitle: "Produzione del periodo",
    productionSubtitle: "Addebiti da ordini e servizi pianificati.",
    actual: "Effettivo",
    planned: "Pianificato",
    source: "Origine",
    item: "Voce",
    context: "Contesto",
    historical: "Storico",
    historicalSubtitle: "Dati dalle statistiche esistenti.",
    latestDailySales: "Ultime vendite giornaliere",
    noHistoricalData: "Nessun dato storico disponibile.",
    topProducts: "Prodotti più venduti",
    loadError: "Errore nel caricamento dei report",
    recipientMissing: "Destinatario non assegnato",
    tablesMissing: "Nessun tavolo assegnato",
    service: "Servizio",
    package: "Pacchetto",
    event: "Evento",
    anonymousClient: "Cliente anonimo",
    counter: "Banco",
    table: "Tavolo",
    client: "Cliente",
    noEvent: "Nessun evento",
              periodProduction: "Produzione periodo",
              serviceOrders: "{{count}} ordini di servizio",
              plannedEvents: "Pianificato eventi",
              daysInPeriod: "{{count}} giornate nel periodo",
              openOrders: "Ordini aperti",
              openOrdersSubtitle: "Aperti, in lavorazione o chiusi",
              counterSales: "Vendite al banco",
              counterSalesSubtitle: "{{count}} ordini senza tavolo",
              futureCalendar: "Calendario eventi futuri",
              futureCalendarSubtitle: "Vista compatta dei prossimi 14 giorni.",
              futureDays: "{{count}} giornate future",
              noEvent: "Nessun evento",
              eventsOfDay: "Eventi del giorno",
              eventsOfDaySubtitle: "Agenda operativa di oggi.",
              noEventsToday: "Nessun evento previsto oggi.",
              guests: "ospiti",
              servicesToday: "Servizi da erogare nel giorno",
              servicesTodaySubtitle: "Lista produzione operativa per sala/tavolo.",
              time: "Ora",
              quantity: "Qta",
              value: "Valore",
              noServicesToday: "Nessun servizio da erogare oggi.",
              serviceOrdersTitle: "Ordini di servizio",
              serviceOrdersSubtitle: "Comande e addebiti nel periodo selezionato.",
              orderColumn: "Ordine",
              date: "Data",
              status: "Stato",
              rows: "Righe",
              total: "Totale",
              noOrdersPeriod: "Nessun ordine nel periodo.",
              topServices: "Top servizi del periodo",
              topServicesSubtitle: "Produzione pianificata da eventi.",
              noServicesPeriod: "Nessun servizio nel periodo.",
              productionTitle: "Produzione del periodo",
              productionSubtitle: "Addebiti da comande e servizi pianificati.",
              actual: "Consuntivo",
              planned: "Pianificato",
              source: "Fonte",
              item: "Voce",
              context: "Contesto",
              noCharges: "Nessun addebito nel periodo.",
              historical: "Statistiche storiche disponibili",
              historicalSubtitle: "Dati provenienti dalle viste statistiche esistenti.",
              latestDailySales: "Ultime vendite giornaliere",
              orders: "ordini",
              noHistoricalData: "Nessun dato storico disponibile.",
              topProducts: "Prodotti piu venduti",
              noProductData: "Nessun dato prodotti disponibile.",
              loadError: "Errore nel caricamento dei report",
              quotesConverted: "Preventivi convertiti",
              quotesConvertedSubtitle: "{{converted}} su {{total}} preventivi",
              chartsOverviewTitle: "Vendite a colpo d'occhio",
              chartsOverviewSubtitle: "Grafici animati collegati al periodo selezionato nel report.",
              chartCollectionTitle: "Andamento incassi",
              chartCollectionSubtitle: "Valore incassato rispetto al totale ancora da incassare.",
              chartCollected: "Incassato",
              chartToCollect: "Da incassare",
              chartChannelTitle: "Canali di vendita",
              chartChannelSubtitle: "Ripartizione dei ricavi tra banco e servizio al tavolo.",
              chartCounter: "Banco",
              chartTable: "Servizio al tavolo",
              chartQuoteConfirmationTitle: "Preventivi e conferme",
              chartQuoteConfirmationSubtitle: "Preventivi ancora aperti rispetto alle conferme generate nel periodo selezionato.",
              chartQuotes: "Preventivi",
              chartConfirmations: "Conferme",
              chartPractices: "{{count}} pratiche",
              chartCompositionTitle: "Composizione venduto",
              chartCompositionSubtitle: "Distribuzione dei ricavi per tipologia di articolo.",
              chartNoData: "Nessun dato",
              dynamicChartTitle: "Andamento vendite filtrate",
              dynamicChartSubtitle: "Si aggiorna immediatamente con ogni filtro della tabella dinamica.",
              dynamicTopArticlesTitle: "Articoli filtrati migliori",
              dynamicTopArticlesSubtitle: "Gli articoli con maggior ricavo nel risultato corrente.",
              chartRows: "righe",
              chartRevenue: "Ricavi",
              chartNoFilteredData: "Nessuna vendita corrisponde ai filtri selezionati.",
              soldPeriodTitle: "Tabella dinamica venduto",
              soldPeriodSubtitle: "Filtra il venduto per categoria, articolo, sala, operatore, fascia oraria, data/ora, tipo vendita e tipologia di incasso.",
              salesFilterCategory: "Categoria",
              salesFilterArticle: "Articolo",
              salesFilterRoom: "Sala vendita",
              salesFilterOperator: "Operatore",
              salesFilterTimeSlot: "Fascia oraria",
              salesFilterSaleType: "Tipo vendita",
              salesFilterPaymentType: "Tipologie incasso",
              clearFilters: "Pulisci filtri",
              salesExtractionStart: "Inizio estrazione",
              salesExtractionEnd: "Fine estrazione",
              salesDateTime: "Ora/data vendita",
              saleTypeHotel: "Cliente hotel",
              saleTypeWalkIn: "Cliente passante",
              operatorMissing: "Operatore non rilevato",
              paymentCash: "Contanti",
              paymentCard: "Carte",
              paymentVoucher: "Sospesi",
              paymentRoomCharge: "Addebito HElite",
              paymentInvoice: "Fattura",
              timeSlotMorning: "Mattina 06:00-12:00",
              timeSlotLunch: "Pranzo 12:00-15:00",
              timeSlotAfternoon: "Pomeriggio 15:00-18:00",
              timeSlotDinner: "Cena 18:00-24:00",
              timeSlotNight: "Notte 00:00-06:00",
            },
            eventPanel: {
              loadError: "Errore caricamento dati evento.",
              eventNameRequired: "Nome evento obbligatorio.",
              selectCompany: "Seleziona un'azienda.",
              selectClient: "Seleziona un cliente.",
              oneDayRequired: "Inserisci almeno una giornata.",
              dayNeedsStartEnd: "Ogni giornata richiede inizio e fine.",
              dayEndAfterStart: "Fine giornata deve essere successiva all'inizio.",
              invalidGuests: "Numero ospiti non valido.",
              tableRequiredWhenConfirmed: "Con stato non PREVENTIVO devi selezionare almeno un tavolo per giornata.",
              invalidQuoteEmail: "Email preventivo non valida.",
              dayPrefix: "Giorno {{number}}",
              packageUnit: "pacchetto",
              serviceUnit: "servizio",
              quoteSubject: "Preventivo evento - {{eventName}}",
              eventCreated: "Evento \"{{name}}\" creato con stato {{status}}.",
              createError: "Errore creazione evento.",
              deleteConfirm: "Eliminare questo evento e tutte le giornate collegate?",
              deleted: "Evento eliminato.",
              deleteError: "Errore eliminazione evento.",
              statusUpdated: "Evento aggiornato a {{status}}.",
              statusUpdateError: "Errore aggiornamento stato evento.",
              title: "Evento multi-giorno (Preventivo / Prenotazione)",
              subtitle: "Flusso opzionale: crea un evento con piu giornate, servizi/pacchetti e stato iniziale PREVENTIVO.",
              loading: "Caricamento dati evento...",
              eventName: "Nome evento",
              initialStatus: "Stato iniziale",
              recipient: "Destinatario",
              company: "Azienda",
              client: "Cliente",
              eventNotes: "Note evento",
              day: "Giornata",
              start: "Inizio",
              end: "Fine",
              people: "Persone",
              dayNote: "Nota giornata",
              tables: "Tavoli",
              packages: "Pacchetti",
              singleServices: "Servizi singoli",
              addDay: "Aggiungi giornata",
              sendQuoteAfterCreate: "Invia preventivo email dopo creazione",
              recipientEmail: "Email destinatario",
              subject: "Oggetto",
              message: "Messaggio",
              saving: "Salvataggio...",
              createEvent: "Crea evento",
              latestEvents: "Ultimi eventi creati",
              dayStatuses: "Stato giornate",
              period: "Periodo",
              guests: "Ospiti",
              days: "Giornate",
              actions: "Azioni",
              confirm: "Conferma",
              delete: "Elimina",
              noEvents: "Nessun evento disponibile.",
            },
            quoteAdmin: {
              packageUnit: "pacchetto",
              packageSubtitle: "Pacchetto - {{count}} servizi",
              unitEach: "unita",
              catalogLoadError: "Errore caricamento catalogo.",
              sendQuoteError: "Errore invio preventivo",
              eventCreateRequired: "Per creare l'evento PREVENTIVO seleziona un cliente o un'azienda.",
              customServicesNote: "Servizi custom non mappati:",
              quoteEventName: "Preventivo - {{name}}",
              recipientFallback: "Destinatario",
              eventCreateError: "Errore creazione evento PREVENTIVO",
              sentAndEventCreated: "Preventivo inviato e evento PREVENTIVO creato.",
              eventCreatedEmailFailed: "Evento PREVENTIVO creato, ma email non inviata: {{error}}",
              emailNotSent: "Email non inviata: {{error}}",
              eventNotCreated: "Evento non creato: {{error}}",
              operationNotCompleted: "Operazione non completata.",
              client: "Cliente",
              company: "Azienda",
              manualEmail: "Email manuale",
              noEmail: "nessuna email",
              searchCompany: "Cerca azienda",
              noEmailWarning: "Il destinatario selezionato non ha una email valida.",
              realCatalog: "Catalogo reale servizi",
              realCatalogSubtitle: "Seleziona da pacchetti o servizi singoli.",
              guestCount: "Numero persone",
              table: "Tavolo",
              seats: "posti",
              tablesOptional: "Tavoli (opzionale)",
              selectTables: "Seleziona uno o piu tavoli",
              compatibleTables: "{{count}} tavoli compatibili con {{guests}} persone",
              insertGuestsFirst: "Inserisci prima il numero persone per filtrare per capienza",
              search: "Ricerca",
              type: "Tipo",
              all: "Tutti",
              packages: "Pacchetti",
              servicesSingle: "Servizi singoli",
              results: "risultati",
              catalogLoading: "Caricamento catalogo...",
              name: "Nome",
              detail: "Dettaglio",
              price: "Prezzo",
              package: "Pacchetto",
              service: "Servizio",
              added: "Aggiunto",
              add: "Aggiungi",
              noResults: "Nessun risultato per i filtri selezionati.",
              eventDateTime: "Data e ora evento",
            },
            orderHistoryPage: {
              noProducts: "Nessun prodotto in questo ordine.",
              title: "Storico ordini",
              clients: "Clienti",
              companies: "Aziende",
              heliteRooms: "Camere HElite",
              search: "Cerca...",
              noClients: "Nessun cliente trovato.",
              noCompanies: "Nessuna azienda trovata.",
              noHeliteRooms: "Nessuna camera HElite trovata.",
              selectTarget: "Seleziona un cliente, un'azienda o una camera HElite per vedere lo storico ordini.",
              heliteRoomsPanel: "Ospiti HElite live",
              heliteGuestsCount: "{{count}} camere in casa",
              inHouse: "In casa",
              spentShort: "Speso",
              orders: "Ordini",
              lastOrder: "Ultimo ordine",
              searchHeliteRoom: "Cerca camera {{roomNumber}}",
              searchHeliteRoomHint: "Cerca ordini e addebiti per questa camera HElite.",
              roomLabel: "Camera {{roomNumber}}",
              heliteBill: "Pren. HElite {{billNumber}}",
              spent: "Speso: {{amount}}",
              ordersCount: "{{count}} ordini",
              noOrders: "Nessun ordine trovato.",
              order: "Ordine",
              date: "Data",
              status: "Stato",
              total: "Totale",
              productFallback: "Prodotto #{{id}}",
              packageFallback: "Pacchetto #{{id}}",
              fixedMenuFallback: "Menu a prezzo fisso",
            },
            bookingExtra: {
              multiEventQuote: "Evento multi-giorno / Preventivo",
              quotes: "Preventivi",
              classicReservation: "Prenotazione classica",
              showCancelled: "Mostra annullati",
              showNoShow: "Mostra no-show",
              companyAlternative: "Azienda (alternativa al cliente)",
              companyHelper: "Seleziona un'azienda se vuoi prenotare senza cliente nominativo.",
              newCompanyUpper: "Nuova azienda",
              newCompany: "Nuova azienda",
              eventNameOptional: "Nome evento (opzionale)",
              eventNameHint: "Usalo come discriminante per collegare questa prenotazione a un evento.",
              companyNameRequired: "Il nome azienda e obbligatorio.",
              companyCreated: "Azienda creata con successo.",
              companyName: "Nome azienda *",
              vatOptional: "Partita IVA (opzionale)",
              sdiOptional: "SDI (opzionale)",
              emailOptional: "Email (opzionale)",
              phoneOptional: "Telefono (opzionale)",
              addressOptional: "Indirizzo (opzionale)",
              legalAddressOptional: "Indirizzo legale (opzionale)",
              createCompany: "Crea azienda",
              event: "Evento:",
              services: "Servizi",
            },
            miscUi: {
              destination: "Destinazione",
              newCourse: "Nuova portata",
              selectedCourse: "Portata selezionata",
              orderReprinted: "Ordine ristampato",
              viewOrder: "Vedi ordine",
              transferToAnotherTable: "Trasferisci a un altro tavolo",
              destinationTable: "Tavolo destinazione",
              transferItems: "Trasferisci",
              moveSelectedProduct: "Sposta {{count}} prodotto",
              moveSelectedProducts: "Sposta {{count}} prodotti",
              occupiedTableWarningTitle: "Attenzione: tavolo occupato",
              occupiedDestinationTableConfirm: "Il tavolo di destinazione risulta occupato. Vuoi continuare comunque con il trasferimento?",
              transferSuccess: "Prodotti trasferiti",
              noClientsAvailable: "Nessun cliente disponibile",
              noCompaniesAvailable: "Nessuna azienda disponibile",
            },
            planning: {
              title: "Planning Meeting",
              today: "Oggi",
              help: "Clicca su uno slot libero per creare una prenotazione e poi completa i dettagli nel dialog.",
              legend_available: "Slot disponibili",
              legend_reserved: "Slot prenotati",
              room_summary: "{{count}} tavoli",
              empty_day: "Nessuna prenotazione per questa sala oggi",
              no_rooms: "Nessuna sala configurata.",
              add_at: "Aggiungi prenotazione alle",
              reservation_detail: "Dettaglio Prenotazione",
              time: "Orario",
              guests: "Ospiti",
              note: "Nota",
              notes: "Note",
              new_reservation: "Nuova Prenotazione",
              start_time: "Inizio",
              end_time: "Fine",
              confirm: "Conferma",
              error_client: "Seleziona un cliente.",
              error_dates: "Imposta orario di inizio e fine.",
              error_no_table: "Nessun tavolo trovato per questa sala.",
              delete_reservation: "Elimina prenotazione",
              deleting: "Eliminazione..."
            },
            booking_newClient: 'Nuovo Cliente',
            client_page_error_duplicate_email: "Email già presente",  
            client_page_error_duplicate_phone: "Numero di telefono già presente",
            client_page_error_create: "Errore durante la creazione del cliente",
            client_page_error_required_fields: "Nome e cognome sono obbligatori",
            client_page_error_email_or_phone_required: "Email o numero di telefono sono obbligatori",
            client_page_success_create: "Cliente registrato con successo!",

            
confirm_delete_msg: "Sei sicuro di voler eliminare {{count}} prenotazione/i? Questa azione è irreversibile.",
preventivi: {
  page:                  "Preventivi",
  subtitle:              "Crea e invia un'offerta/preventivo via e-mail al cliente.",
  step_client:           "Cliente",
  step_services:         "Servizi",
  step_preview:          "Anteprima & Invio",
  select_recipient:      "Seleziona destinatario",
  existing_client:       "Cliente esistente",
  insert_email:          "Inserisci e-mail",
  search_client:         "Cerca per nome o email…",
  recipient_name:        "Nome destinatario",
  email_address:         "Indirizzo e-mail",
  to:                    "A",
  available_services:    "Servizi disponibili",
  click_to_add:          "Clicca su un servizio per aggiungerlo al preventivo.",
  quote_items:           "Voci preventivo",
  no_services_selected:  "Nessun servizio selezionato. Clicca sui chip sopra per aggiungere.",
  col_service:           "Servizio",
  col_unit:              "Unità",
  col_qty:               "Qtà",
  col_unit_price:        "Prezzo unit. (€)",
  col_unit_price_short:  "Unit.",
  col_total:             "Totale (€)",
  grand_total:           "Totale preventivo",
  add_custom:            "Aggiungi voce personalizzata",
  custom_name:           "Nome servizio",
  custom_unit:           "Unità",
  custom_unit_placeholder: "es. giorno",
  custom_price:          "Prezzo unit.",
  add:                   "Aggiungi",
  email_details:         "Dettagli e-mail",
  subject:               "Oggetto",
  event_date:            "Data evento",
  valid_until:           "Preventivo valido fino al",
  intro_message:         "Messaggio introduttivo (opzionale)",
  intro_placeholder:     "Scrivi un messaggio personalizzato per il cliente…",
  email_preview:         "Anteprima e-mail",
  include_logo:          "Includi logo nell'e-mail",
  email_header_title:    "Preventivo Offerta",
  email_header_sub:      "Sale Congressi",
  email_greeting:        "Gentile",
  email_default_body:    "La ringraziamo per il suo interesse. Di seguito trova il preventivo dettagliato per i servizi richiesti.",
  email_footer:          "Preventivo generato automaticamente — Sale Congressi",
  sent_title:            "Preventivo inviato!",
  sent_desc:             "Il preventivo è stato inviato a",
  new_quote:             "Nuovo preventivo",
  send:                  "Invia preventivo",
  sending:               "Invio in corso…",
  send_error:            "Errore invio",
  send_error_label:      "Errore durante l'invio",
  back:                  "Indietro",
  next:                  "Avanti",
  services: {
    hall_half_day:   "Sala Congressi – mezza giornata",
    hall_full_day:   "Sala Congressi – giornata intera",
    projector:       "Proiettore + schermo",
    microphone:      "Microfono wireless",
    coffee_break:    "Coffee break",
    business_lunch:  "Pranzo di lavoro",
    gala_dinner:     "Cena di gala",
    floral:          "Allestimento floreale",
    parking:         "Parcheggio riservato",
    wifi:            "Wi-Fi dedicato ad alta velocità",
    photography:     "Servizio fotografico",
  },
  units: {
    session:   "sessione",
    day:       "giorno",
    unit_day:  "unità/giorno",
    person:    "persona",
    set:       "set",
    spot_day:  "posto/giorno",
    hour:      "ora",
    unit:      "unità",
  },
},
            comunicazioni: {
        title:              "Comunicazioni Prenotazioni",
        subtitle:           "Seleziona una prenotazione per visualizzare e aggiungere note tra operatori.",
        select_reservation: "Prenotazioni",
        search_reservation: "Cerca ospite o stanza...",
        no_reservations:    "Nessuna prenotazione trovata.",
        select_to_start:    "Seleziona una prenotazione per iniziare.",
        room:               "Stanza",
        write_placeholder:  "Scrivi un messaggio... (Invio per inviare)",
        publish:            "Invia",
        no_notes:           "Nessun messaggio. Inizia la conversazione.",
        error_empty:        "Il messaggio non può essere vuoto.",
        error_publish:      "Errore durante l'invio.",
        success_publish:    "Messaggio inviato!",
        user_fallback:      "Utente #{{id}}",
        tables_title:   "Tavoli",
      tables_subtitle: "Clicca su un tavolo per vedere o aggiungere comunicazioni.",
    page: "Comunicazioni",
      },

            spa: {
              common: {
                all: "Tutti",
                cancel: "Annulla",
                clear: "Pulisci",
                save: "Salva",
                spaOnly: "Questa area e disponibile solo per tenant SPA.",
              },
              planner: {
                menu: "SPA Planner",
                title: "SPA Planner",
                subtitle: "Agenda giornaliera per trattamenti SPA, operatori e postazioni.",
                day: "Giorno",
                week: "Settimana",
                today: "Oggi",
                newAppointment: "Nuovo appuntamento",
                editAppointment: "Modifica appuntamento",
                loading: "Caricamento SPA planner...",
                empty: "Nessun appuntamento per i filtri selezionati.",
                backendPending: "Backend in attesa: gli appuntamenti sono temporanei finche gli endpoint `/api/spa/*` non saranno disponibili.",
                metrics: {
                  appointments: "Appuntamenti",
                  inProgress: "In corso",
                  completed: "Completati",
                  noShow: "No-show",
                },
              },
              settings: {
                title: "Impostazioni",
                loading: "Caricamento impostazioni",
                saving: "Salvataggio...",
                loadError: "Impossibile caricare le impostazioni SPA.",
                saveError: "Impossibile salvare le impostazioni SPA.",
                interval: "Intervallo planner",
                timeZone: "Fuso orario",
                openingHours: "Orari di apertura",
                noOpeningHours: "Nessun orario configurato per questo giorno",
                closedDays: "Giorni chiusi",
                closedDay: "Giorno chiuso",
                holidays: "Festivita",
                day: "Giorno",
                start: "Inizio",
                end: "Fine",
                addOpeningHour: "Aggiungi orario",
                addHoliday: "Aggiungi festivita",
                holidayDate: "Data",
                holidayName: "Nome",
                invalidDate: "Data appuntamento non valida.",
                closedDayWarning: "Questa data e chiusa nelle impostazioni SPA.",
                holidayWarning: "Questa data e segnata come festivita: {{name}}.",
                intervalWarning: "L'orario di inizio deve seguire l'intervallo planner di {{interval}} minuti.",
                outsideOpeningHoursWarning: "L'orario di inizio e fuori dagli orari di apertura configurati.",
                days: {
                  0: "Domenica",
                  1: "Lunedi",
                  2: "Martedi",
                  3: "Mercoledi",
                  4: "Giovedi",
                  5: "Venerdi",
                  6: "Sabato",
                },
              },
              statuses: {
                OPTION: "Opzione",
                CONFIRMED: "Confermato",
                GUARANTEED: "Garantito",
                ARRIVED: "Arrivato",
                IN_PROGRESS: "In corso",
                COMPLETED: "Completato",
                CANCELLED: "Annullato",
                NO_SHOW: "No-show",
              },
              customerTypes: {
                hotelGuest: "Ospite hotel",
                external: "Esterno",
              },
              fields: {
                actions: "Azioni",
                area: "Area",
                cabin: "Postazione",
                capacity: "Capacita",
                category: "Categoria",
                client: "Cliente",
                date: "Data",
                duration: "Durata",
                durationMinutes: "Durata minuti",
                email: "Email",
                name: "Nome",
                notes: "Note",
                operator: "Operatore",
                price: "Prezzo",
                quantity: "Quantita",
                room: "Camera",
                skills: "Competenze",
                start: "Inizio",
                status: "Stato",
                treatment: "Trattamento",
                type: "Tipo",
                vat: "IVA",
                vatPercent: "IVA %",
              },
              catalog: {
                menu: "Catalogo SPA",
                title: "Catalogo SPA",
                operatorSaved: "Operatore salvato.",
                operatorCreated: "Operatore creato. Ora puoi aggiungere qualifiche e turni.",
                subtitle: "Trattamenti, operatori e attrezzature pronti per il collegamento backend. Le postazioni si gestiscono dalla mappa.",
                addItem: "Aggiungi {{item}}",
                editItem: "Modifica {{item}}",
                loading: "Caricamento catalogo SPA...",
                backendPending: "Backend in attesa: le modifiche al catalogo sono temporanee finche gli endpoint `/api/spa/*` non saranno disponibili.",
                commaSeparated: "Separati da virgola",
                engagementReminderMinutes: "Minuti promemoria incarico",
                engagementReminderHelp: "Da 5 minuti a 7 giorni prima dell'appuntamento.",
                externalInvitations: "Inviti esterni",
                appointmentId: "ID appuntamento",
                expiresInDays: "Scade tra giorni",
                createInvitation: "Crea invito",
                selectAppointment: "Seleziona appuntamento",
                selectAssignedAppointment: "Appuntamenti assegnati di questa settimana.",
                noAssignedAppointments: "Nessun appuntamento assegnato trovato questa settimana.",
                oneTimeToken: "Token monouso",
                copyToken: "Copia token",
                invitationUrl: "URL invito",
                copyUrl: "Copia URL",
                openInvitation: "Apri",
                expiresAt: "Scade il",
                respondedAt: "Risposto il",
                resend: "Reinvia",
                revoke: "Revoca",
                noInvitations: "Nessun invito.",
                invitationCreated: "Invito creato.",
                invitationCreatedEmailFailed: "Invito creato, ma email non inviata.",
                invitationResent: "Invito reinviato.",
                invitationResentEmailFailed: "Invito reinviato, ma email non inviata.",
                invitationRevoked: "Invito revocato.",
                invitationCreateError: "Impossibile creare l'invito",
                invitationResendError: "Impossibile reinviare l'invito",
                invitationRevokeError: "Impossibile revocare l'invito",
                invitationTokenCopied: "Token invito copiato.",
                invitationTokenCopyError: "Impossibile copiare il token",
                invitationUrlCopied: "URL invito copiato.",
                invitationUrlCopyError: "Impossibile copiare l'URL",
                managedInProducts: "Gestito in Prodotti",
                managedInUsers: "Gestito in Utenti",
                tabs: {
                  treatments: { label: "Trattamenti", singular: "trattamento" },
                  operators: { label: "Operatori", singular: "operatore" },
                  equipment: { label: "Attrezzature", singular: "attrezzatura" },
                },
                statuses: {
                  active: "Attivo",
                  inactive: "Inattivo",
                  available: "Disponibile",
                  cleaning: "Pulizia",
                  maintenance: "Manutenzione",
                  out_of_service: "Fuori servizio",
                },
              },
            },

            tenantDomain: {
              RISTORANTE: {
                addTable: "Aggiungi tavolo",
                editTable: "Modifica tavolo",
                tableName: "Nome tavolo",
                tablePrefix: "Prefisso tavolo",
                tableSuffix: "Suffisso tavolo",
                tableQuantity: "Quantità tavoli",
                selectedTable: "Tavolo selezionato",
                room: "Sala",
                roomName: "Nome sala",
                addRoom: "Aggiungi sala",
                editRoom: "Modifica sala",
                deleteRoom: "Elimina sala",
                seats: "Numero coperti",
                seatNumber: "Nr coperti",
                occupiedSeats: "Posti occupati",
                bookingTable: "Tavolo",
                bookingGuests: "Numero coperti",
                reservationTable: "Tavolo",
                reservationRoom: "Sala",
                clearTableTitle: "Conferma liberazione tavolo",
                clearTableAlert: "Sei sicuro di voler liberare il tavolo",
                tablesMap: "Mappa tavoli",
                newTable: "Nuovo tavolo",
                noTable: "Nessun tavolo disponibile",
                selectTable: "Seleziona tavolo",
                freeTables: "Tavoli liberi",
                activeTables: "Tavoli attivi",
                occupiedTables: "Tavoli occupati",
                addTableQuestion: "Aggiungere tavolo?",
                deleteTableRequestTitle: "Conferma eliminazione tavolo",
                deleteTableRequest: "Sei sicuro di voler eliminare questo tavolo? L'operazione non potrà essere annullata.",
                deleteRoomRequestTitle: "Conferma eliminazione sala",
                deleteRoomRequest: "Attenzione! Eliminando questa sala eliminerai permanentemente anche tutti i tavoli ad essa associati. Vuoi procedere ugualmente?",
                newOrder: "Nuovo Ordine",
                selectorders: "Seleziona articoli",
                noOrders: "Nessun Ordine Attivo",
                closeBill: "Chiudi Conto",
                split: "Dividi Comanda",
                transferOrder: "Trasferisci Comanda",
                confirmCovers: "Conferma Coperti",
                activeOrders: "Ordini Attivi",
                orderSummary: "Riepilogo Comanda",
                noProductPresent: "Nessun prodotto presente nella Comanda",
          products: "Articoli",
                add_product: "Aggiungi Articolo",
                allestimenti: {
                  pageTitleShort: "Pacchetti",
                },
                realTimeOrders: "Ordini Tempo Reale",
                send_order: "Invia Comanda",
                orderDetails: "Dettaglio Comanda",
                draftPayment: "Preconto",
                No_table_selected: "Nessun tavolo selezionato",
                checkoutPage: "Punto Cassa",
                checkout_page: {
                  noRegisteredOrders: "Nessun Ordine Registrato",
                  pending: "In Attesa",
                  occupied: "Occupato",
                },
                menu_config: {
                  page: "Menu",
                },
                clearAllTablesAndPay: "[DEV] LIBERA TAVOLI e PAGA ORDINI",
              },
              SPA: {
                addTable: "Aggiungi postazione",
                editTable: "Modifica postazione",
                tableName: "Nome postazione",
                tablePrefix: "Prefisso postazione",
                tableSuffix: "Suffisso postazione",
                tableQuantity: "Quantità postazioni",
                selectedTable: "Postazione selezionata",
                room: "Area",
                roomName: "Nome area",
                addRoom: "Aggiungi area",
                editRoom: "Modifica area",
                deleteRoom: "Elimina area",
                seats: "Numero persone",
                seatNumber: "Nr persone",
                occupiedSeats: "Persone presenti",
                bookingTable: "Postazione",
                bookingGuests: "Numero persone",
                reservationTable: "Postazione",
                reservationRoom: "Area",
                clearTableTitle: "Conferma liberazione postazione",
                clearTableAlert: "Sei sicuro di voler liberare la postazione",
                tablesMap: "Mappa postazioni",
                newTable: "Nuova postazione",
                noTable: "Nessuna postazione disponibile",
                selectTable: "Seleziona postazione",
                freeTables: "Postazioni libere",
                activeTables: "Postazioni attive",
                occupiedTables: "Postazioni occupate",
                addTableQuestion: "Aggiungere postazione?",
                deleteTableRequestTitle: "Conferma eliminazione postazione",
                deleteTableRequest: "Sei sicuro di voler eliminare questa postazione? L'operazione non potrà essere annullata.",
                deleteRoomRequestTitle: "Conferma eliminazione area",
                deleteRoomRequest: "Attenzione! Eliminando questa area eliminerai permanentemente anche tutte le postazioni ad essa associate. Vuoi procedere ugualmente?",
                newOrder: "Nuovo Appuntamento",
                noOrders: "Nessun Appuntamento Attivo",
                closeBill: "Chiudi Sessione",
                split: "Dividi Sessione",
                transferOrder: "Trasferisci Appuntamento",
                confirmCovers: "Conferma Ospiti",
                activeOrders: "Appuntamenti Attivi",
                orderSummary: "Riepilogo Appuntamento",
                noProductPresent: "Nessun servizio presente nell'Appuntamento",
          products: "Servizi",
                realTimeOrders: "Appuntamenti Tempo Reale",
                send_order: "Invia Appuntamento",
                orderDetails: "Dettaglio Appuntamento",
                draftPayment: "Preconto",
                No_table_selected: "Nessuna postazione selezionata",
                checkoutPage: "Cassa Sessioni",
                checkout_page: {
                  noRegisteredOrders: "Nessun Appuntamento Registrato",
                  pending: "In Attesa",
                  occupied: "In Corso",
                },
                menu_config: {
                  page: "Listino servizi",
                },
                clearAllTablesAndPay: "[DEV] LIBERA POSTAZIONI e PAGA ORDINI",
              },
              SALE_CONGRESSI: {
                planning: {
  title:              "Planning Meeting",
  today:              "Oggi",
  help:               "Clicca su uno slot libero per creare una prenotazione e poi completa i dettagli nel dialog.",
  legend_available:   "Slot disponibili",
  legend_reserved:    "Slot prenotati",
  room_summary:       "{{count}} tavoli",
  empty_day:          "Nessuna prenotazione per questa sala oggi",
  delete_reservation: "Elimina prenotazione",
  deleting:           "Eliminazione...",
  no_rooms:           "Nessuna sala configurata.",
  add_at:             "Aggiungi prenotazione alle",
  reservation_detail: "Dettaglio Prenotazione",
  time:               "Orario",
  guests:             "Ospiti",
  note:               "Nota",
  notes:              "Note",
  new_reservation:    "Nuova Prenotazione",
  start_time:         "Inizio",
  end_time:           "Fine",
  confirm:            "Conferma",
  error_client:       "Seleziona un cliente.",
  error_dates:        "Imposta orario di inizio e fine.",
  error_no_table:     "Nessun tavolo trovato per questa sala.",
},
                addTable: "Aggiungi sala",
                editTable: "Modifica sala",
                tableName: "Nome sala",
                tablePrefix: "Prefisso sala",
                tableSuffix: "Suffisso sala",
                tableQuantity: "Quantità sale",
                selectedTable: "Sala selezionata",
                room: "Area",
                roomName: "Nome area",
                addRoom: "Aggiungi area",
                editRoom: "Modifica area",
                deleteRoom: "Elimina area",
                seats: "Numero partecipanti",
                seatNumber: "Nr partecipanti",
                occupiedSeats: "Partecipanti presenti",
                bookingTable: "Sala",
                eventPanel: {
                  tables: "Sale",
                  tableRequiredWhenConfirmed: "Quando lo stato non e PREVENTIVO, seleziona almeno una sala per ogni giornata.",
                },
                bookingGuests: "Numero partecipanti",
                reservationTable: "Sala",
                reservationRoom: "Area",
                clearTableTitle: "Conferma liberazione sala",
                clearTableAlert: "Sei sicuro di voler liberare la sala",
                tablesMap: "Setup sale",
                newTable: "Nuova sala",
                noTable: "Nessuna sala disponibile",
                selectTable: "Seleziona sala",
                freeTables: "Sale libere",
                activeTables: "Sale attive",
                occupiedTables: "Sale occupate",
                addTableQuestion: "Aggiungere sala?",
                deleteTableRequestTitle: "Conferma eliminazione sala",
                deleteTableRequest: "Sei sicuro di voler eliminare questa sala? L'operazione non potrà essere annullata.",
                deleteRoomRequestTitle: "Conferma eliminazione area",
                deleteRoomRequest: "Attenzione! Eliminando questa area eliminerai permanentemente anche tutte le sale ad essa associate. Vuoi procedere ugualmente?",
                newOrder: "Nuova Pratica",
                noOrders: "Nessun Evento Attivo",
                closeBill: "Chiudi Evento",
                split: "Dividi Evento",
                transferOrder: "Trasferisci Evento",
                confirmCovers: "Conferma Partecipanti",
                activeOrders: "Eventi Attivi",
                orderSummary: "Riepilogo Evento",
                noProductPresent: "Nessun servizio presente nell'Evento",
          products: "Servizi",
                realTimeOrders: "Eventi Tempo Reale",
                send_order: "Invia Evento",
                orderDetails: "Dettaglio Evento",
                draftPayment: "Preconto",
                No_table_selected: "Nessuna sala selezionata",
                checkoutPage: "Punto Cassa",
                checkout_page: {
                  noRegisteredOrders: "Nessun Evento Registrato",
                  pending: "In Attesa",
                  occupied: "In Corso",
                },
                menu_config: {
                  page: "Listino servizi",
                },
                clearAllTablesAndPay: "[DEV] LIBERA SALE e PAGA ORDINI",
          allestimenti: {
            pageTitle: "Gestione pacchetti",
            pageSubtitle: "Crea pacchetti per prenotazioni e vendita diretta. Le sale congressi li possono usare nelle prenotazioni, i ristoranti come menu degustazione direttamente al tavolo.",
            pageTitleShort: "Pacchetti",
            productsAvailable: "Servizi disponibili",
            packageCapacityPeople: "partecipanti",
          },
              },
            },

            client_page: {
              title: "Gestione Clienti",
              search_label: "Cerca per nome o numero camera",
              or_create_company: "Oppure crea una nuova azienda:",
              address: "Indirizzo",
              street_number: "Numero Civico",
              zip_code: "CAP",
              city: "Città",
              province: "Provincia",
              tax_code: "Codice Fiscale",
              rea_number: "Numero REA",
              rea_office: "Ufficio REA",
              insert_passenger: "Inserisci Cliente Passante",
              name: "Nome",
              surname: "Cognome",
              email: 'Indirizzo email',
              phone: 'Recapito telefonico',
              add_client: "Aggiungi Cliente",
              order_history: "Storico ordini di",
              order: "Ordine",
              toCheckout: "Manda in cassa",
              no_orders: "Nessun ordine presente",
              room: "Numero camera",
              treatment: "Trattamento (Passante o Cliente)",
              internal: "Cliente",
        external: "Passante",
        no_client_search: "Usa la barra di ricerca per trovare un cliente",
              client_type: "Tipo Cliente",
              add_company: "Aggiungi Azienda",
              type_company: "Azienda",
              type_individual: "Cliente",
              type_reference: "Nominativo Riferimento",
              company_name: "Nome Azienda",
              contact_person: "Persona di Riferimento",
              email_or_phone_required: "Email o numero di telefono obbligatorio",
              name_optional: "Nome (Opzionale)",
              surname_optional: "Cognome (Opzionale)",
        btn_clienti:  "Clienti",
        btn_aziende:  "Aziende",

        legal_address: "Sede legale",
        company_email: "Email aziendale",

        company_hint:        "Nessuna azienda — creane una nella sezione Aziende",
        company_search_hint: "Cerca o seleziona un'azienda esistente",
        company_no_options:  "Nessuna azienda trovata",
        search_companies_label: "Cerca per nome azienda, P.IVA o email",

        no_results:       "Nessun cliente trovato.",
        no_clienti:       "Nessun cliente registrato ancora.",
        linked_clients:   "Clienti associati",

        add_company_and_client:  "Aggiungi Azienda e Cliente",
        add_company_subtitle:    "Registra una nuova azienda e il cliente principale associato.",
        client_info:             "Dati Cliente",
        company_info:            "Dati Azienda",
        register_company_client: "Registra Azienda e Cliente",

        company_management: "Gestione Aziende",
        no_companies:       "Nessuna azienda registrata ancora.",


        success_create:                "Cliente registrato con successo!",
        success_create_company_client: "Azienda e cliente registrati con successo!",
        error_required_fields:         "Nome e cognome sono obbligatori.",
        error_company_required:        "Il nome dell'azienda è obbligatorio.",
        error_create:                  "Errore durante la registrazione.",
            },
            confirmOperation: {
              deleteProduct: "Eliminare prodotto dalla comanda?",
              cancel: "Annulla",
              confirm: "Conferma",
              editOrder: "Modifica Ordine",
            },
            heliteGuestPicker: {
              title: "Seleziona ospite HElite",
              searchPlaceholder: "Cerca per camera, nome o prenotazione",
              loading: "Caricamento ospiti HElite...",
              loadingShort: "Caricamento ospiti...",
              empty: "Nessun ospite HElite trovato.",
              room: "Camera",
              guest: "Ospite",
              board: "Board",
              booking: "Prenotazione",
              arrival: "Arrivo",
              departure: "Partenza",
              roomWithNumber: "Camera {{room}}",
              bookingShort: "Pren. {{number}}",
              linkedGuest: "Ospite HElite",
              noLinkedGuest: "Nessun ospite HElite collegato",
              selectButton: "Ospite HElite",
              selectRequired: "Seleziona un ospite HElite",
              confirmCharge: "Conferma addebito",
              missingBillId: "Ospite HElite senza billId: impossibile registrare l'addebito camera.",
              invalidAmount: "Importo HElite non valido.",
              loadError: "Errore recupero ospiti HElite",
              invalidCheckoutTotal: "Totale checkout non valido",
              paymentRoomCharge: "Addebito HElite",
              restaurantChargeDescription: "Addebito ristorante {{room}}{{table}}",
              reservationRecipientRequired: "Selezionare cliente, azienda o ospite HElite per la prenotazione",
              reservationGuestsRequired: "Indicare quanti posti sono da prenotare",
              reservationDateTimeRequired: "Selezionare data e fascia oraria",
              reservationTableRequired: "Selezionare almeno un tavolo",
              reservationInvalidTimeRange: "Intervallo orario non valido",
              reservationPastDate: "La data della prenotazione e nel passato.",
            },
            sameClient: "StessoCliente?",
            Passante: "Passante",
            openDrawer: "apri menu",
            Cliente: "Cliente",
            Orders: "Ordini",
            removeTimeSlot: "Rimuovi fascia oraria",
            togglePasswordVisibility: "Mostra/nascondi password",
            orderList: "Lista Ordini",
            delete_button: 'Cancella',
            orderDetail: "Dettaglio Ordine per",
            orderDetails: "Dettaglio Comanda",
            seeOrder: "Visualizza Ordine",
            send_order: "Invia Comanda",
            follow: "Segue",
            yes: "Si",
            no: "No",
            clearAllTablesAndPay: "[DEV] LIBERA TAVOLI e PAGA ORDINI",
            allTablesAlreadyFree: "Tutti i tavoli sono già liberi e/o tutti gli ordini sono già stati pagati!",
            showPic: "Mostra Immagini",
            hidePic: "Nascondi Immagini",
            systemSettings: {
              page: "Impostazioni Sistema",
              pageSubtitle: "Configura le preferenze operative predefinite del sistema.",
              showOrderImages: "Mostra immagini nella presa ordini",
              showOrderImagesHelp: "Mostra o nascondi le immagini dei prodotti durante la presa ordini.",
              kitchenPrintMenuName: "Stampa il nome del menu nelle comande",
              kitchenPrintMenuNameHelp: "Aggiunge tra parentesi il nome del menu a prezzo fisso accanto a ogni piatto scelto.",
              kitchenPrintMenuNameOn: "Visibile",
              kitchenPrintMenuNameOff: "Nascosto",
              orderPrintFontSize: "Dimensione testo comanda e preconto",
              orderPrintFontSizeHelp: "Imposta la dimensione degli articoli nelle stampe di comanda, ristampa, differenziale e preconto.",
              printFontSmall: "Piccolo",
              printFontNormal: "Normale",
              printFontLarge: "Grande",
              defaultTableMapView: "Vista predefinita mappa tavoli",
              defaultTableMapViewHelp: "Imposta la vista iniziale all'apertura della Mappa Tavoli.",
              draftPrintersLabel: "Stampanti preconto",
              draftPrintersHelp: "Queste stampanti verranno usate per il preconto (indipendente dagli articoli).",
              invoiceCourtesyPrintersLabel: "Stampanti copie cortesia fattura",
              invoiceCourtesyPrintersHelp: "Queste stampanti verranno usate per stampare copie cortesia compatte delle fatture.",
              defaultVatRate: "IVA predefinita (%)",
              defaultVatRateHelp: "Viene usata quando una categoria prodotto non ha un'aliquota IVA specifica.",
              defaultVatRateInvalid: "Inserisci un'aliquota IVA compresa tra 0 e 100.",
              defaultVatRateSaved: "Aliquota IVA predefinita salvata con successo.",
              congressAgendaColors: "Colori agenda sale congressi",
              congressAgendaColorsHelp: "Configura i colori usati nel planner per confermati, Check-in, completati e preventivi scaduti.",
              none: "Nessuna",
              ready: "Pronto",
              sectionGeneral: "Generale",
              sectionBilling: "Fatturazione",
              sectionEasyInvoice: "EasyInvoice",
              tenantTypes: {
                SALE_CONGRESSI: "Sale congressi",
                RISTORANTE: "Ristorante",
                SPA: "Spa",
              },
              billingOwnerData: "Dati Cedente Prestatore",
              billingOwnerDataHelp: "Dati fiscali usati nei documenti e nelle integrazioni.",
              ownerName: "Nome/Ragione Sociale",
              ownerSurname: "Cognome (se persona fisica)",
              ownerTaxCode: "Codice Fiscale",
              ownerVat: "Partita IVA",
              ownerAddress: "Indirizzo",
              ownerPostalCode: "CAP",
              ownerCity: "Città",
              ownerProvince: "Provincia",
              ownerEmail: "Email",
              ownerPhone: "Telefono",
              edit: "Modifica",
              save: "Salva",
              saving: "Salvataggio...",
              cancel: "Annulla",
              saveBillingSuccess: "Dati di fatturazione salvati con successo.",
              easyInvoiceTitle: "Credenziali di accesso",
              easyInvoiceHelp: "Credenziali per il collegamento al servizio EasyInvoice.",
              saveEasyInvoiceSuccess: "Credenziali salvate con successo.",
              user: "User",
              password: "Password",
              client_id: "Client ID",
              secret: "Secret",
              saveEasyInviceSuccess: "Credentials saved successfully.",
              validation: {
                ownerNameRequired: "Inserisci almeno il nome o la ragione sociale.",
                provinceTooLong: "La provincia deve avere massimo 2 caratteri.",
                emailInvalid: "Email non valida.",
              },
              smtp: {
                title: "Configurazione SMTP",
                help: "Server email usato dal tenant per inviare preventivi, riepiloghi e comunicazioni.",
                portInvalid: "PORTA_SMTP deve essere un numero tra 1 e 65535.",
                passwordPlaceholder: "Password salvata: lascia vuoto per mantenerla.",
                saveSuccess: "Configurazione SMTP salvata con successo.",
              },
              logo: {
                title: "Logo",
                empty: "Nessun logo caricato",
                upload: "Carica logo",
                change: "Cambia logo",
                remove: "Rimuovi",
                alt: "Logo tenant",
                invalidType: "Carica un logo PNG, JPG, WEBP o SVG.",
                tooLarge: "Il logo deve essere inferiore a 2 MB.",
                readError: "Impossibile leggere il file selezionato.",
                saveSuccess: "Logo salvato con successo.",
              },
              pms: {
                title: "PMS HElite",
                help: "Credenziali per il collegamento al PMS HElite.",
                urlInvalid: "URL HElite non valido.",
                passwordPlaceholder: "Password salvata: lascia vuoto per mantenerla.",
                saveSuccess: "Configurazione PMS salvata con successo.",
              },
            },
            departments: {
              title: "Reparti",
              subtitle: "Gestisci i reparti operativi e collega gli utenti che devono ricevere o gestire le note dei servizi.",
              conferenceOnly: "Questa anagrafica e disponibile solo per sale congressi.",
              newDepartment: "Nuovo reparto",
              editDepartment: "Modifica reparto",
              registryTitle: "Anagrafica reparti",
              registrySubtitle: "Cucina, manutenzione, accoglienza, tecnica audio/video, ecc.",
              department: "Reparto",
              status: "Stato",
              users: "Utenti",
              actions: "Azioni",
              noDescription: "Nessuna descrizione",
              empty: "Nessun reparto configurato.",
              usersTitle: "Utenti e reparti",
              usersSubtitle: "Ogni utente puo appartenere a uno o piu reparti.",
              assignedDepartments: "Reparti associati",
              departmentName: "Nome reparto",
              description: "Descrizione",
              departmentActive: "Reparto attivo",
              userFallback: "Utente {{id}}",
              validation: { nameRequired: "Inserisci il nome del reparto." },
              loadError: "Errore nel caricamento reparti.",
              created: "Reparto creato.",
              updated: "Reparto aggiornato.",
              saveError: "Errore salvataggio reparto.",
              deleteConfirm: "Eliminare il reparto \"{{name}}\"?",
              deleted: "Reparto eliminato.",
              deleteError: "Errore eliminazione reparto.",
              userDepartmentsUpdated: "Reparti utente aggiornati.",
              userDepartmentsError: "Errore aggiornamento reparti utente.",
            },
            setups: {
              shortLabel: "Allestimenti",
              title: "Allestimenti sale",
              subtitle: "Anagrafica libera per configurazioni come ferro di cavallo, palcoscenico, platea o setup personalizzati.",
              conferenceOnlyTitle: "Anagrafica disponibile solo per sale congressi",
              conferenceOnlySubtitle: "Per i ristoranti resta valida la normale gestione pacchetti/menu, senza questa anagrafica allestimenti.",
              newSetup: "Nuovo allestimento",
              editSetup: "Modifica allestimento",
              search: "Cerca allestimenti",
              noPhoto: "Nessuna foto",
              photoCount: "Foto: {{count}}",
              empty: "Nessun allestimento trovato.",
              setupName: "Nome allestimento",
              description: "Descrizione",
              setupActive: "Allestimento attivo",
              uploadImages: "Carica immagini",
              imageAlt: "Allestimento",
              validation: { nameRequired: "Inserisci il nome dell'allestimento." },
              loadError: "Errore nel caricamento allestimenti",
              uploadError: "Errore upload immagini",
              saved: "Allestimento salvato.",
              saveError: "Errore salvataggio allestimento",
              deleteConfirm: "Eliminare l'allestimento \"{{name}}\"?",
              deleted: "Allestimento eliminato.",
              deleteError: "Errore eliminazione allestimento",
            },
            usageTypes: {
              title: "Tipi di utilizzo",
              subtitle: "Definisci categorie libere come meeting, formazione, assemblea, evento privato.",
              conferenceOnly: "Questa anagrafica e disponibile solo per sale congressi.",
              newType: "Nuovo tipo",
              newUsageType: "Nuovo tipo di utilizzo",
              editType: "Modifica tipo di utilizzo",
              name: "Nome",
              description: "Descrizione",
              typeActive: "Tipo attivo",
              noDescription: "Nessuna descrizione.",
              empty: "Nessun tipo di utilizzo configurato.",
              validation: { nameRequired: "Inserisci il nome del tipo di utilizzo." },
              loadError: "Errore nel caricamento tipi di utilizzo.",
              created: "Tipo di utilizzo creato.",
              updated: "Tipo di utilizzo aggiornato.",
              saveError: "Errore salvataggio tipo di utilizzo.",
              deleteConfirm: "Eliminare il tipo di utilizzo \"{{name}}\"?",
              deleted: "Tipo di utilizzo eliminato.",
              deleteError: "Errore eliminazione tipo di utilizzo.",
            },
            congressReservations: {
              validation: {
                eventNameRequired: "Inserisci il nome evento/pratica.",
                quoteEmailRequired: "Per il preventivo e obbligatoria una email destinatario valida.",
                sendEmailRequired: "Per inviare la mail serve una email destinatario valida.",
                dayRequired: "Inserisci almeno una giornata.",
                dayDateTimeRequired: "Completa date e orari delle giornate.",
                dayEndAfterStart: "Ogni giornata deve avere un orario finale successivo all'inizio.",
                guestsPositive: "Gli ospiti devono essere maggiori di zero.",
                roomRequiredForReservation: "Per convertire in prenotazione devi assegnare almeno una sala per ogni giornata.",
                departmentRequired: "Per ogni servizio seleziona il reparto di riferimento.",
                serviceTimeOutsideDay: "L'orario di erogazione {{time}} per {{service}} nella {{day}} deve essere tra {{start}} e {{end}}.",
              },
              loadError: "Errore nel caricamento dati congressi.",
              emailSubject: {
                quote: "Preventivo - {{name}}",
                confirmed: "Conferma prenotazione - {{name}}",
                option: "Opzione prenotazione - {{name}}",
                summary: "Riepilogo evento - {{name}}",
              },
              rowCategory: {
                serviceDepartment: "Servizio - {{department}}",
                extraDepartment: "Extra - {{department}}",
                extra: "Extra",
              },
              genericClientNameRequired: "Inserisci prima il nominativo del cliente generico.",
              genericClientCreated: "Cliente creato e agganciato alla pratica.",
              genericClientCreateError: "Errore nella creazione cliente.",
              genericCompanyNameRequired: "Inserisci prima il nome della ditta generica.",
              genericCompanyCreated: "Azienda creata e agganciata alla pratica.",
              genericCompanyCreateError: "Errore nella creazione azienda.",
              mailWarning: "Pratica salvata, ma email non inviata: {{error}}.",
              sendError: "errore invio",
              practiceSaved: "Pratica salvata.",
              practiceSavedWithWarning: "Pratica salvata. {{warning}}",
              practiceSaveError: "Errore nel salvataggio pratica.",
              savingPractice: "Salvataggio pratica...",
              cancellationReasonRequired: "Inserisci il motivo dell'annullamento.",
              cancelConfirmWithPrepayments: "Questa pratica ha ancora {{amount}} di acconti residui. Annullarla comunque?",
              cancelPracticeWarningTitle: "Acconti residui",
              confirmActionHelp: "Controlla il saldo aperto prima di continuare.",
              reservationConfirmed: "Prenotazione confermata.",
              reservationConfirmError: "Errore conferma prenotazione.",
              restoreCheckIn: "Ripristina prenotazione",
              restoreCheckInTitle: "Ripristina check-in",
              restoreCheckInConfirm: "Ripristinare il check-in di \"{{name}}\" e riportare l'evento a prenotazione confermata?",
              restoreCheckInHelp: "Usa questa azione solo per correggere un errore dell'operatore.",
              restoreCheckInSuccess: "Check-in ripristinato. L'evento è tornato una prenotazione confermata.",
              restoreCheckInError: "Errore durante il ripristino del check-in.",
              deleteConfirm: "Eliminare \"{{name}}\"?",
              deleteConfirmWithPrepayments: "Questa pratica ha ancora {{amount}} di acconti residui. Eliminarla comunque?",
              deletePracticeTitle: "Elimina pratica",
              deletePracticeWarningTitle: "Elimina pratica con acconti",
              practiceDeleted: "Pratica eliminata.",
              practiceDeleteError: "Errore eliminazione pratica.",
              practiceDeleteBlockedByPrepayments: "Questa pratica non puo essere eliminata perche ha storico acconti collegato. Annulla o storna prima i movimenti finanziari.",
              practiceDeleteBlockedByAccount: "La pratica non può essere eliminata perché è già stato emesso un conto.",
              plannerStartDate: "Data di partenza",
              serviceQuantityOverageTitle: "Quantità servizi superiore agli ospiti",
              serviceQuantityOverageConfirm: "Alcuni servizi superano il numero degli ospiti della sala:\n{{details}}\n\nVuoi salvare comunque?",
              saveAnyway: "Salva comunque",
              assignRoomBeforeCheckout: "Assegna una sala prima di andare in cassa.",
              compatibilityUpdated: "Compatibilita allestimenti aggiornata.",
              compatibilityUpdateError: "Errore aggiornamento compatibilita.",
              pdfError: "Errore generazione PDF.",
              summaryEmailSent: "Riepilogo inviato via email.",
              summaryEmailError: "Errore invio riepilogo.",
              goToCheckout: "Vai in punto cassa",
              editPractice: "Modifica pratica",
              newPractice: "Nuova pratica",
              freeRecipientVat: "Partita IVA destinatario libero",
              freeRecipientEmail: "Email destinatario libero",
              optionalClient: "Cliente (opzionale)",
              clientVat: "Partita IVA cliente",
              clientEmail: "Email cliente",
              optionalCompany: "Azienda (opzionale)",
              companyVat: "Partita IVA azienda",
              companyEmail: "Email azienda",
              activeFlag: "Attiva",
              cancellationReason: "Motivo annullamento",
              cancellationReasonHelp: "Obbligatorio quando la pratica viene annullata.",
              cancellationReasonPlaceholder: "Scrivi il motivo dell'annullamento...",
              emailAddresses: "Indirizzi email",
              emailAddressesHelp: "Puoi inserire piu indirizzi separati da virgola, punto e virgola o a capo.",
              none: "Nessuno",
              setupNotePlaceholder: "Es. disposizione palco, microfoni, manutenzione...",
              rowNotePlaceholder: "Es. senza glutine, predisporre tecnico, passaggio manutenzione...",
              quoteRow: "Riga preventivo",
              attachment: "Allegato",
              savedAttachment: "{{name}} (salvato)",
              emailPreview: "Anteprima e-mail",
              defaultQuoteEmailMessage: "La ringraziamo per il suo interesse. Di seguito trova il preventivo dettagliato per i servizi richiesti. La data di validita del preventivo e indicata di seguito. Siamo a disposizione per qualsiasi chiarimento o modifica.",
              defaultConfirmationEmailMessage: "Confermiamo i dettagli della prenotazione riportati di seguito. Restiamo a disposizione per eventuali richieste o modifiche.",
              send: "invio",
              resends: "reinvii",
              moreThan: "piu di",
              prepayments: {
                action: "Acconti",
                column: "Acconti",
                title: "Acconti - {{name}}",
                eventTotal: "Totale evento",
                totalDeposits: "Depositi",
                totalAdvances: "Anticipi fiscali",
                totalPrepayments: "Totale acconti",
                amountDue: "Residuo da pagare",
                remainingShort: "{{amount}} residuo",
                sessionInfo: "Totali e movimenti vengono caricati dallo storico acconti del backend.",
                loadingSummary: "Caricamento storico acconti...",
                summaryLoadError: "Impossibile caricare lo storico acconti.",
                receive: "Ricevi acconto",
                refund: "Rimborsa",
                deposit: "Deposito",
                fiscalAdvance: "Anticipo fiscale",
                defaultDescription: "Acconto {{name}}",
                amount: "Importo",
                refundAmount: "Importo rimborso",
                paymentMethod: "Metodo pagamento",
                vatRate: "Aliquota IVA",
                vatNature: "Natura IVA",
                document: "Documento",
                refundDocument: "Documento rimborso",
                invoiceId: "ID fattura",
                creditNoteId: "ID nota di credito",
                documentNumber: "Numero documento",
                documentDate: "Data documento",
                description: "Descrizione",
                notes: "Note",
                noRefundable: "Nessun movimento rimborsabile disponibile in questa sessione. Serve lo storico acconti dal backend per rimborsare dopo un refresh.",
                sourceMovement: "Movimento da rimborsare",
                originalDocument: "Documento originale: {{documentType}} {{documentNumber}}",
                movementOption: "#{{id}} - {{type}} - {{amount}} - {{documentType}}",
                movementOptionAvailable: "#{{id}} - {{type}} - originale {{amount}} - disponibile {{available}} - {{documentType}}",
                register: "Registra",
                saving: "Salvataggio...",
                receivedSuccess: "Acconto registrato.",
                refundSuccess: "Rimborso registrato.",
                reverseSuccess: "Acconto stornato.",
                fullReversalInfo: "Questo anticipo fiscale verra stornato per intero: {{amount}}.",
                invoiceDelivery: {
                  SENT: "Fattura #{{invoiceId}} salvata e inviata.",
                  FAILED: "Movimento e fattura #{{invoiceId}} salvati, ma l'invio e fallito. Riprova dai documenti emessi. {{message}}",
                  SKIPPED: "Movimento salvato. Fattura #{{invoiceId}} gia inviata o in lavorazione.",
                },
                paymentMethods: {
                  cash: "Contanti",
                  card: "Carta",
                  bankTransfer: "Bonifico",
                  voucher: "Voucher",
                  roomCharge: "Addebito camera",
                },
                documentTypes: {
                  commercialDocument: "Documento commerciale",
                  invoiceTd02: "Fattura acconto TD02",
                  plainReceiptRefund: "Ricevuta rimborso",
                  commercialCancellation: "Annullamento commerciale",
                  commercialReturn: "Reso commerciale",
                  creditNoteTd04: "Nota di credito TD04",
                },
                vatNatureOptions: {
                  N1: "N1",
                  N2: "N2",
                  N3: "N3",
                  N4: "N4",
                  N5: "N5",
                  N6: "N6",
                  N7: "N7",
                },
                validation: {
                  validAmountRequired: "Inserisci un importo valido.",
                  sourceRequired: "Seleziona il movimento da rimborsare.",
                  td04IdRequired: "Inserisci l'ID della nota di credito TD04.",
                  refundDocumentRequired: "Completa numero e data del documento di rimborso.",
                  vatRateRequired: "Inserisci un'aliquota IVA valida.",
                  descriptionRequired: "Inserisci la descrizione dell'anticipo.",
                  td02IdRequired: "Inserisci l'ID della fattura TD02.",
                  vatNatureRequired: "Seleziona la natura IVA per una TD02 a IVA zero.",
                  commercialDocumentRequired: "Completa numero e data del documento commerciale.",
                },
                errors: {
                  exceedsTotal: "Gli acconti superano il totale pratica. Totale: {{practiceTotal}}, gia registrati: {{currentPrepayments}}, richiesti: {{requestedAmount}}.",
                  refundExceeds: "Il rimborso supera il disponibile. Disponibile: {{refundableAmount}}, richiesto: {{requestedAmount}}.",
                  idempotencyKeyReused: "Richiesta gia usata con dati diversi. Riprova l'operazione.",
                  invalidReversalDocument: "Questo anticipo richiede {{documentType}}.",
                  td02NotSent: "La fattura TD02 deve essere inviata correttamente prima di stornarla con TD04.",
                  generic: "Errore registrazione acconto.",
                },
              },
            },
            orderSummary: "Riepilogo Comanda",
            noProductPresent: "Nessun prodotto presente nella Comanda",
            perPerson: "a persona",
            description: "Descrizione",
            addTimeSlot: "Aggiungi fascia oraria",
            visible: "Visibile",
            wait: "Attesa",
            guests: "Ospiti",
            noOrders: "Nessun Ordine Attivo",
            realTimeOrders: "Ordini Tempo Reale",
            newOrder: "Nuovo Ordine",
            closeBill: "Chiudi Conto",
            addTable: "Aggiungi Tavolo",
            singleCreate: "Creazione Singola",
            bulkCreate: "Creazione Multipla",
            noTable: "Nessun tavolo disponibile",
            No_table_selected: "Nessun tavolo selezionato",
            tableSession: {
              inUse: "In carico ad un altro operatore",
            },
            menu: "Menu",
            edit_product: 'Modifica Prodotto',
            invalidRoleSelected: "Ruolo selezionato non valido",
            support: "Aiuto",
            dailySales: "Vendite giornaliere (ultimi giorni)",
            total: "Totale",
            occupiedTables: "Tavoli Occupati",
            noTableOccupied: "Nessun Tavolo Occupato",
            confirmReservationClient: "Confermi che è il cliente della prenotazione?",
            transferOrder: "Trasferimento Comanda",
            syncRequests: "Sincronizza {{count}} richieste",
            confirmSeats: "Conferma il numero di posti",
            addTableQuestion: "Aggiungere tavolo?",
            activeOrders: "Ordini Attivi",
            avgTime: "Tempo Medio",
            revenueToday: "Incasso di Oggi",
            split: "Dividi Comanda",
            mostSold: "Prodotti più venduti",
            sold: "Venduti",
            checkoutPage: "Punto Cassa",
            noEventsInRange: 'Non ci sono eventi in questo intervallo.',
            tableMapPage: {
              columnNames: {
                name: "NOME",
                seats: "POSTI",
                status: "STATO"
              },
              print: "Stampa",
              reprintOrders: "Ristampa Comande",
              transferOrders: "Trasferisci Comande",
              transferFrom: "Trasferisci da:",
              transferTo: "Trasferisci a:",
              transferButton: "trasferisci",
              noTableInWaiting: "Nessun Tavolo In Attesa",
              noTableOccupied: "Nessun Tavolo Occupato",
              draftPayment: "Preconto",
              roomChargeCheckout: "Addebito camera",
              CRMclients: "Clienti CRM",
              seeOrders: "Vedi Ordini",
              minute: "Minuto",
              minutes: "Minuti",
              course: "Portata",
              details: "Dettaglio",
              close: "Chiudi",
              open: "Apri",
              sendToCheckout: "Manda in Cassa",
              error_move_product_1: "Errore nello spostamento del prodotto:",
              error_delete_order_1: "Errore cancellazione comanda:",
              error_patch_order_1: "Errore nella patch della comanda:",
        success_savedCoordinates: "Coordinate salvate su DB!",
              error_coordinates_table_1: "Errore nel recupero delle coordinate:",
              error_coordinates_table_2: "Errore nel salvataggio coordinate:",
              error_categories_1: "Errore nel recupero delle categorie:",
              error_transfer_order_1: "Errore durante il trasferimento della comanda",
              unknown_error: "Errore sconosciuto",
              error_print_1: "Errore durante la stampa della comanda",
            },
            sortName: "Ordina per Nome",
            sortPrice: "Ordina per Prezzo",
            showDetails: "Vedi",
            editLayout: "Modifica disposizione",
            editLayoutTitle: "Modifica disposizione tavoli",
            cancel: "Annulla",
            save: "Salva",
            confirm: "Conferma",
            select: "Seleziona",
            blankname: 'Il nome non può essere vuoto',
            work_selection: "Seleziona l'area in cui lavorerai oggi",
            operator: "Operatore",
            freetables: "Tavoli Liberi",
            activetables: "Tavoli Attivi",
            selectTable: "Seleziona un Tavolo",
            noTableSelected: "Nessun dato disponibile. Selezionare un tavolo.",
            formats: "Formati Supportati",
            generalstatus: "Stato Generale del Servizio",
            active: "Attiva",
            products: 'Prodotti',
            orders: 'Comande',
            select_orders: 'Seleziona Comande',
            selected_articles: 'Articoli Selezionati',
            variants: 'Varianti',
            reservation: 'Prenotazione',
            reservations: 'Prenotazioni',
            selectedOrders_alert: {
              successAddProduct: "Portata Aggiunta con successo!",
              orderSaved: "Ordine ricevuto e salvato con successo!",
              errExceedSeatingCapacity: "Numero coperti selezionato oltre limite massimo consentito dal tavolo",
            },
            handleCategory_alert: {
              errorAddCategory: "Errore nell'aggiunta della categoria:",
              errorAddSubCategory: "Errore nell'aggiunta della sottocategoria:",
              errorRecoveryCat: "Errore nel recupero della Categoria/Sottocategoria",
              errorUpdateCat: "Errore nell'aggiornamento della categoria:",
              errorUpdateSubCat: "Errore nell'aggiornamento della sottocategoria:",
              errorDeleteCat: "Errore nella cancellazione della categoria:",
              errorDeleteSubCat: "Errore nella cancellazione della sottocategoria:",
            },
            orderDetails_alert: {
              errorMoveProduct: "Errore nello spostamento del prodotto:",
              errorDeleteProduct: "Errore cancellazione comanda:",
              errorPatchProduct: "Errore nella patch della comanda:",
            },
      productList_alert:{
        success_dateslot: "Fascia oraria aggiornata per prodotto ID:",
        error_dateslot: "Errore aggiornamento fascia oraria:",
        success_duplicate: "Prodotto duplicato con successo",
        error_duplicate: "Errore durante la duplicazione del prodotto:",
      },
      menu_alert:{
        error_sorting:"Errore nell'ordinamento prodotti:",
      },
      modals_alert:{
        error_sending:"Errore invio comanda:",
        error_getTable:"Errore ottenimento tavolo:",
        error_createTable:"Errore creazione tavolo:",
        error_editTable:"Errore modifica tavolo:",
        error_deleteTable:"Errore cancellazione tavolo:",
        error_createRoom:"Errore creazione sala:",
        error_deleteRoom:"Errore cancellazione sala:",
      },
      user_alert:{
        error_registration: "Errore durante la registrazione:",
        error_updateUser: "Errore aggiornamento Utente:",
      },
            confirmClientQuestion: "Confermi che è il cliente della prenotazione?",
            booking: {
              name: "Nome cliente",
              guests: "Numero coperti",
              calendar_help: "Seleziona uno slot sul calendario o regola l'orario manualmente sotto",
              today: "Oggi",
              back: "Indietro",
              next: "Prossimo",
              week: "Settimana",
              day: "Giorno",
              event: "Evento",
              allDay: 'Tutto il giorno',
              work_week: 'Sett. Lavorativa',
              month: 'Mese',
              tomorrow: 'Domani',
              yesterday: 'Ieri',
              agenda: 'Agenda',
              date: "Data",
              time: "Ora",
              room: "Sala",
              table: "Tavolo",
              notes: "Note",
              submit: "Invia prenotazione",
              error: "Errore prenotazione:",
              room_error: "Errore nel recupero delle stanze:",
        packagesLabel: "Pacchetti (opzionale)",
        packagesSelect: "Seleziona pacchetti",
        packagesBookedNoteTitle: "Pacchetti prenotati",
        packageFallbackName: "Pacchetto",
      },
      orderPackages: {
        label: "Pacchetto",
        tastingMenu: "Menu degustazione",
        select: "Seleziona pacchetto",
        add: "Aggiungi pacchetto",
        invalidSelection: "Nessun pacchetto valido selezionato",
        addedSuccess: "Pacchetto aggiunto alla comanda",
            },
            list_reservation: "Lista prenotazioni",
            reservations_details: {
              title: "Prenotazioni",
              client: "Cliente",
              table: "Tavolo",
              room: "Stanza",
              date: "Data Prenotazione",
              status: "Stato",
              change_status: "Cambia stato",
              status_update_error: "Errore nell'aggiornamento stato",
              status_values: {
                TO_CONFIRM: "Da confermare",
                CONFIRMED: "Confermata",
                COMPLETED: "Completata",
                CANCELLED: "Annullata",
                NO_SHOW: "No-show",
              },
              cancellation_reason: "Motivo annullamento",
              cancellation_reason_placeholder: "Scrivi il motivo dell'annullamento",
              provide_cancellation_reason: "Inserisci il motivo dell'annullamento",
              add_cancellation_reason: "Per impostare lo stato su annullata, inserisci un motivo.",
              createdAt: "Creato il",
              clientDetails: "Dettagli Cliente",
              edit_pending_hint: "Questa prenotazione è da confermare. Puoi modificare data, orario, ospiti, tavolo e note.",
              edit_booking: "Modifica prenotazione",
              save_booking: "Salva modifiche prenotazione",
              save_booking_error: "Errore nell'aggiornamento prenotazione",
              error: "Errore",
              none: "Nessuna prenotazione trovata",
              noClient: "Nessun Cliente",
              noOrder: "Nessun Ordine"
            },
            clearModal: {
              dialogTitle: "Conferma liberazione tavolo",
              dialogAlert: "Sei sicuro di voler liberare il tavolo",
            },
            chart: {
              title: "Distribuzione degli Ordini",
              noData: "Nessun ordine trovato per la stanza selezionata",
              loading: "Caricamento dati...",
            },
            selectRoom: "Seleziona stanza",
            hello: "Ciao",
            selected: "Selezionato",
            quantity: "Quantità",
            no_room: 'Nessuna sala disponibile',
            room: 'Stanza',
            add_product: 'Aggiungi Prodotto',
            new_product: 'Nuovo Prodotto',
            delete_product: "Elimina prodotto",
            tables: 'Mappa dei Tavoli',
            new_room_name: 'Nuovo Nome Sala',
            new_table: 'Nuovo Tavolo',
            add_table: 'Aggiungi tavolo',
            edit_table: 'Modifica Tavolo',
            table_name: 'Nome Tavolo',
            table_name_prefix: 'Prefisso',
            table_name_suffix: 'Suffisso',
            table_quantity: 'Quantità Tavoli',
            selected_table: 'Tavolo Selezionato',
            deleteTableRequestTitle: "Conferma Eliminazione Tavolo",
            deleteTableRequest: "Sei sicuro di voler eliminare questo tavolo? L'operazione non potrà essere annullata.",
            deleteRoomRequestTitle: "Conferma Eliminazione Sala",
            deleteRoomRequest: "Attenzione! Eliminando questa sala eliminerai permanentemente anche tutti i tavoli ad essa associati. Vuoi procedere ugualmente?",
            allTablesCleared: "Tutti i tavoli sono stati liberati e/o tutti gli ordini sono stati pagati!",
            courseAddedSuccess: "Portata Aggiunta con successo!",
            addRoom: 'Aggiungi Sala',
            editRoom: 'Modifica Sala',
            deleteRoom: 'Elimina Sala',
            roomName: "Nome Sala",
            seatNumber: "Nr Posti",
            seats: "posto/i",
            occupiedSeats: "Posti Occupati",
            add_button: 'Aggiungi',
            update_button: "Aggiorna",
            cancel_button: 'Annulla',
            changeTo_it: 'Cambia in IT',
            changeTo_en: 'Cambia in ENG',
            changeTo_sq: 'Cambia in SQ',
            dashboard: 'Dashboard',
            welcome_message: 'Benvenuto alla pagina iniziale',
            email: 'Email',
            password: "Password",
            product: "Prodotto",
            product_name: 'Nome',
            price: 'Prezzo',
            category: 'Categoria',
            subcategory: 'Sottocategoria',
            cover_room: 'Sala associata',
            cover_room_default: 'Tutte le sale (predefinito)',
            product_room: 'Sala associata',
            product_room_all: 'Tutte le sale',
            product_printer_targets: 'Stampanti articolo',
            bulkPrinters: {
              selectVisible: 'Seleziona visibili',
              deselectVisible: 'Deseleziona visibili',
              selectedCount: '{{count}} selezionati',
              assignPrinters: 'Assegna stampanti',
              title: 'Assegna stampanti di reparto',
              productsSelected: '{{count}} prodotti selezionati',
              noPrintersConfigured: 'Nessuna stampante configurata. Configura prima le stampanti di reparto.',
              printers: 'Stampanti',
              saving: 'Salvataggio...',
              assign: 'Assegna',
              selectProductFirst: 'Seleziona almeno un prodotto.',
              selectPrinterFirst: 'Seleziona almeno una stampante.',
              updatedSuccess: 'Stampanti aggiornate su {{count}} prodotti.',
              assignError: 'Errore durante assegnazione stampanti.',
            },
            bulkDelete: {
              selectVisible: 'Seleziona visibili',
              deselectVisible: 'Deseleziona visibili',
              selectedCount: '{{count}} selezionati',
              deleteSelected: 'Elimina selezionati',
              productsTitle: 'Elimina articoli',
              productsConfirm: 'Eliminare definitivamente i {{count}} articoli selezionati?',
              categoriesTitle: 'Elimina categorie',
              categoriesConfirm: 'Eliminare definitivamente le {{count}} categorie selezionate?',
              confirm: 'Elimina',
              deleting: 'Eliminazione...',
              productsDeleted: '{{count}} articoli eliminati.',
              categoriesDeleted: '{{count}} categorie eliminate.',
              deleteProductsError: 'Errore durante eliminazione degli articoli.',
              deleteCategoriesError: 'Errore durante eliminazione delle categorie.',
            },
            NoCategory: "Senza categoria",
            waiter: 'Cameriere',
            time: 'Tempo',
            no_products: 'Nessun prodotto trovato',
            addImage: "Aggiungi Immagine",
            changeImage: "Cambia Immagine",
            fromTime: 'Da',
            toTime: 'A',
            Standard: "Vista Standard",
            Detailed: "Vista Dettagliata",
            stats: { page: "Statistiche" },
            allRoom: "Tutte le sale",
            selectDate: "Seleziona una data e ora dal calendario",
            user_management: {
              page: "Utenti",
              title: "Gestione Utenti",
              add_edit_title: "Aggiungi / Modifica Utente",
              name: "Nome",
              surname: "Cognome",
              email: "Email",
              role: "Ruolo",
              password: "Password",
              new_password: "Nuova Password",
              cancel_button: "Annulla",
              active: "Attivo",
              inactive: "Disattivo",
              add_button: "Aggiungi",
              update_button: "Aggiorna",
              user_list: "Lista Utenti",
              noUserAvailable: "Nessun utente disponibile",
            },
            manage_categories: {
              page: "Categorie",
              title: "Configurazione Listino Servizi - Categorie e Sottocategorie",
              category_name: "Nome Categoria",
              new_category: "Nuova Categoria",
              add_category: "Aggiungi Categoria",
              add_subcategory: "Aggiungi Sottocategoria",
              add_button: "Aggiungi",
              vat_rate: "IVA (%)",
              vat_short: "IVA",
              vat_default: "IVA predefinita",
              vat_default_help: "Lascia vuoto per usare l'IVA predefinita del tenant.",
              vat_invalid: "Inserisci un'aliquota IVA compresa tra 0 e 100.",
              order_help: "Trascina le categorie oppure usa le frecce per scegliere l'ordine mostrato nella comanda.",
              drag: "Trascina per spostare",
              move_up: "Sposta su",
              move_down: "Sposta giu",
              order_error: "Impossibile salvare l'ordine delle categorie: ",
            },
            checkout_page: {
              delete: "Elimina",
              invoice: "Fattura",
              surcharge: "Maggioraz.",
              edit_price: "Modifica Prezzo",
              clear_percent: "Rimuovi %",
              remove_discount: "Rimuovi Sconto",
              move_to_pending: "Metti In Attesa",
              edit_qty: "Modifica Quantità",
              split: "Dividi",
              print: "Stampa",
              subtotal: "SubTotale",
              closeCheckout: "Chiudi Cassa",
              partialPayment: "Pagamento parziale",
              totalPayment: "Pagamento totale",
              printInvoice: "Crea fattura",
              invoiceCloseConfirmTitle: "Fattura creata",
              invoiceCloseConfirmNote: "Chiudi la cassa senza pagamento oppure esci e lascia l'ordine aperto per il pagamento.",
              closeCheckoutWithoutPayment: "Chiudi cassa",
              exitInvoiceCloseConfirm: "Esci",
              invoiceCheckoutClosed: "Cassa chiusa senza pagamento.",
              toPay: "Da Pagare",
              searchProduct: "Cerca Prodotto",
              noRegisteredOrders: "Nessun Ordine Registrato",
              NoCategory: "Nessuna Categoria trovata",
              totalPaid: "Totale Pagato",
              confirmedPayment: "Pagamento Confermato!",
              confirmedPayment_note: "Il pagamento è andato a buon fine.",
              referenceNumber: "Numero Riferimento",
              paymentDate: "Data Pagamento",
              paymentMethod: "Metodo Pagamento",
              send: "Invia",
              pending: "In Attesa",
              occupied: "Occupato",
              toCheckout: "Alla Cassa",
              editPrice_note_1: "Nessun prodotto selezionato per la modifica del prezzo",
              editPrice_note_2: "Seleziona i prodotti da modificare, oppure nessuno per applicare a tutti",
              splitWeightProductWarning: "Non puoi dividere prodotti venduti a peso",
              editQty_note_1: "Nessun prodotto selezionato per la modifica della Quantità",
              editQty_note_2: "Seleziona un prodotto alla volta per la modifica della Quantità",
              delete_title: "Conferma Eliminazione Ordini",
              delete_note_1: "Nessun prodotto selezionato per l'eliminazione",
              delete_note_2: "Procedere con l'eliminazione? L'operazione non potrà essere annullata",
              delete_note_3: "errore durante la rimozione",
              delete_note_4: "Errore durante l'eliminazione dell'ordine",
              delete_note_5: "Errore durante la rimozione della comanda (divisi)",
              delete_note_6: "Errore durante la rimozione della comanda (uniti)",
              fetch_note_1: "Errore nel fetch prenotazioni",
              selectPaymentMethode: "Seleziona il metodo di Pagamento",
              cash:"Contanti",
              cards:"Carte",
              other:"Altro",
              newCounterSale: "Nuova vendita al banco",
              counterSale: "Vendita al banco",
              noBookedClient: "Nessun cliente prenotato",
              notBookedClient: "Non e il cliente prenotato",
              multipleCheckout: "Checkout multiplo",
              multipleCheckoutHelp: "Seleziona i tavoli da accorpare in un unico conto. Saranno inclusi tutti gli ordini aperti di ogni tavolo.",
              multipleCheckoutActiveWarning: "Checkout multiplo in corso: seleziona un tavolo per aggiungere articoli",
              multipleCheckoutMinOrders: "Seleziona almeno due ordini da accorpare",
              invalidCheckoutTotal: "Totale checkout non valido",
              multipleCheckoutOrderCount: "Checkout multiplo ({{count}} ordini)",
              orderColumn: "Ordine",
              itemsColumn: "Articoli",
              amount: "Importo",
              given: "Dato",
              rowChange: "Resto riga",
              addPaymentMethod: "+ Metodo",
              romanSplit: "Dividi in parti uguali",
              romanSplitParts: "Numero parti",
              remaining: "Restante",
              totalChange: "Resto totale",
              confirmPayment: "Conferma pagamento",
              cashGiven: "Contante dato",
              change: "Resto",
              prepaymentsLoading: "Caricamento acconti disponibili...",
              prepaymentsApplied: "Acconti applicati",
              amountDueAfterPrepayments: "Residuo dopo acconti",
              prepaymentsWillApply: "{{amount}} verranno applicati prima della chiusura.",
              noAvailablePrepayments: "Nessun acconto disponibile per questa chiusura.",
              zeroBalanceCovered: "Il saldo finale e gia coperto. Non serve un altro pagamento.",
              prepaymentsCovered: "Coperto da acconti",
              prepaymentApplyNote: "Applicato durante la chiusura finale",
              prepaymentsLoadError: "Impossibile caricare gli acconti per questo evento.",
              prepaymentApplyError: "Impossibile applicare gli acconti alla chiusura finale.",
              prepaymentCommercialVatBlocked: "L'anticipo supera il totale del documento commerciale finale con la stessa IVA.",
              prepaymentExceedsOrder: "Gli acconti selezionati superano il totale dell'ordine.",
              prepaymentOrderNotApplicable: "Non e possibile applicare gli acconti perche l'ordine e gia chiuso.",
              prepaymentSourceMissing: "Uno o piu acconti selezionati non sono piu disponibili.",
              prepaymentSourceInvalid: "Solo gli acconti incassati possono essere applicati in chiusura.",
              prepaymentAdvanceAlreadyApplied: "Questo anticipo fiscale e gia stato applicato.",
              prepaymentApplicationExceedsAvailable: "L'importo selezionato supera il saldo acconto disponibile.",
              prepaymentAdvanceMustApplyInFull: "Gli anticipi fiscali devono essere applicati per intero.",
              prepaymentInvalidFinalInvoice: "Una fattura di acconto o una nota di credito non puo essere usata come fattura finale.",
              prepaymentFinalInvoiceAlreadySent: "Gli acconti non possono modificare una fattura gia inviata.",
              prepaymentInvoiceNotFound: "Fattura finale non trovata.",
              prepaymentInvoiceVatBlocked: "L'anticipo supera il totale della fattura finale con la stessa IVA.",
              prepaymentInvoiceVatWarning: "Un anticipo supera il gruppo IVA corrispondente nella fattura finale. Continuare comunque?",
              invoicePrepaymentsWillApply: "{{amount}} di acconti verranno applicati alla fattura finale prima della chiusura.",
              prepaymentPos: {
                deposits: "Depositi",
                advances: "Anticipi",
                depositProducts: "Servizi deposito",
                advanceProducts: "Servizi anticipo",
                subtitle: "Stanza acconti dedicata a questa pratica.",
                receive: "Ricevi",
                refund: "Reso",
                reverse: "Storna",
                totalDeposits: "Totale depositi",
                totalAdvances: "Totale anticipi",
                paymentMethod: "Metodo pagamento",
                vatRate: "Aliquota IVA",
                vatNature: "Natura IVA",
                documentType: "Tipo documento",
                sourceMovement: "Movimento originale",
                invoiceId: "ID fattura",
                documentNumber: "Numero documento",
                documentDate: "Data documento",
                description: "Descrizione",
                note: "Nota",
                noEvent: "Seleziona una pratica Sale Congressi prima di aprire Depositi o Anticipi.",
                noProducts: "Nessun servizio deposito/anticipo trovato. Controlla nomi prodotti/categorie.",
                saved: "Movimento acconto salvato.",
                fiscalPending: "La stampa automatica del documento fiscale e ancora pending; inserisci manualmente i riferimenti dopo la stampa.",
                invoiceDelivery: {
                  SENT: "Fattura #{{invoiceId}} salvata e inviata.",
                  FAILED: "Movimento e fattura #{{invoiceId}} salvati, ma l'invio e fallito. Riprova dai documenti emessi. {{message}}",
                  SKIPPED: "Movimento salvato. Fattura #{{invoiceId}} gia inviata o in lavorazione.",
                },
                paymentMethods: {
                  CASH: "Contanti",
                  CARD: "Carta",
                  BANK_TRANSFER: "Bonifico",
                  VOUCHER: "Voucher",
                  ROOM_CHARGE: "Addebito camera",
                },
                documentTypes: {
                  COMMERCIAL_DOCUMENT: "Documento commerciale anticipo",
                  INVOICE_TD02: "Fattura acconto TD02",
                  COMMERCIAL_CANCELLATION: "Annullo commerciale",
                  COMMERCIAL_RETURN: "Reso commerciale",
                  CREDIT_NOTE_TD04: "Nota credito TD04",
                },
                vatNatureOptions: {
                  N1: "N1",
                  N2: "N2",
                  N3: "N3",
                  N4: "N4",
                  N5: "N5",
                  N6: "N6",
                  N7: "N7",
                },
                errors: {
                  amountRequired: "Inserisci un importo.",
                  sourceRequired: "Seleziona il movimento originale.",
                  documentRequired: "Inserisci numero e data documento.",
                  invoiceRequired: "Inserisci l'ID fattura.",
                  vatNatureRequired: "Seleziona la natura IVA per una TD02 a IVA zero.",
                  vatRequired: "Inserisci l'aliquota IVA.",
                  descriptionRequired: "Inserisci la descrizione dell'anticipo.",
                  exceedsTotal: "Gli acconti superano il totale pratica.",
                  refundExceeds: "Il reso supera l'importo disponibile.",
                  advanceProcessed: "Questo anticipo ha gia un reso o uno storno.",
                  td02NotSent: "La fattura TD02 deve essere inviata correttamente prima di stornarla con TD04.",
                  generic: "Errore salvataggio movimento acconto.",
                },
              },
              warning: "Avviso",
              incompleteBillingWarning: "Le informazioni del Cedente Prestatore non sono complete. Sistemale nella sezione Fatturazione delle impostazioni di sistema prima di generare una fattura.",
            },
            menu_config: {
              page: "Listino servizi",
              categories: "Categorie",
              category_name: "Nome Categoria",
              select_category: "Seleziona una categoria",
              product_ordering: "Ordinamento Prodotti",
              lunch: "Pranzo",
              dinner: "Cena",
              noProductsMenuFound: "Nessun prodotto trovato. Per favore controlla la disponibilità oraria dei prodotti.",
              save_order: "Salva ordinamento",
            },
            quickActions: {
              quickActions: "Azioni Rapide",
              closeOrder: "Chiudi Comanda",
              cashRegister: "Cassa",
              directAccess: "Accesso Diretto",
            },
            modalVariant: {
              title: "Varianti Prodotto",
              addVariant: "Aggiungi Variante",
              editVariant: "Modifica Variante",
              deleteVariant: "Elimina Variante",
              variantName: "Nome Variante",
              variantPrice: "Prezzo",
              variantDesc: "Note",
              delete_note: "Confermi eliminazione Variante?",
            },
            variantManagement: {
              title: "Varianti generiche",
              subtitle: "Crea una variante e collegala agli articoli.",
              addVariant: "Aggiungi variante",
              noVariants: "Nessuna variante configurata",
              priceLabel: "Prezzo: {{price}} EUR",
              linkedProductsCount: "{{count}} articoli collegati",
              linkProducts: "Collega articoli",
              editVariant: "Modifica variante",
              newVariant: "Nuova variante",
              variantName: "Nome variante",
              notes: "Note",
              linkedProducts: "Articoli collegati",
              searchProduct: "Cerca articolo",
              close: "Chiudi",
              deleteVariant: "Elimina variante",
              deleteConfirm: "Eliminare \"{{name}}\"? Verranno rimossi anche i collegamenti agli articoli.",
              linkedToProduct: "Collegata a questo articolo",
              notLinkedToProduct: "Non collegata a questo articolo",
              linkProductsTitle: "Collega articoli - {{name}}",
            },
            error_password_length: 'La password deve contenere almeno 8 caratteri.',
            error_password_upper: 'La password deve contenere almeno una lettera maiuscola.',
            error_password_lower: 'La password deve contenere almeno una lettera minuscola.',
            error_password_number: 'La password deve contenere almeno un numero.',
            error_password_special: 'La password deve contenere almeno un carattere speciale.',
            error_username_required: 'Nome utente richiesto',
            error_password_required: 'Password richiesta',
            error_password_incorrect: 'Password errata',
            error_products_load: 'Errore caricamento prodotti:',
            error_number_of_seats: "Il Numero di Tavoli Non Può Essere 0 o Inferiore",
            Logout: 'Disconnetti',
            LIBERO: "Libero",
            IN_ATTESA: "In Attesa",
            OCCUPATO: "Occupato",
            RISERVATO: "Riservato",
            NON_DISPONIBILE: "Non Disponibile",
            common: {
              actions: {
                create: "Crea",
                delete: "Elimina",
                cancel: "Annulla",
                save: "Salva",
                edit: "Modifica",
                refresh: "Aggiorna",
                retry: "Riprova",
                clearFilter: "Pulisci filtro",
              },
              status: { active: "attivo", inactive: "disattivo" },
              pagination: {
                rowsPerPage: "Righe per pagina:",
                displayedRows: "{{from}}-{{to}} di {{count}}"
              },
              errors: { loading: "Errore di caricamento", updateFailed: "Errore durante l'aggiornamento" },
              loading: "Caricamento in corso...",
              changeLanguage: "Cambia lingua",
              noResults: "Nessun risultato",
            },
            admin: {
              smtp: {
                title: "Predefiniti SMTP",
                help: "Questi valori vengono copiati nei nuovi tenant quando il backend li crea. Il tenant potra modificarli in seguito.",
              },
              tenants: {
                title: "Gestione Tenant",
                actions: { newTenant: "Nuovo tenant" },
                search: { placeholder: "Cerca tenant..." },
          miss: "TenantType mancante o invalido:",
                empty: {
                  noneTitle: "Nessun tenant creato",
                  noneSubtitle: "Crea il tuo primo tenant per iniziare.",
                  noResultsTitle: "Nessun risultato",
                  noResultsSubtitle: "Nessun tenant corrisponde ai filtri correnti."
                },
                table: { tenantId: "Tenant ID", id: "Id", tenantType: "Tipo Tenant", status: "Stato", createdAt: "Creato", actions: "Azioni" },
                switchAria: "Imposta tenant {{id}} {{state}}",
                dialogs: {
                  create: { title: "Crea nuovo tenant", label: "Tenant ID" },
                  edit: { title: "Modifica tenant" },
                  delete: {
                    title: "Conferma eliminazione tenant",
                    subtitle: "Per eliminare il tenant \"{{id}}\" inserisci la tua password.",
                    passwordLabel: "Password amministratore"
                  }
                },
                confirm: { delete: "Eliminare definitivamente il tenant {{id}}? Verrà rimosso anche il suo DB." },
                notifications: {
                  created: "Tenant creato",
                  deleted: "Tenant eliminato",
                  activated: "Tenant {{id}} attivato",
                  deactivated: "Tenant {{id}} disattivato"
                }
              },
              users: {
                title: "Gestione Utenti",
                tabs: { superadmin: "Superadmin", adminByTenant: "Admin per tenant" },
                search: { superadmin: "Cerca superadmin...", admin: "Cerca admin..." },
                buttons: {
                  newSuperadmin: "Nuovo Superadmin",
                  createSuperadmin: "Crea Superadmin",
                  newAdmin: "Nuovo Admin",
                  createAdmin: "Crea Admin"
                },
                empty: {
                  noSuperadminTitle: "Nessun superadmin",
                  noSuperadminSubtitle: "Crea il primo superadmin per accedere alla gestione globale.",
                  noAdminTitle: "Nessun admin",
                  noAdminSubtitle: "Questo tenant non ha ancora amministratori.",
                  noResultsTitle: "Nessun risultato",
                  noResultsSubtitleSuperadmin: "Nessun superadmin corrisponde ai filtri correnti.",
                  noResultsSubtitleAdmin: "Nessun admin corrisponde ai filtri correnti."
                },
                table: { name: "Nome", surname: "Cognome", email: "Email", actions: "Azioni" },
                dialogs: {
                  createUser: {
                    titleSuperadmin: "Crea Superadmin",
                    titleAdmin: "Crea Admin del tenant",
                    fields: { name: "Nome", surname: "Cognome", email: "Email", password: "Password", tenant: "Tenant" }
                  }
                },
                confirm: { deleteUser: "Eliminare {{email}}?" },
                notifications: {
                  superadminCreated: "Superadmin creato",
                  superadminDeleted: "Superadmin eliminato",
                  adminCreated: "Admin creato",
                  adminDeleted: "Admin eliminato"
                },
              }
            },
      allestimenti: {
        pageTitle: "Gestione pacchetti",
        pageSubtitle: "Crea pacchetti per prenotazioni e vendita diretta. Le sale congressi li possono usare nelle prenotazioni, i ristoranti come menu degustazione direttamente al tavolo.",
        pageTitleShort: "Allestimenti",
        summaryTotalPackages: "Pacchetti totali",
        summaryActivePackages: "Pacchetti attivi",
        summaryInactivePackages: "Pacchetti inattivi",
        searchPlaceholder: "Cerca pacchetti o servizi...",
        newPackage: "Nuovo pacchetto",
        productsAvailable: "Servizi disponibili",
        noProductsAvailable: "Nessun servizio disponibile",
        noProductsAvailableHint: "Crea i servizi dalla pagina prodotti per usarli qui.",
        packageStatusInactive: "Non attivo",
        packageStatusActiveNow: "Attivo ora",
        packageStatusOutOfTime: "Fuori fascia",
        packagePrice: "Prezzo",
        packageCapacity: "Capacita",
        packageCapacityPeople: "partecipanti",
        packageTimeRange: "Fascia oraria",
        includedProducts: "Servizi inclusi",
        packageContent: "Contenuto pacchetto",
        noPackagesFound: "Nessun pacchetto trovato",
        noPackagesHint: "Crea un pacchetto con i servizi disponibili.",
        editPackage: "Modifica pacchetto",
        newPackageModal: "Nuovo pacchetto",
        packageName: "Nome pacchetto",
        packageType: "Tipo",
        packageTypeStandard: "Pacchetto",
        packageTypeTastingMenu: "Menu degustazione",
        courseIndex: "Portata",
        courseName: "Nome portata",
        currentCourse: "Portata corrente",
        courseNameOptional: "Nome portata (opzionale)",
        nextCourse: "Segue",
        courseFlowHint: "Aggiungi gli articoli di questa portata, poi passa alla successiva.",
        capacity: "Capacita",
        manualPriceOptional: "Prezzo manuale (opzionale)",
        packageActive: "Pacchetto attivo",
        activeFrom: "Attivo dalle",
        activeTo: "Attivo fino alle",
        description: "Descrizione",
        selectIncludedProducts: "Seleziona servizi inclusi",
        remove: "Rimuovi",
        add: "Aggiungi",
        quantityShort: "Qta",
        uploadImages: "Carica immagini",
        uploadingImages: "Caricamento immagini...",
        imageFormats: "JPG, PNG, WEBP",
        selectionSummary: "Riepilogo selezione",
        selectedProducts: "Servizi selezionati",
        productsTotal: "Totale servizi",
        finalPackagePrice: "Prezzo finale pacchetto",
        cancel: "Annulla",
        saveChanges: "Salva modifiche",
        createPackage: "Crea pacchetto",
        deletePackageTitle: "Elimina pacchetto",
        deletePackageConfirm: "Sei sicuro di voler eliminare questo pacchetto?",
        delete: "Elimina",
      },
            billing: {
              page: "Fatturazione",
              subtitle: "Gestisci fatture, documenti commerciali e conti dimostrativi",
              actions: {
                newDocument: "Nuovo documento",
                export: "Esporta",
                exportSelected: "Esporta ({{count}})",
                exporting: "Esportazione...",
                view: "Visualizza",
                duplicate: "Duplica",
                print: "Stampa",
                download: "Scarica",
                sendSelectedInvoices: "Invia selezionate ({{count}})",
                sendingInvoices: "Invio...",
                sendInvoice: "Invia fattura",
                cancelInvoice: "Annulla fattura",
                printCourtesyCopy: "Stampa copia cortesia",
              },
              export: {
                selectAtLeastOne: "Seleziona almeno una fattura da esportare",
                success: "{{count}} fatture esportate",
                partialError: "Esportate {{success}} fatture, {{failed}} non esportate",
              },
              summary: {
                totalDocuments: "Documenti totali",
                totalDocumentsSubtitle: "Tutti i documenti emessi e in bozza",
                invoices: "Fatture",
                invoicesSubtitle: "Fatture fiscali",
                commercialDocuments: "Documenti commerciali",
                commercialDocumentsSubtitle: "Scontrini e documenti simili",
                totalAmount: "Totale importi",
                totalAmountSubtitle: "Somma dei totali visibili",
                title: "Fattura creata correttamente",
                subtitle: "Fattura creata correttamente. È possibile visualizzarla.",
                fileName: "Nome file",
                name: "Denominazione",
                date: "Data scadenza",
              },
              filters: {
                searchPlaceholder: "Cerca per numero, cliente, P.IVA/C.F., riferimento, sede, operatore",
                documentType: "Tipo documento",
                status: "Stato",
                from: "Da",
                to: "A",
                reset: "Reset",
              },
              table: {
                recordsFound: "record trovati",
                columns: {
                  isSent: "Inviato",
                  isSent_notes: "Messaggio",
                  documentType: "Tipo Documento",
                  number: "Numero",
                  date: "Data",
                  customer: "Cliente",
                  vatOrFiscalCode: "P.IVA/Codice Fiscale",
                  taxableAmount: "Imponibile",
                  vat: "IVA",
                  total: "Totale",
                  paymentMethod: "Metodo Pagamento",
                  status: "Stato",
            incassoStatus: "Stato incasso",
            paymentDate: "Data incasso",
                  reference: "Riferimento",
                  locationTable: "Sala",
                  operator: "Operatore",
                  actions: "Azioni",
                },
              },
        incassoOptions: {
          collected: "Riscosso",
          notCollected: "Non riscosso",
          postponed: "Non riscosso con incasso posticipato",
        },
              empty: {
                title: "Nessun documento trovato",
                subtitle: "Prova a cambiare i filtri oppure crea un nuovo documento.",
              },
              documentTypes: {
                all: "Tutti",
                invoice: "Fattura",
                commercialDocument: "Documento Commerciale",
                draftBill: "Conto Dimostrativo",
                creditNote: "Nota di Credito",
              },
              status: {
                all: "Tutti",
                draft: "Bozza",
                issued: "Emesso",
                paid: "Pagato",
                cancelled: "Annullato",
                reversed: "Stornato",
                sending: "Invio in corso",
                sent: "Inviata",
                error: "Errore",
                cancelling: "Annullamento in corso",
              },
              creditNote: {
                originalInvoice: "Storno fattura {{id}}",
                creditNote: "Nota di credito {{number}}",
              },
              batchResults: {
                title: "Risultato invio fatture",
                invoice: "Fattura #{{id}}",
                generic: "Invio",
              },
              cancelDialog: {
                title: "Annulla fattura",
                draftMessage: "Questa bozza verra eliminata.",
                sentMessage: "La fattura e gia stata inviata. Verra creata una nota di credito in bozza.",
                confirm: "Conferma",
                cancelling: "Annullamento...",
              },
              errors: {
                fetchClients: "Errore nel recupero dei clienti",
                missingAuth: "Token di autenticazione non trovato",
              },
              createDialog: {
                title: "Crea fattura",
                fields: {
                  sdiCode: "Codice SdI",
                  subjectType: "Tipo Soggetto",
                  invoiceLineDiscountSurcharge: "Sconto/Maggiorazione",
                  subjectTypeOptions: {
                    private: "Privato",
                    company: "Azienda",
                  },
                  client: "Cliente",
                  customerName: "Nome cliente",
                  emailPec: "Email / PEC",
                  customerId: "ID cliente",
                  companyId: "ID azienda",
                  documentType: "Tipo documento",
                  customerAddress: "Indirizzo cliente",
                  streetNumber: "Numero civico",
                  zip: "CAP",
                  city: "Citta",
                  province: "Provincia",
                  taxCode: "Codice fiscale",
                  vatNumber: "Partita IVA",
                  reaOffice: "Ufficio REA",
                  reaNumber: "Numero REA",
                  taxableAmount: "Imponibile",
                  vatPercent: "IVA %",
                  vatAmount: "Importo IVA",
                  total: "Totale",
                  paymentConditions: "Condizioni pagamento",
                  paymentMethod: "Metodo pagamento",
                  dueDate: "Data scadenza",
                  paymentAmount: "Importo pagamento",
                  reason: "Causale",
                  invoiceLines: "Linee fattura",
                  invoiceLineDescription: "Descrizione",
                  invoiceLineQuantity: "Quantità",
                  invoiceLineUnitPrice: "Prezzo unitario",
                },
                actions: {
                  cancel: "Annulla",
                  save: "Salva fattura",
                  saving: "Salvataggio...",
                  addInvoiceLine: "Aggiungi riga",
                  removeLine: "Rimuovi",
                },
              },
            },
            month: {
              jan: "Gen", feb: "Feb", mar: "Mar", apr: "Apr",
              may: "Mag", jun: "Giu", jul: "Lug", aug: "Ago",
              sep: "Set", oct: "Ott", nov: "Nov", dec: "Dic",
              error: "Errore nel trovare il mese",
            },
            price_per_weight: "Prezzo al peso",
            weight_unit: "Unità di misura",
          },
        },

        // ─────────────────────────────────────────────
        //  ALBANIAN
        // ─────────────────────────────────────────────
        sq: {
          translation: {
            login: 'Hyr',
            home: 'Kryefaqja',
            optional: '(Opsionale)',
            all: "Të gjitha",
            dataScadenzaPreventivo: "Data skadimit të ofertës",
            data: "Data",
            show: "Shfaq",
            search: "Kërko",
            Noteorganizzative: "Shënime organizative",
            qta: "Sasi",
            ospiti: "Numri i personave",
            Messaggioemail: "Përmbajtja e email-it",
            prezzo: "Çmimi",
            orarioServizioOpzionale: "Ora shërbimi",
            giornata: "Dita",
            dacatalogo: "Nga katalogu",
            clients: 'Klientë',
            azienda: 'Kompani (Opsionale)',
            saleassegnate: "Salla e caktuar",
            giornateesala: "Dita dhe salla",
            nomeEvento: "Emri i eventit",
            descrizionemodificabile: "Modifikimi i përshkrimit",
            righeperpagina: "Rreshta për faqe",
            Puliscifiltrilista: "Pastro filtrat e listës",
            tipiutilizzo: "Lloji i përdorimit (Opsionale)",
            emailattiva: "Email-i i marrësit të mëparshëm",
            datascadenzapreventivo: "Data skadimit të ofertës",
            client: 'Klient',
            server: "Server",
            completata: "E përfunduar",
            checkIn: "Check-in",
            eventoInCorso: "Event në zhvillim",
            eventoCompletato: "Event i përfunduar",
            prenotazioniConfermate: "Rezervime të konfirmuara",
            preventiviScaduti: "Oferta të skaduara",
            preventivoScaduto: "Ofertë e skaduar",
            destinatarioLibero: "Marrës i lirë",
            destinatarioLiberoHelp: "Klient ose kompani ende jo në regjistër.",
            partitaIvaOpzionale: "Numri i TVSH-së (opsional)",
            creaCliente: "Krijo klient",
            creaAzienda: "Krijo kompani",
            tipoPratica: "Lloji i praktikës",
            giorno: "Ditë",
tregiorni: "3 ditë",
settegiorni: "7 ditë",
settlavorativa: "Java e punës",
settimana: "Java",
agenda: "Agjendë",
            transferFrom: "Transfero nga:",
            tipoPractica: "Lloji i praktikës",
            FasceOrarie: "Oraret",
  InserisciFasceOrarie: "Vendos orare si mëngjes, drekë dhe darkë. Emri i orarit aktiv do të shfaqet lart sipas orës aktuale.",
  Fascia: "Orari",
  Rimuovi: "Hiq",
  NomeFascia: "Emri i orarit",
  PlaceholderNomeFascia: "MËNGJESI",
  Da: "Nga",
  A: "Deri",
  breakfast: "Mëngjes",
  lunch: "Drekë",
  dinner: "Darkë",
  EsempioFasciaOraria: "Shembull: nga 08:00 deri në 12:00 = MËNGJESI",
  AggiungiFascia: "Shto orar",
  Salvataggio: "Duke ruajtur...",
  SalvaFasceOrarie: "Ruaj oraret",
  TimeSlotsRequired: "Shto të paktën një orar të vlefshëm.",
  TimeSlotInvalid: "Kontrollo oraret e vendosura.",
  TimeSlotsSaved: "Oraret u ruajtën me sukses.",
            riepilogoPratiche: "Përmbledhje e praktikave",
            transferTo: "Transfero tek:",
            allestimentisale: "Konfigurimi i sallave",
            reparti: "Reparte",
            reparto: "Reparti",
            noteRepartoServizio: "Shenime per repartin",
            invioConfermaOpzione: "Email konfirmimi/opsioni",
            invioRiepilogoEvento: "Email permbledhje eventi",
            tipiutilizzo: "Lloji i përdorimit",
            transfer: "Transfero",
            placeholdercerca: "Kërko klient, kompani ose event",
            cerca: "Kërko",
            planner: "Planner",
            clienteaziendaeventoo: "Klient (Opsional)",
            confirmCovers: "Konfirmo Kopertinat",
            pratichetrovatesu : "praktika të gjetura në",
            roomNameExists: "Emri i Sallës Ekziston",
            noTableOnStandBy: "Asnjë Tavolinë në Pritje",
            horizontalPlease: "Për të përdorur këtë aplikacion, ju lutemi rrotulloni ekranin horizontalisht",
            numberOfPeople: "Numri i personave",
            confirm_delete: "Fshi rezervimet",
            planning_title: "Planifikimi i Rezervimeve",
            oggi: "Sot",
indietro: "Mbrapa",
avanti: "Përpara",
nuovapratica: "Praktikë e re",
filtri: "Filtra",
filtriPerStampa: "Filtra per printim",
filtriPlannerHelp: "Filtro praktikat qe shfaqen ne planifikues dhe perfshihen ne permbledhjet PDF ose email.",
duplica: "Dupliko",
stato: "Statusi",
tutti: "Të gjitha",
sala: "Salla",
tutte: "Të gjitha",
clienteaziendaevento: "Klient, kompani ose event",
da: "Nga",
a: "Deri",
categorieprodottinelreport: "Kategori produktesh në raport",
pdfsenzaprezzietotali: "PDF pa çmime dhe totalet",
mostrannullateneltabellone: "Trego anulimet në tabelë",
pulisci: "Pastro",
modalita: "Modaliteti",
nessunapraticanelgiornoselezionato: "Nuk u gjet asnjë praktikë në ditën e zgjedhur",
sale: "Salla",
capienza: "Kapaciteti",
bloccatada: "Bllokuar nga",
sallacollegata: "sallë e lidhur",
riepilogopratiche: "Përmbledhje e praktikave",
praticheritrovatesu: "praktika të gjetura në",
Pulisicifiltrilista: "Pastro filtrat e listës",
tutti: "Të gjitha",
pratica: "Praktikë",
stato: "Statusi",
destinatario: "Marrësi",
sala: "Salla",
periodo: "Periudha",
invii: "Dërgime",
nessunapractica: "Nuk u gjet asnjë praktikë",
azioni: "Veprime",
uso: "Përdorim",
motivo: "Arsye",
converti: "Konverto",
conferma: "Konfirmo",
modifica: "Ndrysho",
elimina: "Fshi",
nessunapraticatrovata: "Nuk u gjet asnjë praktikë",
preventivo: "Ofertë",
daconfermare: "Për t'u konfirmuar",
confermata: "E konfirmuar",
annullata: "E anuluar",
noshow: "Nuk u paraqit",
giornateeSale: "Ditë dhe salla",
aggiungidata: "Shto datë",
righepreventivoservizi: "Rreshta të ofertës / shërbimeve",
aggiungiriga: "Shto rresht",
Inviopreventivo: "Dërgimi i ofertës",
emailattiva: "Email aktiv",
inviaemaildoposalvataggio: "Dërgo email pas ruajtjes",
Allegatiextra: "Bashkëngjitje shtesë",
Caricaallegati: "Ngarko bashkëngjitje",
salvapratica: "Ruaj praktikën",
annulla: "Anulo",
parentRoomOptional: "Salla kryesore (opsionale)",
noParentRoom: "Asnje salle kryesore",
parentRoomHelp: "Nese kjo salle eshte nenndarje, zgjidh ketu sallen kryesore.",
Allestimenticompatibili: "Montime të përputhshme",
durante: "Gjatë rezervimit të kësaj salle do të mund të zgjidhen vetëm këto montime.",
salvacompatibilita: "Ruaj përputhshmërinë",
InviaRiepilogoFiltrato: "Dërgo përmbledhjen e filtruar",
inviaPDF: "Dërgo PDF",
Annullapratica: "Anulo praktikën",
Perannullareunapratica: "Për të anuluar një praktikë duhet të tregosh arsyen e anulimit.",
confermaanullamento: "Konfirmo anulimin",

            selectorders: "Zgjidh rezervimet",
            selectTable: "Zgjidh një tavolinë",
            plannersubtitle: "Menaxhoni ofertat, rezervimet dhe ngjarjet nga disponueshmëria e dhomave.",
            selectedarticles: "Artikujt e zgjedhur",
            CustomerOrderHistory: "Historia e porosive",
            accountsView: "Llogaritë",
            pacchetti: "Paketa",
            servizi: "Sherbime",
            loading: "Duke ngarkuar...",
            monitorEventi: {
              menu: "Monitori i eventeve",
              title: "Eventet e sotme",
              ended: "Perfunduar",
              realtimeShort: "Live",
              events: "evente",
              services: "Sherbime",
              noOperations: "Nuk ka sherbime operative te shenuara",
              moreOperations: "aktivitete te tjera",
              noEventsForRoom: "Provo te zgjedhesh te gjitha sallat.",
              waitingRealtime: "Kjo pamje perditesohet automatikisht ne kohe reale.",
              moreEvents: "evente jo te dukshme: filtro sipas salles",
              enterFullscreen: "Ekran i plote",
              loadError: "Gabim gjate ngarkimit te eventeve.",
            },
            menuGroups: {
              operativity: "Operativiteti",
              reservationsCrm: "Rezervime dhe CRM",
              catalogMenu: "Katalogu dhe menuja",
              administration: "Administrimi",
              system: "Sistemi",
              operationsLog: "Logu i veprimeve",
              systemSettings: "Cilesimet e sistemit",
              landingPage: "Faqja hyrese",
            },
            issuedDocuments: {
              menu: "Dokumente te leshuara",
              title: "Dokumente te leshuara",
              subtitle: "Pagesa nga Punto Cassa, dokumente tregtare dhe debitime HElite.",
              from: "Nga",
              to: "Deri",
              refresh: "Rifresko",
              refreshed: "Dokumentet e leshuara u perditesuan",
              loadError: "Gabim gjate ngarkimit te dokumenteve te leshuara",
              normalPayments: "Pagesa normale",
              helitePayments: "Debitimet HElite",
              prepaymentDocuments: "Parapagime",
              countSummary: "{{count}} rreshta | {{total}}",
              searchPlaceholder: "Kerko llogari, klient, dhome, sherbim...",
              account: "Llogaria",
              date: "Data",
              clientContext: "Klient / kontekst",
              payments: "Pagesa",
              document: "Dokument",
              event: "Event",
              operation: "Veprim",
              sourceDocument: "Dokumenti burim",
              total: "Totali",
              actions: "Veprime",
              noDocuments: "Nuk u gjet asnje dokument i leshuar.",
              details: "Detaje",
              detailTitle: "Detaj llogarie #{{id}}",
              prepaymentDetailTitle: "Detaj parapagimi #{{id}}",
              client: "Klient",
              context: "Kontekst",
              paidTotal: "Totali i paguar",
              orderStatus: "Statusi i porosise",
              method: "Metoda",
              type: "Tipi",
              roomHolder: "Dhoma / mbajtesi",
              amount: "Shuma",
              fiscal: "Fiskale",
              courtesy: "Kortesie",
              historicalHeliteCharge: "Debitim historik HElite",
              noHeliteCharges: "Nuk ka debitim HElite te lidhur.",
              codes: "Kode",
              status: "Status",
              error: "Gabim",
              orderRows: "Rreshtat e porosise",
              extraCounter: "Shtese banaku",
              item: "Artikull",
              quantity: "Sasia",
              commercialDocuments: "Dokumente tregtare",
              noCommercialDocuments: "Nuk ka dokument tregtar te lidhur.",
              documentCount: "{{count}} dokumente",
              documentNumber: "Dokument #{{id}}",
              invoiceNumber: "Fature {{number}}",
              sourceDocumentNumber: "Burim {{number}}",
              eventFallback: "Event #{{id}}",
              prepaymentMovements: "Levizjet e parapagimit",
              close: "Mbyll",
              clientFallback: "Klient #{{id}}",
              tableFallback: "Tavolina {{id}}",
              counter: "Banak",
              helite: "HElite",
              deduct: "Kthe",
              heliteDeducted: "Debitimi HElite u kthye.",
              restore: "RIKTHE",
              heliteRestored: "Llogaria HElite u rikthye ne Point of Sale.",
              restoreHeliteConfirmTitle: "Te rikthehet llogaria HElite?",
              restoreHeliteConfirmText: "Do te krijohet nje llogari e re me artikujt, tavolinen, klientin dhe rezervimin origjinal. Nuk do te dergohet automatikisht nje debit i ri ne HElite.",
              deductConfirmTitle: "Te kthehet debitimi HElite?",
              deductConfirmText: "Ky veprim dergon kthimin ne HElite per debitimin e zgjedhur.",
              chargeStatuses: {
                SUCCESS: "Sukses",
                FAILED: "Deshtoi",
                REVERSED: "I kthyer",
                PARTIALLY_REVERSED: "I kthyer pjeserisht",
                PENDING: "Ne pritje",
              },
              paymentMethods: {
                cash: "Cash",
                card: "Karte",
                bankTransfer: "Transferte bankare",
                voucher: "Kupon",
                roomCharge: "Debitim HElite",
                invoice: "Fature",
              },
              prepaymentTypes: {
                DEPOSIT: "Depozite",
                ADVANCE: "Parapagim fiskal",
              },
              prepaymentOperations: {
                RECEIPT: "Marrje",
                REFUND: "Rimbursim",
                REVERSAL: "Stornim",
                APPLICATION: "Aplikuar",
              },
              prepaymentDocumentTypes: {
                PLAIN_RECEIPT: "Mandat i thjeshte",
                COMMERCIAL_DOCUMENT: "Dokument tregtar",
                INVOICE_TD02: "Fature parapagimi",
                COMMERCIAL_CANCELLATION: "Anullim tregtar",
                COMMERCIAL_RETURN: "Kthim tregtar",
                CREDIT_NOTE_TD04: "Note krediti",
              },
              lineTypes: {
                product: "Produkt",
                package: "Pakete",
                menu: "Menu",
                adjustment: "Rregullim",
              },
            },
            fixedPriceMenu: {
              title: "Menu me cmim fiks",
              subtitle: "Konfiguro cmimin, portatat, zgjedhjet dhe shtesat.",
              newMenu: "Menu e re",
              editMenu: "Ndrysho menune",
              defaultMenuName: "Menu Dreke",
              defaultFirstCourse: "Pjata e pare",
              defaultSecondCourse: "Pjata e dyte",
              defaultDessertCourse: "Embelsire",
              defaultCourse: "Portata {{index}}",
              restaurantOnly: "Ky funksion eshte i disponueshem vetem per RISTORANTE.",
              loading: "Duke ngarkuar...",
              noMenus: "Nuk ka menu te konfiguruara.",
              active: "Aktive",
              inactive: "Jo aktive",
              choicesAndDishes: "{{min}}-{{max}} zgjedhje, {{count}} pjata",
              edit: "Ndrysho",
              deactivate: "Caktivizo",
              deleteConfirm: "Te fshihet \"{{name}}\"?",
              name: "Emri",
              date: "Data",
              basePrice: "Cmimi baze",
              courseName: "Emri i portates",
              courseOrder: "Renditja",
              minimum: "Min",
              maximum: "Max",
              availableDishes: "Pjatat e disponueshme",
              optionalSupplement: "Shtese opsionale",
              extraPrice: "Shtese EUR",
              addCourse: "Shto portate",
              cancel: "Anulo",
              save: "Ruaj",
              saving: "Duke ruajtur...",
              selectDishes: "Zgjidh pjatat",
              selectDishesDescription: "Zgjidh pjatat per cdo portate.",
              choose: "Zgjidh {{count}}",
              chooseRange: "Zgjidh {{min}}-{{max}}",
              chooseUpTo: "Zgjidh deri ne {{count}} artikuj (opsionale)",
              noDishesConfigured: "Nuk ka pjata te konfiguruara.",
              menuPrice: "Cmimi i menuse",
              supplements: "Shtesat",
              addToOrder: "Shto ne porosi",
              menuFallback: "Menu me cmim fiks",
              productFallback: "Produkti #{{id}}",
              supplementLabel: "Shtese EUR {{price}}",
              saved: "Menuja me cmim fiks u ruajt",
              deactivated: "Menuja u caktivizua",
              deleted: "Menuja u fshi",
              loadError: "Gabim gjate ngarkimit te menuve",
              saveError: "Gabim gjate ruajtjes",
              deactivateError: "Gabim gjate caktivizimit",
              deleteError: "Gabim gjate fshirjes",
              validationMainFields: "Ploteso emrin dhe cmimin.",
              validationAddCourse: "Shto te pakten nje portate.",
              validationCourseOrderPositive: "Renditja e portates duhet te jete numer pozitiv.",
              validationCourseOrderUnique: "Cdo portate duhet te kete renditje te ndryshme.",
              validationActiveDate: "Ekziston nje menu tjeter aktive per kete date.",
              validationCourseContent: "Cdo portate duhet te kete emer dhe te pakten nje pjate.",
              validationSelectionLimits: "Kufijte minimal/maksimal te zgjedhjeve nuk jane te vlefshem.",
              validationMinimumMaximum: "Minimumi nuk mund te jete me i madh se maksimumi.",
              validationMaximumOptions: "Maksimumi i zgjedhjeve tejkalon pjatat e disponueshme.",
              checkoutDeleteBlocked: "Menuja me cmim fiks nuk mund te fshihet ne checkout.",
              checkoutPriceSnapshot: "Cmimi i menuse ruhet ne snapshot-in e porosise.",
              checkoutChangesBlocked: "Menuja me cmim fiks nuk mund te ndryshohet ne checkout.",
              checkoutSplitBlocked: "Menuja me cmim fiks nuk mund te ndahet.",
              checkoutQuantitySnapshot: "Sasia e menuse ruhet ne snapshot-in e porosise.",
            },
            logsPage: {
              title: "Logu i veprimeve",
              exportCsv: "Eksporto CSV",
              exportSuccess: "Eksportimi CSV perfundoi",
              exportError: "Gabim eksportimi CSV",
              loadError: "Gabim ne ngarkimin e logeve",
              action: "Veprimi",
              entity: "Entiteti",
              entityId: "ID entiteti",
              userId: "ID perdoruesi",
              userName: "Emri",
              email: "Email",
              path: "Path",
              reason: "Arsyeja",
              requestId: "Request ID",
              dateTime: "Data/Ora",
              from: "Nga",
              to: "Deri",
              refresh: "Perditeso",
              all: "Te gjitha",
              noLogs: "Nuk u gjet asnje log",
            },
            reports: {
              orderStatus: { OPEN: "Hapur", IN_PROGRESS: "Ne proces", CLOSED: "Mbyllur", CANCELLED: "Anuluar", PAID: "Paguar" },
              eventStatus: { PREVENTIVO: "Oferte", TO_CONFIRM: "Per konfirmim", CONFIRMED: "Konfirmuar", CHECKED_IN: "Check-in", COMPLETED: "Perfunduar", CANCELLED: "Anuluar", NO_SHOW: "No-show" },
              recipientMissing: "Destinatari nuk eshte caktuar",
              tablesMissing: "Tavolinat nuk jane caktuar",
              service: "Sherbim",
              package: "Pakete",
              product: "Produkt",
              table: "Tavolina",
              counter: "Banak",
              order: "Porosia #{{id}}",
              event: "Event",
              adminReports: "Raporte admin",
              title: "Statistika operative",
              subtitle: "Porosi sherbimi, evente te ardhshme, evente te dites, sherbime per tu kryer dhe prodhim i periudhes.",
              from: "Nga",
              to: "Deri",
              refresh: "Perditeso",
              today: "Sot",
              last7: "7 ditet e fundit",
              last30: "30 ditet e fundit",
              currentMonth: "Muaji aktual",
              eventsToday: "Evente sot",
              serviceRows: "{{count}} rreshta sherbimi",
              deliverToday: "Per tu kryer sot",
              plannedServices: "Sherbime dhe paketa te planifikuara",
              periodProduction: "Prodhimi i periudhes",
              serviceOrders: "{{count}} porosi sherbimi",
              plannedEvents: "Evente te planifikuara",
              daysInPeriod: "{{count}} dite ne periudhe",
              openOrders: "Porosi te hapura",
              openOrdersSubtitle: "Te hapura, ne proces ose te mbyllura",
              counterSales: "Shitje ne banak",
              counterSalesSubtitle: "{{count}} porosi pa tavoline",
              adminReports: "Raportet e administratorit",
    title: "Statistika operacionale",
    subtitle: "Porosi shërbimi, evente të ardhshme, evente të sotme, shërbime për t’u dorëzuar dhe prodhim i periudhës.",
    from: "Nga",
    to: "Deri",
    refresh: "Rifresko",
    today: "Sot",
    last7: "7 ditët e fundit",
    last30: "30 ditët e fundit",
    currentMonth: "Muaji aktual",
    showEventsSection: "Shfaq seksionin e eventeve",
    hideEventsSection: "Fshih seksionin e eventeve",
    eventsToday: "Eventet e sotme",
    serviceRows: "Rreshtat e shërbimeve",
    deliverToday: "Për dorëzim sot",
    plannedServices: "Shërbime të planifikuara",
    periodProduction: "Prodhimi i periudhës",
    serviceOrders: "Porosi shërbimi",
    plannedEvents: "Evente të planifikuara",
    daysInPeriod: "Ditë në periudhë",
    openOrders: "Porosi të hapura",
    openOrdersSubtitle: "Të hapura, në proces ose të mbyllura",
    counterSales: "Shitje në banak",
    counterSalesSubtitle: "Porosi pa tavolinë",
    servicesToday: "Shërbime për t’u dorëzuar sot",
    servicesTodaySubtitle: "Lista operative e prodhimit sipas sallës/tavolinës.",
    serviceAccountsTitle: "Llogaritë e shërbimit",
    serviceOrdersTitle: "Porositë e shërbimit",
    serviceAccountsSubtitle: "Llogari të hapura, të mbyllura dhe në përpunim në periudhën e zgjedhur.",
    serviceOrdersSubtitle: "Porosi dhe tarifa nga shërbimet e planifikuara në periudhën e zgjedhur.",
    accountsView: "Pamja e llogarive",
    ordersView: "Pamja e porosive",
    accountColumn: "Llogaria",
    orderColumn: "Porosia",
    date: "Data",
    orders: "Porosi",
    status: "Statusi",
    rows: "Rreshta",
    total: "Totali",
    noOrdersPeriod: "Nuk ka porosi në këtë periudhë.",
    noServiceAccounts: "Nuk u gjetën llogari shërbimi.",
    noProductData: "Nuk ka të dhëna produkti.",
    noEventsToday: "Nuk ka evente të planifikuara për sot.",
    noServicesToday: "Nuk ka shërbime për t’u dorëzuar sot.",
    noServicesPeriod: "Nuk ka shërbime në këtë periudhë.",
    noCharges: "Nuk ka tarifa në këtë periudhë.",
    topServices: "Shërbimet kryesore në periudhë",
    topServicesSubtitle: "Prodhim i planifikuar nga eventet.",
    usageTypeStatsTitle: "Statistika sipas llojit te perdorimit",
    usageTypeStatsSubtitle: "Shperndarja e praktikave te sallave te kongreseve ne periudhen e zgjedhur.",
    noPracticesPeriod: "Asnje praktike ne periudhen e zgjedhur.",
    withoutUsageType: "Pa lloj perdorimi",
    practiceCount: "{{count}} praktika",
    daysCount: "{{count}} dite",
    guestsCount: "{{count}} mysafire",
    productionTitle: "Prodhimi i periudhës",
    productionSubtitle: "Tarifa nga porosi dhe shërbime të planifikuara.",
    actual: "Aktual",
    planned: "I planifikuar",
    source: "Burimi",
    item: "Artikulli",
    context: "Konstexti",
    historical: "Historiku",
    historicalSubtitle: "Të dhëna nga statistikat ekzistuese.",
    latestDailySales: "Shitjet më të fundit ditore",
    noHistoricalData: "Nuk ka të dhëna historike.",
    topProducts: "Produktet më të shitura",
    servizi: "Sherbime",
    loading: "Duke ngarkuar...",
    monitorEventi: {
      title: "Eventet e sotme",
      ended: "Perfunduar",
      realtimeShort: "Live",
      events: "evente",
      noOperations: "Nuk ka sherbime operative te shenuara",
      moreOperations: "aktivitete te tjera",
      noEventsForRoom: "Provo te zgjedhesh te gjitha sallat.",
      waitingRealtime: "Kjo pamje perditesohet automatikisht ne kohe reale.",
      moreEvents: "evente jo te dukshme: filtro sipas salles",
      enterFullscreen: "Ekran i plote",
    },
    loadError: "Gabim gjatë ngarkimit të raporteve",
    recipientMissing: "Marrësi nuk është caktuar",
    tablesMissing: "Nuk ka tavolina të caktuara",
    service: "Shërbim",
    package: "Paketë",
    event: "Event",
    anonymousClient: "Klient anonim",
    counter: "Banak",
    table: "Tavolinë",
    client: "Klient",
    noEvent: "Nuk ka event",
              futureCalendar: "Kalendari i eventeve te ardhshme",
              futureCalendarSubtitle: "Pamje kompakte e 14 diteve te ardhshme.",
              futureDays: "{{count}} dite te ardhshme",
              noEvent: "Asnje event",
              eventsOfDay: "Eventet e dites",
              eventsOfDaySubtitle: "Agjenda operative e dites.",
              noEventsToday: "Asnje event i planifikuar sot.",
              guests: "mysafire",
              servicesToday: "Sherbime per tu kryer ne dite",
              servicesTodaySubtitle: "Lista operative sipas salles/tavolines.",
              time: "Ora",
              quantity: "Sasia",
              value: "Vlera",
              noServicesToday: "Asnje sherbim per tu kryer sot.",
              serviceOrdersTitle: "Porosi sherbimi",
              serviceOrdersSubtitle: "Porosi dhe tarifa ne periudhen e zgjedhur.",
              orderColumn: "Porosia",
              date: "Data",
              status: "Statusi",
              rows: "Rreshta",
              total: "Totali",
              noOrdersPeriod: "Asnje porosi ne periudhe.",
              topServices: "Sherbimet kryesore te periudhes",
              topServicesSubtitle: "Prodhim i planifikuar nga eventet.",
              noServicesPeriod: "Asnje sherbim ne periudhe.",
              productionTitle: "Prodhimi i periudhes",
              productionSubtitle: "Tarifa nga porosite dhe sherbimet e planifikuara.",
              actual: "Realizuar",
              planned: "Planifikuar",
              source: "Burimi",
              item: "Zeri",
              context: "Konteksti",
              noCharges: "Asnje tarife ne periudhe.",
              historical: "Statistika historike te disponueshme",
              historicalSubtitle: "Te dhena nga pamjet statistikore ekzistuese.",
              latestDailySales: "Shitjet e fundit ditore",
              orders: "porosi",
              noHistoricalData: "Asnje e dhene historike.",
              topProducts: "Produktet me te shitura",
              noProductData: "Asnje e dhene produktesh.",
              loadError: "Gabim ne ngarkimin e raporteve",
              quotesConverted: "Oferta te konvertuara",
              quotesConvertedSubtitle: "{{converted}} nga {{total}} oferta",
              chartsOverviewTitle: "Shitjet me nje shikim",
              chartsOverviewSubtitle: "Grafike te animuara te lidhura me periudhen e zgjedhur.",
              chartCollectionTitle: "Ecuria e arketimeve",
              chartCollectionSubtitle: "Te ardhurat e mbledhura kundrejt vleres se mbetur.",
              chartCollected: "Arketuar",
              chartToCollect: "Per tu arketuar",
              chartChannelTitle: "Kanalet e shitjes",
              chartChannelSubtitle: "Ndarja e te ardhurave mes banakut dhe tavolinave.",
              chartCounter: "Banak",
              chartTable: "Sherbim ne tavoline",
              chartQuoteConfirmationTitle: "Ofertat dhe konfirmimet",
              chartQuoteConfirmationSubtitle: "Ofertat e hapura kundrejt konfirmimeve ne periudhen e zgjedhur.",
              chartQuotes: "Oferta",
              chartConfirmations: "Konfirmime",
              chartPractices: "{{count}} praktika",
              chartCompositionTitle: "Perberja e shitjeve",
              chartCompositionSubtitle: "Shperndarja e te ardhurave sipas llojit te artikullit.",
              chartNoData: "Asnje e dhene",
              dynamicChartTitle: "Ecuria e shitjeve te filtruara",
              dynamicChartSubtitle: "Perditesohet menjehere me filtrat e tabeles dinamike.",
              dynamicTopArticlesTitle: "Artikujt kryesore te filtruar",
              dynamicTopArticlesSubtitle: "Artikujt me te ardhurat me te larta ne rezultatin aktual.",
              chartRows: "rreshta",
              chartRevenue: "Te ardhura",
              chartNoFilteredData: "Asnje shitje nuk perputhet me filtrat e zgjedhur.",
              soldPeriodTitle: "Tabela dinamike e shitjeve",
              soldPeriodSubtitle: "Filtro shitjet sipas kategorise, artikullit, salles, operatorit, fashës orare, dates/ores, tipit te shitjes dhe menyres se pageses.",
              salesFilterCategory: "Kategoria",
              salesFilterArticle: "Artikulli",
              salesFilterRoom: "Salla e shitjes",
              salesFilterOperator: "Operatori",
              salesFilterTimeSlot: "Fasha orare",
              salesFilterSaleType: "Tipi i shitjes",
              salesFilterPaymentType: "Tipet e pageses",
              clearFilters: "Pastro filtrat",
              salesExtractionStart: "Fillimi i nxjerrjes",
              salesExtractionEnd: "Fundi i nxjerrjes",
              salesDateTime: "Data/ora e shitjes",
              saleTypeHotel: "Klient hoteli",
              saleTypeWalkIn: "Klient kalimtar",
              operatorMissing: "Operatori nuk u gjet",
              paymentCash: "Para ne dore",
              paymentCard: "Karta",
              paymentVoucher: "Pagesa pezull",
              paymentRoomCharge: "Tarifim dhome",
              paymentInvoice: "Fature",
              timeSlotMorning: "Mengjes 06:00-12:00",
              timeSlotLunch: "Dreke 12:00-15:00",
              timeSlotAfternoon: "Pasdite 15:00-18:00",
              timeSlotDinner: "Darka 18:00-24:00",
              timeSlotNight: "Nate 00:00-06:00",
            },
            eventPanel: {
              loadError: "Gabim ne ngarkimin e te dhenave te eventit.",
              eventNameRequired: "Emri i eventit eshte i detyrueshem.",
              selectCompany: "Zgjidh nje kompani.",
              selectClient: "Zgjidh nje klient.",
              oneDayRequired: "Shto te pakten nje dite.",
              dayNeedsStartEnd: "Cdo dite kerkon fillim dhe mbarim.",
              dayEndAfterStart: "Mbarimi duhet te jete pas fillimit.",
              invalidGuests: "Numri i mysafireve nuk eshte i vlefshem.",
              tableRequiredWhenConfirmed: "Kur statusi nuk eshte OFERTE, zgjidh te pakten nje tavoline per cdo dite.",
              invalidQuoteEmail: "Emaili i ofertes nuk eshte i vlefshem.",
              dayPrefix: "Dita {{number}}",
              packageUnit: "pakete",
              serviceUnit: "sherbim",
              quoteSubject: "Oferte eventi - {{eventName}}",
              eventCreated: "Eventi \"{{name}}\" u krijua me status {{status}}.",
              createError: "Gabim ne krijimin e eventit.",
              deleteConfirm: "Ta fshij kete event dhe te gjitha ditet e lidhura?",
              deleted: "Eventi u fshi.",
              deleteError: "Gabim ne fshirjen e eventit.",
              statusUpdated: "Eventi u perditesua ne {{status}}.",
              statusUpdateError: "Gabim ne perditesimin e statusit te eventit.",
              title: "Event shume-ditor (Oferte / Rezervim)",
              subtitle: "Fluks opsional: krijo nje event me disa dite, sherbime/paketa dhe status fillestar OFERTE.",
              loading: "Duke ngarkuar te dhenat e eventit...",
              eventName: "Emri i eventit",
              initialStatus: "Statusi fillestar",
              recipient: "Destinatari",
              company: "Kompani",
              client: "Klient",
              eventNotes: "Shenime eventi",
              day: "Dita",
              start: "Fillimi",
              end: "Mbarimi",
              people: "Persona",
              dayNote: "Shenim dite",
              tables: "Tavolina",
              packages: "Paketa",
              singleServices: "Sherbime te vecanta",
              addDay: "Shto dite",
              sendQuoteAfterCreate: "Dergo email oferte pas krijimit",
              recipientEmail: "Email destinatar",
              subject: "Subjekti",
              message: "Mesazhi",
              saving: "Duke ruajtur...",
              createEvent: "Krijo event",
              latestEvents: "Eventet e fundit te krijuara",
              dayStatuses: "Statuset e diteve",
              period: "Periudha",
              guests: "Mysafire",
              days: "Dite",
              actions: "Veprime",
              confirm: "Konfirmo",
              delete: "Fshi",
              noEvents: "Asnje event i disponueshem.",
            },
            quoteAdmin: {
              packageUnit: "pakete",
              packageSubtitle: "Pakete - {{count}} sherbime",
              unitEach: "njesi",
              catalogLoadError: "Gabim ne ngarkimin e katalogut.",
              sendQuoteError: "Gabim ne dergimin e ofertes",
              eventCreateRequired: "Per te krijuar eventin OFERTE, zgjidh nje klient ose kompani.",
              customServicesNote: "Sherbime te personalizuara te pamapuara:",
              quoteEventName: "Oferte - {{name}}",
              recipientFallback: "Destinatar",
              eventCreateError: "Gabim ne krijimin e eventit OFERTE",
              sentAndEventCreated: "Oferta u dergua dhe eventi OFERTE u krijua.",
              eventCreatedEmailFailed: "Eventi OFERTE u krijua, por emaili nuk u dergua: {{error}}",
              emailNotSent: "Emaili nuk u dergua: {{error}}",
              eventNotCreated: "Eventi nuk u krijua: {{error}}",
              operationNotCompleted: "Operacioni nuk u perfundua.",
              client: "Klient",
              company: "Kompani",
              manualEmail: "Email manual",
              noEmail: "pa email",
              searchCompany: "Kerko kompani",
              noEmailWarning: "Destinatari i zgjedhur nuk ka email te vlefshem.",
              realCatalog: "Katalog real sherbimesh",
              realCatalogSubtitle: "Zgjidh paketa ose sherbime te vecanta.",
              guestCount: "Numri i personave",
              table: "Tavolina",
              seats: "vende",
              tablesOptional: "Tavolina (opsionale)",
              selectTables: "Zgjidh nje ose me shume tavolina",
              compatibleTables: "{{count}} tavolina te pershtatshme me {{guests}} persona",
              insertGuestsFirst: "Vendos fillimisht numrin e personave per filtrimin sipas kapacitetit",
              search: "Kerko",
              type: "Tipi",
              all: "Te gjitha",
              packages: "Paketa",
              servicesSingle: "Sherbime te vecanta",
              results: "rezultate",
              catalogLoading: "Duke ngarkuar katalogun...",
              name: "Emri",
              detail: "Detaji",
              price: "Cmimi",
              package: "Pakete",
              service: "Sherbim",
              added: "Shtuar",
              add: "Shto",
              noResults: "Asnje rezultat per filtrat e zgjedhur.",
              eventDateTime: "Data dhe ora e eventit",
            },
            orderHistoryPage: {
              noProducts: "Asnje produkt ne kete porosi.",
              title: "Historia e porosive",
              clients: "Kliente",
              companies: "Kompani",
              heliteRooms: "Dhoma HElite",
              search: "Kerko...",
              noClients: "Nuk u gjet asnje klient.",
              noCompanies: "Nuk u gjet asnje kompani.",
              noHeliteRooms: "Nuk u gjet asnje dhome HElite.",
              selectTarget: "Zgjidh nje klient, kompani ose dhome HElite per te pare historikun e porosive.",
              heliteRoomsPanel: "Kliente HElite live",
              heliteGuestsCount: "{{count}} dhoma check-in",
              inHouse: "Ne hotel",
              spentShort: "Shpenzuar",
              orders: "Porosi",
              lastOrder: "Porosia e fundit",
              searchHeliteRoom: "Kerko dhomen {{roomNumber}}",
              searchHeliteRoomHint: "Kerko porosite dhe addebitot per kete dhome HElite.",
              roomLabel: "Dhoma {{roomNumber}}",
              heliteBill: "Prenotim HElite {{billNumber}}",
              spent: "Shpenzuar: {{amount}}",
              ordersCount: "{{count}} porosi",
              noOrders: "Nuk u gjet asnje porosi.",
              order: "Porosia",
              date: "Data",
              status: "Statusi",
              total: "Totali",
              productFallback: "Produkt #{{id}}",
              packageFallback: "Pakete #{{id}}",
              fixedMenuFallback: "Menu me cmim fiks",
            },
            bookingExtra: {
              multiEventQuote: "Event shume-ditor / Oferte",
              quotes: "Oferta",
              classicReservation: "Rezervim klasik",
              showCancelled: "Shfaq te anuluarat",
              showNoShow: "Shfaq no-show",
              companyAlternative: "Kompani (alternative ndaj klientit)",
              companyHelper: "Zgjidh nje kompani nese do te rezervosh pa klient nominal.",
              newCompanyUpper: "Kompani e re",
              newCompany: "Kompani e re",
              eventNameOptional: "Emri i eventit (opsional)",
              eventNameHint: "Perdore si dallues per ta lidhur kete rezervim me nje event.",
              companyNameRequired: "Emri i kompanise eshte i detyrueshem.",
              companyCreated: "Kompania u krijua me sukses.",
              companyName: "Emri i kompanise *",
              vatOptional: "NIPT/VAT (opsional)",
              sdiOptional: "SDI (opsional)",
              emailOptional: "Email (opsional)",
              phoneOptional: "Telefon (opsional)",
              addressOptional: "Adresa (opsionale)",
              legalAddressOptional: "Adresa ligjore (opsionale)",
              createCompany: "Krijo kompani",
              event: "Event:",
              services: "Sherbime",
            },
            miscUi: {
              destination: "Destinacioni",
              newCourse: "Portate e re",
              selectedCourse: "Portata e zgjedhur",
              orderReprinted: "Porosia u rishtyp",
              viewOrder: "Shiko porosine",
              transferToAnotherTable: "Transfero ne nje tavoline tjeter",
              destinationTable: "Tavolina e destinacionit",
              transferItems: "Transfero",
              moveSelectedProduct: "Zhvendos {{count}} produkt",
              moveSelectedProducts: "Zhvendos {{count}} produkte",
              occupiedTableWarningTitle: "Kujdes: tavoline e zene",
              occupiedDestinationTableConfirm: "Tavolina e destinacionit eshte e zene. Deshiron te vazhdosh gjithsesi me transferimin?",
              transferSuccess: "Produktet u transferuan",
              noClientsAvailable: "Asnje klient i disponueshem",
              noCompaniesAvailable: "Asnje kompani e disponueshme",
            },
            planning: {
              title: "Planifikimi i Takimeve",
              today: "Sot",
              help: "Kliko nje interval te lire per te krijuar rezervim dhe ploteso detajet ne dritare.",
              legend_available: "Intervale te lira",
              legend_reserved: "Intervale te rezervuara",
              room_summary: "{{count}} tavolina",
              empty_day: "Asnje rezervim per kete salle sot",
              no_rooms: "Asnje salle e konfiguruar.",
              add_at: "Shto rezervim ne oren",
              reservation_detail: "Detajet e Rezervimit",
              time: "Ora",
              guests: "Mysafire",
              note: "Shenim",
              notes: "Shenime",
              new_reservation: "Rezervim i Ri",
              start_time: "Fillimi",
              end_time: "Mbarimi",
              confirm: "Konfirmo",
              error_client: "Zgjidh nje klient.",
              error_dates: "Cakto oren e fillimit dhe mbarimit.",
              error_no_table: "Nuk u gjet asnje tavoline per kete salle.",
              delete_reservation: "Fshi rezervimin",
              deleting: "Duke fshire..."
            },
            booking_newClient: 'Klient i ri',
            client_page_error_duplicate_email: "Ky email është i lidhur me një klient tjetër.",
            client_page_error_duplicate_phone: "Ky numër telefoni është i lidhur me një klient tjetër.",
            client_page_error_create: "Gabim gjatë krijimit të klientit.",
            client_page_error_required_fields: "Emri dhe mbiemri janë të detyrueshëm.",
            client_page_error_email_or_phone_required: "Duhet të jepni të paktën një email ose numër telefoni.",
            client_page_success_create: "Klienti u krijua me sukses!",

confirm_delete_msg: "Jeni të sigurt që doni të fshini {{count}} rezervim/e? Ky veprim nuk mund të zhbëhet.",
preventivi: {
  page:                  "Ofertat",
  subtitle:              "Krijo dhe dërgo një ofertë/preventiv me e-mail te klienti.",
  step_client:           "Klienti",
  step_services:         "Shërbimet",
  step_preview:          "Paraparje & Dërgim",
  select_recipient:      "Zgjidh destinatarin",
  existing_client:       "Klient ekzistues",
  insert_email:          "Shto e-mail",
  search_client:         "Kërko me emër ose email…",
  recipient_name:        "Emri i destinatarit",
  email_address:         "Adresa e-mail",
  to:                    "Për",
  available_services:    "Shërbimet e disponueshme",
  click_to_add:          "Kliko një shërbim për ta shtuar në ofertë.",
  quote_items:           "Zërat e ofertës",
  no_services_selected:  "Nuk është zgjedhur asnjë shërbim. Kliko çipat sipër për të shtuar.",
  col_service:           "Shërbimi",
  col_unit:              "Njësia",
  col_qty:               "Sas.",
  col_unit_price:        "Çmimi njësia (€)",
  col_unit_price_short:  "Njësia",
  col_total:             "Totali (€)",
  grand_total:           "Totali i ofertës",
  add_custom:            "Shto zë të personalizuar",
  custom_name:           "Emri i shërbimit",
  custom_unit:           "Njësia",
  custom_unit_placeholder: "p.sh. ditë",
  custom_price:          "Çmimi njësia",
  add:                   "Shto",
  email_details:         "Detajet e e-mailit",
  subject:               "Subjekti",
  event_date:            "Data e eventit",
  valid_until:           "Oferta e vlefshme deri më",
  intro_message:         "Mesazh hyrës (opsional)",
  intro_placeholder:     "Shkruaj një mesazh të personalizuar për klientin…",
  email_preview:         "Paraparje e e-mailit",
  include_logo:          "Perfshi logon ne e-mail",
  email_header_title:    "Ofertë Preventiv",
  email_header_sub:      "Sallat e Kongresit",
  email_greeting:        "I/E nderuar",
  email_default_body:    "Ju falënderojmë për interesin tuaj. Më poshtë gjeni ofertën e detajuar për shërbimet e kërkuara.",
  email_footer:          "Ofertë e gjeneruar automatikisht — Sallat e Kongresit",
  sent_title:            "Oferta u dërgua!",
  sent_desc:             "Oferta u dërgua te",
  new_quote:             "Ofertë e re",
  send:                  "Dërgo ofertën",
  sending:               "Duke dërguar…",
  send_error:            "Gabim dërgimi",
  send_error_label:      "Gabim gjatë dërgimit",
  back:                  "Mbrapa",
  next:                  "Përpara",
  services: {
    hall_half_day:   "Salla e Kongresit – gjysmë dite",
    hall_full_day:   "Salla e Kongresit – ditë e plotë",
    projector:       "Projektor + ekran",
    microphone:      "Mikrofon wireless",
    coffee_break:    "Pushim kafeje",
    business_lunch:  "Drekë biznesi",
    gala_dinner:     "Darkë gala",
    floral:          "Dekorim floral",
    parking:         "Parking i rezervuar",
    wifi:            "Wi-Fi i dedikuar me shpejtësi të lartë",
    photography:     "Shërbim fotografik",
  },
  units: {
    session:   "sesion",
    day:       "ditë",
    unit_day:  "njësi/ditë",
    person:    "person",
    set:       "set",
    spot_day:  "vend/ditë",
    hour:      "orë",
    unit:      "njësi",
  },
},
            comunicazioni: {
      title:              "Komunikimet e Rezervimeve",
      subtitle:           "Zgjidh një rezervim për të parë dhe shtuar shënime mes operatorëve.",
      select_reservation: "Rezervimet",
      search_reservation: "Kërko mysafirin ose dhomën...",
      no_reservations:    "Asnjë rezervim i gjetur.",
      select_to_start:    "Zgjidh një rezervim për të filluar bisedën.",
      room:               "Dhoma",
      write_placeholder:  "Shkruaj një mesazh... (Enter për dërgim)",
      publish:            "Dërgo",
      no_notes:           "Asnjë mesazh ende. Fillo bisedën.",
      error_empty:        "Mesazhi nuk mund të jetë bosh.",
      error_publish:      "Gabim gjatë dërgimit.",
      success_publish:    "Mesazhi u dërgua!",
      user_fallback:      "Përdoruesi #{{id}}",
      tables_title:   "Tables",
      tables_subtitle: "Click a table to view or add communications.",
    page: "Komunikimet",
    },
            

            spa: {
              common: {
                all: "Te gjitha",
                cancel: "Anulo",
                clear: "Pastro",
                save: "Ruaj",
                spaOnly: "Kjo zone eshte e disponueshme vetem per tenant SPA.",
              },
              planner: {
                menu: "SPA Planner",
                title: "SPA Planner",
                subtitle: "Tabela ditore e takimeve per trajtime SPA, operatore dhe kabina.",
                day: "Dita",
                week: "Java",
                today: "Sot",
                newAppointment: "Takim i ri",
                editAppointment: "Ndrysho takimin",
                loading: "Duke ngarkuar SPA planner...",
                empty: "Nuk ka takime per filtrat e zgjedhur.",
                backendPending: "Backend ne pritje: takimet jane te perkohshme derisa endpoint-et `/api/spa/*` te jene gati.",
                metrics: {
                  appointments: "Takime",
                  inProgress: "Ne proces",
                  completed: "Te perfunduara",
                  noShow: "No-show",
                },
              },
              settings: {
                title: "Konfigurime",
                loading: "Duke ngarkuar konfigurimet",
                saving: "Duke ruajtur...",
                loadError: "Nuk u ngarkuan konfigurimet SPA.",
                saveError: "Nuk u ruajten konfigurimet SPA.",
                interval: "Intervali i planner-it",
                timeZone: "Zona kohore",
                openingHours: "Oraret e hapjes",
                noOpeningHours: "Nuk ka orare te konfiguruara per kete dite",
                closedDays: "Dite te mbyllura",
                closedDay: "Dite e mbyllur",
                holidays: "Pushime",
                day: "Dita",
                start: "Fillimi",
                end: "Mbarimi",
                addOpeningHour: "Shto orar",
                addHoliday: "Shto pushim",
                holidayDate: "Data",
                holidayName: "Emri",
                invalidDate: "Data e takimit nuk eshte valide.",
                closedDayWarning: "Kjo date eshte e mbyllur ne konfigurimet SPA.",
                holidayWarning: "Kjo date eshte shenuar si pushim: {{name}}.",
                intervalWarning: "Ora e fillimit duhet te ndjeke intervalin {{interval}} minuta.",
                outsideOpeningHoursWarning: "Ora e fillimit eshte jashte orareve te hapjes.",
                days: {
                  0: "E diel",
                  1: "E hene",
                  2: "E marte",
                  3: "E merkure",
                  4: "E enjte",
                  5: "E premte",
                  6: "E shtune",
                },
              },
              statuses: {
                OPTION: "Opsion",
                CONFIRMED: "I konfirmuar",
                GUARANTEED: "I garantuar",
                ARRIVED: "Ka ardhur",
                IN_PROGRESS: "Ne proces",
                COMPLETED: "I perfunduar",
                CANCELLED: "I anuluar",
                NO_SHOW: "No-show",
              },
              customerTypes: {
                hotelGuest: "Klient hoteli",
                external: "I jashtem",
              },
              fields: {
                actions: "Veprime",
                area: "Zone",
                cabin: "Kabine",
                capacity: "Kapaciteti",
                category: "Kategoria",
                client: "Klienti",
                date: "Data",
                duration: "Kohezgjatja",
                durationMinutes: "Kohezgjatja ne minuta",
                email: "Email",
                name: "Emri",
                notes: "Shenime",
                operator: "Operatori",
                price: "Cmimi",
                quantity: "Sasia",
                room: "Dhoma",
                skills: "Aftesi",
                start: "Fillimi",
                status: "Statusi",
                treatment: "Trajtimi",
                type: "Tipi",
                vat: "TVSH",
                vatPercent: "TVSH %",
              },
              catalog: {
                menu: "Katalogu SPA",
                title: "Katalogu SPA",
                operatorSaved: "Operatori u ruajt.",
                operatorCreated: "Operatori u krijua. Tani mund te shtosh kualifikime dhe turne.",
                subtitle: "Trajtimet, operatoret dhe pajisjet gati per lidhjen me backend. Kabinat menaxhohen nga harta e kabinave.",
                addItem: "Shto {{item}}",
                editItem: "Ndrysho {{item}}",
                loading: "Duke ngarkuar katalogun SPA...",
                backendPending: "Backend ne pritje: ndryshimet e katalogut jane te perkohshme derisa endpoint-et `/api/spa/*` te jene gati.",
                commaSeparated: "Te ndara me presje",
                engagementReminderMinutes: "Minutat e kujteses se angazhimit",
                engagementReminderHelp: "Nga 5 minuta deri ne 7 dite para takimit.",
                externalInvitations: "Ftesa te jashtme",
                appointmentId: "ID e takimit",
                expiresInDays: "Skadon pas ditesh",
                createInvitation: "Krijo ftese",
                selectAppointment: "Zgjidh takim",
                selectAssignedAppointment: "Takimet e caktuara per kete jave.",
                noAssignedAppointments: "Nuk u gjet takim i caktuar per kete jave.",
                oneTimeToken: "Token njeperdorimsh",
                copyToken: "Kopjo token",
                invitationUrl: "URL e fteses",
                copyUrl: "Kopjo URL",
                openInvitation: "Hap",
                expiresAt: "Skadon me",
                respondedAt: "U pergjigj me",
                resend: "Ridërgo",
                revoke: "Revoko",
                noInvitations: "Nuk ka ftesa.",
                invitationCreated: "Ftesa u krijua.",
                invitationCreatedEmailFailed: "Ftesa u krijua, por email-i nuk u dergua.",
                invitationResent: "Ftesa u ridergua.",
                invitationResentEmailFailed: "Ftesa u ridergua, por email-i nuk u dergua.",
                invitationRevoked: "Ftesa u revokua.",
                invitationCreateError: "Nuk u krijua ftesa",
                invitationResendError: "Nuk u ridergua ftesa",
                invitationRevokeError: "Nuk u revokua ftesa",
                invitationTokenCopied: "Token-i i fteses u kopjua.",
                invitationTokenCopyError: "Nuk u kopjua token-i",
                invitationUrlCopied: "URL e fteses u kopjua.",
                invitationUrlCopyError: "Nuk u kopjua URL",
                managedInProducts: "Menaxhohet te Products",
                managedInUsers: "Menaxhohet te Users",
                tabs: {
                  treatments: { label: "Trajtime", singular: "trajtim" },
                  operators: { label: "Operatore", singular: "operator" },
                  equipment: { label: "Pajisje", singular: "pajisje" },
                },
                statuses: {
                  active: "Aktiv",
                  inactive: "Jo aktiv",
                  available: "E lire",
                  cleaning: "Pastrim",
                  maintenance: "Mirembajtje",
                  out_of_service: "Jashte sherbimit",
                },
              },
            },

            tenantDomain: {
              RISTORANTE: {
                addTable: "Shto tavolinë",
                editTable: "Ndrysho tavolinën",
                tableName: "Emri i tavolinës",
                tablePrefix: "Prefiksi i tavolinës",
                tableSuffix: "Sufiksi i tavolinës",
                tableQuantity: "Sasia e tavolinave",
                selectedTable: "Tavolina e zgjedhur",
                room: "Sallë",
                roomName: "Emri i sallës",
                addRoom: "Shto sallë",
                editRoom: "Ndrysho sallën",
                deleteRoom: "Fshi sallën",
                seats: "Numri i vendeve",
                seatNumber: "Numri i vendeve",
                occupiedSeats: "Vendet e zëna",
                bookingTable: "Tavolinë",
                bookingGuests: "Numri i mysafirëve",
                reservationTable: "Tavolinë",
                reservationRoom: "Sallë",
                clearTableTitle: "Konfirmo lirimin e tavolinës",
                clearTableAlert: "Jeni i sigurt që doni të lironi tavolinën",
                tablesMap: "Harta e tavolinave",
                newTable: "Tavolinë e re",
                noTable: "Nuk ka tavolina",
                selectTable: "Zgjidh tavolinën",
                freeTables: "Tavolina të lira",
                activeTables: "Tavolina aktive",
                occupiedTables: "Tavolina të zëna",
                addTableQuestion: "Shto tavolinë?",
                deleteTableRequestTitle: "Konfirmo fshirjen e tavolinës",
                deleteTableRequest: "Jeni i sigurt që doni të fshini këtë tavolinë? Veprimi nuk mund të zhbëhet.",
                deleteRoomRequestTitle: "Konfirmo fshirjen e sallës",
                deleteRoomRequest: "Kujdes! Duke fshirë këtë sallë do të fshihen edhe të gjitha tavolinat e lidhura me të. Doni të vazhdoni?",
                newOrder: "Porosi e Re",
                selectorders: "Zgjidh artikujt",
                noOrders: "Nuk ka Porosi Aktive",
                closeBill: "Mbyll Llogarinë",
                split: "Ndaj Porosinë",
                transferOrder: "Transfero Porosinë",
                confirmCovers: "Konfirmo Kopertinat",
                activeOrders: "Porosi Aktive",
                orderSummary: "Përmbledhja e Porosisë",
                noProductPresent: "Nuk ka produkte në këtë porosi",
          products: "Artikuj",
                add_product: "Shto Artikull",
                allestimenti: {
                  pageTitleShort: "Paketat",
                },
                realTimeOrders: "Porosi në Kohë Reale",
                send_order: "Dërgo Porosinë",
                orderDetails: "Detajet e Porosisë",
                draftPayment: "Parakonto",
                No_table_selected: "Asnjë tavolinë e zgjedhur",
                checkoutPage: "Arka",
                checkout_page: {
                  noRegisteredOrders: "Asnjë Porosi e Regjistruar",
                  pending: "Në Pritje",
                  occupied: "E Zënë",
                },
                menu_config: {
                  page: "Menu",
                },
                clearAllTablesAndPay: "[DEV] LIRO TAVOLINAT DHE PAGUAJ POROSITË",
              },
              SPA: {
                addTable: "Shto kabinë",
                editTable: "Ndrysho kabinën",
                tableName: "Emri i kabinës",
                tablePrefix: "Prefiksi i kabinës",
                tableSuffix: "Sufiksi i kabinës",
                tableQuantity: "Sasia e kabinave",
                selectedTable: "Kabina e zgjedhur",
                room: "Zonë",
                roomName: "Emri i zonës",
                addRoom: "Shto zonë",
                editRoom: "Ndrysho zonën",
                deleteRoom: "Fshi zonën",
                seats: "Numri i personave",
                seatNumber: "Numri i personave",
                occupiedSeats: "Personat e pranishëm",
                bookingTable: "Kabinë",
                bookingGuests: "Numri i personave",
                reservationTable: "Kabinë",
                reservationRoom: "Zonë",
                clearTableTitle: "Konfirmo lirimin e kabinës",
                clearTableAlert: "Jeni i sigurt që doni të lironi kabinën",
                tablesMap: "Harta e kabinave",
                newTable: "Kabinë e re",
                noTable: "Nuk ka kabina",
                selectTable: "Zgjidh kabinën",
                freeTables: "Kabina të lira",
                activeTables: "Kabina aktive",
                occupiedTables: "Kabina të zëna",
                addTableQuestion: "Shto kabinë?",
                deleteTableRequestTitle: "Konfirmo fshirjen e kabinës",
                deleteTableRequest: "Jeni i sigurt që doni të fshini këtë kabinë? Veprimi nuk mund të zhbëhet.",
                deleteRoomRequestTitle: "Konfirmo fshirjen e zonës",
                deleteRoomRequest: "Kujdes! Duke fshirë këtë zonë do të fshihen edhe të gjitha kabinat e lidhura me të. Doni të vazhdoni?",
                newOrder: "Takim i Ri",
                noOrders: "Nuk ka Takime Aktive",
                closeBill: "Mbyll Seancën",
                split: "Ndaj Seancën",
                transferOrder: "Transfero Takimin",
                confirmCovers: "Konfirmo Mysafirët",
                activeOrders: "Takime Aktive",
                orderSummary: "Përmbledhja e Takimit",
                noProductPresent: "Nuk ka shërbime në këtë Takim",
          products: "Shërbime",
                realTimeOrders: "Takime në Kohë Reale",
                send_order: "Dërgo Takimin",
                orderDetails: "Detajet e Takimit",
                draftPayment: "Parakonto",
                No_table_selected: "Asnjë kabinë e zgjedhur",
                checkoutPage: "Arka e Seancave",
                checkout_page: {
                  noRegisteredOrders: "Asnjë Takim i Regjistruar",
                  pending: "Në Pritje",
                  occupied: "Në Seancë",
                },
                menu_config: {
                  page: "Lista e shërbimeve",
                },
                clearAllTablesAndPay: "[DEV] LIRO KABINAT DHE PAGUAJ POROSITË",
              },
              SALE_CONGRESSI: {
                planning: {
  title:              "Planifikimi i Takimeve",
  today:              "Sot",
  help:               "Kliko nje interval te lire per te krijuar rezervim dhe ploteso detajet ne dritare.",
  legend_available:   "Intervale te lira",
  legend_reserved:    "Intervale te rezervuara",
  room_summary:       "{{count}} tavolina",
  empty_day:          "Asnje rezervim per kete salle sot",
  delete_reservation: "Fshi rezervimin",
  deleting:           "Duke fshire...",
  no_rooms:           "Asnjë sallë e konfiguruar.",
  add_at:             "Shto rezervim në orën",
  reservation_detail: "Detajet e Rezervimit",
  time:               "Ora",
  guests:             "Mysafirë",
  note:               "Shënim",
  notes:              "Shënime",
  new_reservation:    "Rezervim i Ri",
  start_time:         "Fillimi",
  end_time:           "Mbarimi",
  confirm:            "Konfirmo",
  error_client:       "Zgjidh një klient.",
  error_dates:        "Cakto orën e fillimit dhe mbarimit.",
  error_no_table:     "Nuk u gjet asnjë tavolinë për këtë sallë.",
},
                addTable: "Shto sallë",
                editTable: "Ndrysho sallën",
                tableName: "Emri i sallës",
                tablePrefix: "Prefiksi i sallës",
                tableSuffix: "Sufiksi i sallës",
                tableQuantity: "Sasia e sallave",
                selectedTable: "Salla e zgjedhur",
                room: "Zonë",
                roomName: "Emri i zonës",
                addRoom: "Shto zonë",
                editRoom: "Ndrysho zonën",
                deleteRoom: "Fshi zonën",
                seats: "Numri i pjesëmarrësve",
                seatNumber: "Numri i pjesëmarrësve",
                occupiedSeats: "Pjesëmarrësit e pranishëm",
                bookingTable: "Sallë",
                eventPanel: {
                  tables: "Salla",
                  tableRequiredWhenConfirmed: "Kur statusi nuk eshte OFERTE, zgjidh te pakten nje salle per cdo dite.",
                },
                bookingGuests: "Numri i pjesëmarrësve",
                reservationTable: "Sallë",
                reservationRoom: "Zonë",
                clearTableTitle: "Konfirmo lirimin e sallës",
                clearTableAlert: "Jeni i sigurt që doni të lironi sallën",
                tablesMap: "Setup sallash",
                newTable: "Sallë e re",
                noTable: "Nuk ka salla",
                selectTable: "Zgjidh sallën",
                freeTables: "Salla të lira",
                activeTables: "Salla aktive",
                occupiedTables: "Salla të zëna",
                addTableQuestion: "Shto sallë?",
                deleteTableRequestTitle: "Konfirmo fshirjen e sallës",
                deleteTableRequest: "Jeni i sigurt që doni të fshini këtë sallë? Veprimi nuk mund të zhbëhet.",
                deleteRoomRequestTitle: "Konfirmo fshirjen e zonës",
                deleteRoomRequest: "Kujdes! Duke fshirë këtë zonë do të fshihen edhe të gjitha sallat e lidhura me të. Doni të vazhdoni?",
                newOrder: "Praktike e Re",
                noOrders: "Nuk ka Ngjarje Aktive",
                closeBill: "Mbyll Ngjarjen",
                split: "Ndaj Ngjarjen",
                transferOrder: "Transfero Ngjarjen",
                confirmCovers: "Konfirmo Pjesëmarrësit",
                activeOrders: "Ngjarje Aktive",
                orderSummary: "Përmbledhja e Ngjarjes",
                noProductPresent: "Nuk ka shërbime në këtë Ngjarje",
          products: "Shërbime",
                realTimeOrders: "Ngjarje në Kohë Reale",
                send_order: "Dërgo Ngjarjen",
                orderDetails: "Detajet e Ngjarjes",
                draftPayment: "Parakonto",
                No_table_selected: "Asnjë sallë e zgjedhur",
                checkoutPage: "Arka e Eventeve",
                checkout_page: {
                  noRegisteredOrders: "Asnjë Ngjarje e Regjistruar",
                  pending: "Në Pritje",
                  occupied: "Në Event",
                },
                menu_config: {
                  page: "Lista e shërbimeve",
                },
                clearAllTablesAndPay: "[DEV] LIRO SALLAT DHE PAGUAJ POROSITË",
          allestimenti: {
            pageTitle: "Menaxhimi i paketave",
            pageSubtitle: "Krijo paketa per rezervime ose shitje direkte. Te sallat e kongresit perdoren ne rezervim, te restoranti mund te shtohen direkt ne tavoline (p.sh. menu degustimi).",
            pageTitleShort: "Paketa",
            productsAvailable: "Sherbime te disponueshme",
            packageCapacityPeople: "pjesemarres",
          },
                
              },
            },
        order:    "Porosi",
        date:     "Data",
        table:    "Tavolinë",
        room:     "Dhomë",
        
            client_page: {
              title: "Menaxhimi i Klientëve",
              search_label: "Kërko sipas emrit ose numrit të dhomës",
              insert_passenger: "Shto Klient të Jashtëm",
              or_create_company: "Ose krijo një kompani të re:",
              address: "Adresa",
              street_number: "Numri i Rrugës",
              zip_code: "Kodi Postar",
              city: "Qyteti",
              province: "Provincia",
              tax_code: "Kodi Fiskal",
              rea_number: "Numri REA",
              rea_office: "Zyrja REA",
              name: "Emri",
              surname: "Mbiemri",
              email: 'Adresa email',
              phone: 'Numri i telefonit',
              add_client: "Shto Klient",
              order_history: "Historia e porosive për",
              order: "Porosi",
              toCheckout: "Dërgo te Arka",
              no_orders: "Nuk u gjet asnjë porosi",
              room: "Numri i dhomës",
              treatment: "Trajtim (I jashtëm ose Klient)",
              internal: "Klient",
        external: " i Jashtëm",
        no_client_search: "Përdor shiritin e kërkimit për të gjetur klientin",
              client_type: "Lloji i Klientit",
              add_company: "Shto Kompani",
              type_company: "Kompani",
              type_individual: "Individual",
              type_reference: "Kontakt Referues",
              company_name: "Emri i Kompanisë",
              contact_person: "Personi i Kontaktit",
              email_or_phone_required: "Email ose numri i telefonit është i detyrueshëm",
              name_optional: "Emri (Opsional)",
              surname_optional: "Mbiemri (Opsional)",
        btn_clienti: "Klientët",
          btn_aziende: "Kompanitë",

          legal_address: "Selia ligjore",
          company_email: "Email i kompanisë",

          company_hint:        "Asnjë kompani — krijo një te Kompanitë",
          company_search_hint: "Kërko ose zgjidh një kompani ekzistuese",
          company_no_options:  "Asnjë kompani e gjetur",

          no_results:       "Asnjë klient i gjetur.",
          linked_clients:   "Klientët e lidhur",

          add_company_and_client:  "Shto Kompani dhe Klient",
          add_company_subtitle:    "Regjistro një kompani të re dhe klientin kryesor të lidhur.",
          client_info:             "Të dhënat e Klientit",
          company_info:            "Të dhënat e Kompanisë",
          register_company_client: "Regjistro Kompani dhe Klient",

          company_management: "Menaxhim Kompanish",
          no_companies:       "Asnjë kompani e regjistruar ende.",

          success_create:                "Klienti u regjistrua me sukses!",
          success_create_company_client: "Kompania dhe klienti u regjistruan me sukses!",
          error_required_fields:         "Emri dhe mbiemri janë të detyrueshëm.",
          error_company_required:        "Emri i kompanisë është i detyrueshëm.",
          error_create:                  "Gabim gjatë regjistrimit.",
            },
            confirmOperation: {
              deleteProduct: "Fshi produktin nga porosia?",
              cancel: "Anullo",
              confirm: "Konfirmo",
              editOrder: "Ndrysho Porosinë",
            },
            sameClient: "I njëjti klient?",
            openDrawer: "hap menunë",
            heliteGuestPicker: {
              title: "Zgjidh mysafirin HElite",
              searchPlaceholder: "Kerko sipas dhomes, emrit ose prenotimit",
              loading: "Duke ngarkuar mysafiret HElite...",
              loadingShort: "Duke ngarkuar mysafiret...",
              empty: "Nuk u gjet asnje mysafir HElite.",
              room: "Dhoma",
              guest: "Mysafir",
              board: "Board",
              booking: "Prenotimi",
              arrival: "Mberritja",
              departure: "Largimi",
              roomWithNumber: "Dhoma {{room}}",
              bookingShort: "Pren. {{number}}",
              linkedGuest: "Mysafir HElite",
              noLinkedGuest: "Nuk ka mysafir HElite te lidhur",
              selectButton: "Mysafir HElite",
              selectRequired: "Zgjidh nje mysafir HElite",
              confirmCharge: "Konfirmo debitimin",
              missingBillId: "Mysafiri HElite nuk ka billId: nuk mund te regjistrohet debitimi i dhomes.",
              invalidAmount: "Shuma HElite nuk eshte e vlefshme.",
              loadError: "Gabim ne marrjen e mysafireve HElite",
              invalidCheckoutTotal: "Totali i checkout nuk eshte i vlefshem",
              paymentRoomCharge: "Debitim HElite",
              restaurantChargeDescription: "Debitim restoranti {{room}}{{table}}",
              reservationRecipientRequired: "Zgjidh klient, kompani ose mysafir HElite per prenotimin",
              reservationGuestsRequired: "Vendos sa vende duhen prenotuar",
              reservationDateTimeRequired: "Zgjidh daten dhe fashen orare",
              reservationTableRequired: "Zgjidh te pakten nje tavoline",
              reservationInvalidTimeRange: "Intervali orar nuk eshte i vlefshem",
              reservationPastDate: "Data e prenotimit eshte ne te shkuaren.",
            },
            Passante: "Kalimtar",
            singleCreate: "Krijim i Vetëm",
            bulkCreate: "Krijim Masiv",
            Cliente: "Klient",
            Orders: "Porosi",
            orderList: "Lista e Porosive",
            orderDetail: "Detajet e Porosisë për",
            orderDetails: "Detajet e Porosisë",
            seeOrder: "Shiko Porosinë",
            send_order: "Dërgo Porosinë",
            follow: "Vijo",
            showPic: "Shfaq Imazhet",
            addTimeSlot: "Shto fashe orare",
            removeTimeSlot: "Hiq fashe orare",
            hidePic: "Fshih Imazhet",
            systemSettings: {
              page: "Cilesimet e Sistemit",
              pageSubtitle: "Konfiguro preferencat operative te parazgjedhura te sistemit.",
              showOrderImages: "Shfaq imazhe te marrja e porosive",
              showOrderImagesHelp: "Shfaq ose fshih imazhet e produkteve gjate marrjes se porosive.",
              kitchenPrintMenuName: "Printo emrin e menus ne porosite e kuzhines",
              kitchenPrintMenuNameHelp: "Shton emrin e menus me cmim fiks prane cdo pjate te zgjedhur.",
              kitchenPrintMenuNameOn: "I dukshem",
              kitchenPrintMenuNameOff: "I fshehur",
              defaultTableMapView: "Pamja e parazgjedhur e hartes se tavolinave",
              defaultTableMapViewHelp: "Percakton pamjen fillestare kur hapet Harta e Tavolinave.",
              draftPrintersLabel: "Printerat e parakontos",
              draftPrintersHelp: "Keta printera do te perdoren per parakonton (te pavarur nga produktet).",
              invoiceCourtesyPrintersLabel: "Printerat e kopjeve te fatures",
              invoiceCourtesyPrintersHelp: "Keta printera do te perdoren per kopje te shkurtra te fatures.",
              defaultVatRate: "TVSH e parazgjedhur (%)",
              defaultVatRateHelp: "Perdoret kur nje kategori produkti nuk ka nje norme specifike TVSH-je.",
              defaultVatRateInvalid: "Vendos nje norme TVSH-je nga 0 deri ne 100.",
              defaultVatRateSaved: "Norma e parazgjedhur e TVSH-se u ruajt me sukses.",
              congressAgendaColors: "Ngjyrat e agjendes se konferencave",
              congressAgendaColorsHelp: "Konfiguro ngjyrat e perdorura ne planner per te konfirmuara, Check-in, te perfunduara dhe ofertat e skaduara.",
              none: "Asnje",
              ready: "Gati",
              sectionGeneral: "Te pergjithshme",
              sectionBilling: "Faturimi",
              sectionEasyInvoice: "EasyInvoice",
              tenantTypes: {
                SALE_CONGRESSI: "Salla konferencash",
                RISTORANTE: "Restorant",
                SPA: "Spa",
              },
              billingOwnerData: "Të dhënat e ofruesit",
              ownerName: "Name/Business Name",
              ownerSurname: "Mbiemri (nëse është individ)",
              ownerTaxCode: "Kodi tatimor",
              ownerVat: "Numri i TVSH-së",
              ownerAddress: "Adresa",
              ownerPostalCode: "Kodi postar",
              ownerCity: "Qyteti",
              ownerProvince: "Provinca",
              ownerEmail: "Email",
              ownerPhone: "Telefon",
              billingOwnerData: "Te dhenat e ofruesit",
              billingOwnerDataHelp: "Te dhenat fiskale qe perdoren ne dokumente dhe integrime.",
              ownerName: "Emri/Emri i biznesit",
              ownerSurname: "Mbiemri (nese eshte individ)",
              ownerVat: "Numri i TVSH-se",
              edit: "Ndrysho",
              save: "Ruaj",
              saving: "Duke u ruajtur...",
              cancel: "Anullo",
              saveBillingSuccess: "Të dhënat e faturimit u ruajtën me sukses.",
              saveBillingSuccess: "Te dhenat e faturimit u ruajten me sukses.",
              easyInvoiceTitle: "Kredencialet e aksesit",
              easyInvoiceHelp: "Kredencialet per lidhjen me sherbimin EasyInvoice.",
              saveEasyInvoiceSuccess: "Kredencialet u ruajten me sukses.",
              user: "Perdoruesi",
              password: "Fjalekalimi",
              client_id: "Client ID",
              secret: "Secret",
              validation: {
                ownerNameRequired: "Vendos te pakten emrin ose emrin e biznesit.",
                provinceTooLong: "Provinca duhet te kete maksimumi 2 karaktere.",
                emailInvalid: "Email i pavlefshem.",
              },
              saveEasyInviceSuccess: "Kredencialet u ruajtën me sukses.",
              smtp: {
                title: "Konfigurimi SMTP",
                help: "Serveri i email-it qe perdoret nga tenanti per oferta, permbledhje dhe komunikime.",
                portInvalid: "PORTA_SMTP duhet te jete nga 1 deri ne 65535.",
                passwordPlaceholder: "Fjalekalimi eshte ruajtur: lere bosh per ta mbajtur.",
                saveSuccess: "Konfigurimi SMTP u ruajt me sukses.",
              },
              logo: {
                title: "Logo",
                empty: "Nuk ka logo te ngarkuar",
                upload: "Ngarko logo",
                change: "Ndrysho logo",
                remove: "Hiq",
                alt: "Logo e tenantit",
                invalidType: "Ngarko nje logo PNG, JPG, WEBP ose SVG.",
                tooLarge: "Logo duhet te jete me pak se 2 MB.",
                readError: "Nuk mund te lexohet file i zgjedhur.",
                saveSuccess: "Logo u ruajt me sukses.",
              },
              pms: {
                title: "PMS HElite",
                help: "Kredencialet per lidhjen me PMS HElite.",
                urlInvalid: "URL HElite i pavlefshem.",
                passwordPlaceholder: "Fjalekalimi eshte ruajtur: lere bosh per ta mbajtur.",
                saveSuccess: "Konfigurimi PMS u ruajt me sukses.",
              },
            },
            departments: {
              title: "Repartet",
              subtitle: "Menaxho repartet operative dhe lidhi me perdoruesit qe duhet te marrin ose menaxhojne shenimet e sherbimeve.",
              conferenceOnly: "Kjo liste eshte e disponueshme vetem per sallat e konferencave.",
              newDepartment: "Repart i ri",
              editDepartment: "Ndrysho repartin",
              registryTitle: "Lista e reparteve",
              registrySubtitle: "Kuzhina, mirembajtja, pritja, teknika audio/video, etj.",
              department: "Reparti",
              status: "Statusi",
              users: "Perdoruesit",
              actions: "Veprime",
              noDescription: "Pa pershkrim",
              empty: "Nuk ka reparte te konfiguruara.",
              usersTitle: "Perdoruesit dhe repartet",
              usersSubtitle: "Cdo perdorues mund te jete ne nje ose me shume reparte.",
              assignedDepartments: "Repartet e lidhura",
              departmentName: "Emri i repartit",
              description: "Pershkrimi",
              departmentActive: "Repart aktiv",
              userFallback: "Perdoruesi {{id}}",
              validation: { nameRequired: "Vendos emrin e repartit." },
              loadError: "Gabim ne ngarkimin e reparteve.",
              created: "Reparti u krijua.",
              updated: "Reparti u perditesua.",
              saveError: "Gabim ne ruajtjen e repartit.",
              deleteConfirm: "Te fshihet reparti \"{{name}}\"?",
              deleted: "Reparti u fshi.",
              deleteError: "Gabim ne fshirjen e repartit.",
              userDepartmentsUpdated: "Repartet e perdoruesit u perditesuan.",
              userDepartmentsError: "Gabim ne perditesimin e reparteve te perdoruesit.",
            },
            setups: {
              shortLabel: "Setup-et",
              title: "Setup sallash",
              subtitle: "Liste e lire per konfigurime si patkua, skene, platea ose setup te personalizuara.",
              conferenceOnlyTitle: "Liste e disponueshme vetem per salla konferencash",
              conferenceOnlySubtitle: "Per restorantet mbetet menaxhimi normal i paketave/menuve, pa kete liste setup-esh.",
              newSetup: "Setup i ri",
              editSetup: "Ndrysho setup-in",
              search: "Kerko setup-e",
              noPhoto: "Nuk ka foto",
              photoCount: "Foto: {{count}}",
              empty: "Nuk u gjet asnje setup.",
              setupName: "Emri i setup-it",
              description: "Pershkrimi",
              setupActive: "Setup aktiv",
              uploadImages: "Ngarko imazhe",
              imageAlt: "Setup",
              validation: { nameRequired: "Vendos emrin e setup-it." },
              loadError: "Gabim ne ngarkimin e setup-eve",
              uploadError: "Gabim ne ngarkimin e imazheve",
              saved: "Setup-i u ruajt.",
              saveError: "Gabim ne ruajtjen e setup-it",
              deleteConfirm: "Te fshihet setup-i \"{{name}}\"?",
              deleted: "Setup-i u fshi.",
              deleteError: "Gabim ne fshirjen e setup-it",
            },
            usageTypes: {
              title: "Llojet e perdorimit",
              subtitle: "Percakto kategori te lira si meeting, trajnim, asamble, event privat.",
              conferenceOnly: "Kjo liste eshte e disponueshme vetem per sallat e konferencave.",
              newType: "Lloj i ri",
              newUsageType: "Lloj i ri perdorimi",
              editType: "Ndrysho llojin e perdorimit",
              name: "Emri",
              description: "Pershkrimi",
              typeActive: "Lloj aktiv",
              noDescription: "Pa pershkrim.",
              empty: "Nuk ka lloje perdorimi te konfiguruara.",
              validation: { nameRequired: "Vendos emrin e llojit te perdorimit." },
              loadError: "Gabim ne ngarkimin e llojeve te perdorimit.",
              created: "Lloji i perdorimit u krijua.",
              updated: "Lloji i perdorimit u perditesua.",
              saveError: "Gabim ne ruajtjen e llojit te perdorimit.",
              deleteConfirm: "Te fshihet lloji i perdorimit \"{{name}}\"?",
              deleted: "Lloji i perdorimit u fshi.",
              deleteError: "Gabim ne fshirjen e llojit te perdorimit.",
            },
            congressReservations: {
              validation: {
                eventNameRequired: "Vendos emrin e eventit/praktikes.",
                quoteEmailRequired: "Per oferten duhet nje email i vlefshem i marresit.",
                sendEmailRequired: "Per te derguar email-in duhet nje email i vlefshem i marresit.",
                dayRequired: "Shto te pakten nje dite.",
                dayDateTimeRequired: "Ploteso datat dhe oraret e diteve.",
                dayEndAfterStart: "Cdo dite duhet te kete orar perfundimi pas fillimit.",
                guestsPositive: "Te ftuarit duhet te jene me shume se zero.",
                roomRequiredForReservation: "Per ta kthyer ne rezervim, cakto te pakten nje salle per cdo dite.",
                departmentRequired: "Per cdo sherbim zgjidh repartin perkates.",
                serviceTimeOutsideDay: "Orari i sherbimit {{time}} per {{service}} ne {{day}} duhet te jete midis {{start}} dhe {{end}}.",
              },
              loadError: "Gabim ne ngarkimin e te dhenave te kongresit.",
              emailSubject: {
                quote: "Oferte - {{name}}",
                confirmed: "Konfirmim rezervimi - {{name}}",
                option: "Opsion rezervimi - {{name}}",
                summary: "Permbledhje eventi - {{name}}",
              },
              rowCategory: {
                serviceDepartment: "Sherbim - {{department}}",
                extraDepartment: "Ekstra - {{department}}",
                extra: "Ekstra",
              },
              genericClientNameRequired: "Vendos fillimisht emrin e klientit gjenerik.",
              genericClientCreated: "Klienti u krijua dhe u lidh me praktiken.",
              genericClientCreateError: "Gabim ne krijimin e klientit.",
              genericCompanyNameRequired: "Vendos fillimisht emrin e kompanise gjenerike.",
              genericCompanyCreated: "Kompania u krijua dhe u lidh me praktiken.",
              genericCompanyCreateError: "Gabim ne krijimin e kompanise.",
              mailWarning: "Praktika u ruajt, por email-i nuk u dergua: {{error}}.",
              sendError: "gabim dergimi",
              practiceSaved: "Praktika u ruajt.",
              practiceSavedWithWarning: "Praktika u ruajt. {{warning}}",
              practiceSaveError: "Gabim ne ruajtjen e praktikes.",
              savingPractice: "Duke ruajtur praktiken...",
              cancellationReasonRequired: "Vendos arsyen e anulimit.",
              cancelConfirmWithPrepayments: "Kjo praktike ka ende {{amount}} parapagime te hapura. Te anulohet gjithsesi?",
              cancelPracticeWarningTitle: "Parapagime te hapura",
              confirmActionHelp: "Kontrollo bilancin e hapur para se te vazhdosh.",
              reservationConfirmed: "Rezervimi u konfirmua.",
              reservationConfirmError: "Gabim ne konfirmimin e rezervimit.",
              restoreCheckIn: "Rikthe rezervimin",
              restoreCheckInTitle: "Rikthe check-in",
              restoreCheckInConfirm: "Te rikthehet check-in per \"{{name}}\" ne nje rezervim te konfirmuar?",
              restoreCheckInHelp: "Perdore kete veprim vetem per te korrigjuar nje gabim te operatorit.",
              restoreCheckInSuccess: "Check-in u rikthye. Eventi eshte perseri nje rezervim i konfirmuar.",
              restoreCheckInError: "Gabim gjate rikthimit te check-in.",
              deleteConfirm: "Te fshihet \"{{name}}\"?",
              deleteConfirmWithPrepayments: "Kjo praktike ka ende {{amount}} parapagime te hapura. Te fshihet gjithsesi?",
              deletePracticeTitle: "Fshi praktiken",
              deletePracticeWarningTitle: "Fshi praktiken me parapagime",
              practiceDeleted: "Praktika u fshi.",
              practiceDeleteError: "Gabim ne fshirjen e praktikes.",
              practiceDeleteBlockedByPrepayments: "Kjo praktike nuk mund te fshihet sepse ka histori parapagimesh te lidhur. Anulo ose storno levizjet financiare me pare.",
              practiceDeleteBlockedByAccount: "Kjo praktike nuk mund te fshihet sepse llogaria eshte leshuar tashme.",
              plannerStartDate: "Data e nisjes",
              serviceQuantityOverageTitle: "Sasia e sherbimit tejkalon numrin e te ftuarve",
              serviceQuantityOverageConfirm: "Disa sherbime tejkalojne numrin e te ftuarve ne salle:\n{{details}}\n\nTe ruhet gjithsesi?",
              saveAnyway: "Ruaj gjithsesi",
              assignRoomBeforeCheckout: "Cakto nje salle para se te shkosh ne arke.",
              compatibilityUpdated: "Setup-et kompatibile u perditesuan.",
              compatibilityUpdateError: "Gabim ne perditesimin e kompatibilitetit.",
              pdfError: "Gabim ne gjenerimin e PDF.",
              summaryEmailSent: "Permbledhja u dergua me email.",
              summaryEmailError: "Gabim ne dergimin e permbledhjes.",
              goToCheckout: "Shko ne arke",
              editPractice: "Ndrysho praktiken",
              newPractice: "Praktike e re",
              freeRecipientVat: "Numri i TVSH-se i marresit te lire",
              freeRecipientEmail: "Email-i i marresit te lire",
              optionalClient: "Klient (opsional)",
              clientVat: "Numri i TVSH-se i klientit",
              clientEmail: "Email-i i klientit",
              optionalCompany: "Kompani (opsionale)",
              companyVat: "Numri i TVSH-se i kompanise",
              companyEmail: "Email-i i kompanise",
              activeFlag: "Aktive",
              cancellationReason: "Arsyeja e anulimit",
              cancellationReasonHelp: "E detyrueshme kur praktika anulohet.",
              cancellationReasonPlaceholder: "Shkruaj arsyen e anulimit...",
              emailAddresses: "Adresat email",
              emailAddressesHelp: "Mund te vendosesh disa adresa te ndara me presje, pikepresje ose rresht te ri.",
              none: "Asnje",
              setupNotePlaceholder: "P.sh. vendosje skene, mikrofona, mirembajtje...",
              rowNotePlaceholder: "P.sh. pa gluten, pergatit teknikun, kalim mirembajtjeje...",
              quoteRow: "Rresht oferte",
              attachment: "Bashkengjitje",
              savedAttachment: "{{name}} (e ruajtur)",
              emailPreview: "Pamja paraprake e email-it",
              defaultQuoteEmailMessage: "Ju falenderojme per interesin. Me poshte gjeni oferten e detajuar per sherbimet e kerkuara. Data e vlefshmerise se ofertes tregohet me poshte. Jemi ne dispozicion per cdo sqarim ose ndryshim.",
              defaultConfirmationEmailMessage: "Konfirmojmë detajet e rezervimit të paraqitura më poshtë. Jemi në dispozicion për çdo kërkesë ose ndryshim.",
              send: "dergim",
              resends: "ridergime",
              moreThan: "me shume se",
              prepayments: {
                action: "Parapagime",
                column: "Parapagime",
                title: "Parapagime - {{name}}",
                eventTotal: "Totali i eventit",
                totalDeposits: "Depozita",
                totalAdvances: "Parapagime fiskale",
                totalPrepayments: "Totali i parapagimeve",
                amountDue: "Mbetet per t'u paguar",
                remainingShort: "{{amount}} mbetur",
                sessionInfo: "Totalet dhe levizjet ngarkohen nga historiku i parapagimeve ne backend.",
                loadingSummary: "Duke ngarkuar historikun e parapagimeve...",
                summaryLoadError: "Nuk u ngarkua historiku i parapagimeve.",
                receive: "Merr parapagim",
                refund: "Rimburso",
                deposit: "Depozite",
                fiscalAdvance: "Parapagim fiskal",
                defaultDescription: "Parapagim {{name}}",
                amount: "Shuma",
                refundAmount: "Shuma e rimbursimit",
                paymentMethod: "Menyra e pageses",
                vatRate: "Norma TVSH",
                vatNature: "Natyra TVSH",
                document: "Dokument",
                refundDocument: "Dokument rimbursimi",
                invoiceId: "ID fature",
                creditNoteId: "ID note krediti",
                documentNumber: "Numer dokumenti",
                documentDate: "Date dokumenti",
                description: "Pershkrim",
                notes: "Shenime",
                noRefundable: "Nuk ka levizje te rimbursueshme ne kete sesion. Backend-i duhet te ktheje historikun e parapagimeve per te rimbursuar pas nje rifreskimi.",
                sourceMovement: "Levizja per rimbursim",
                originalDocument: "Dokumenti origjinal: {{documentType}} {{documentNumber}}",
                movementOption: "#{{id}} - {{type}} - {{amount}} - {{documentType}}",
                movementOptionAvailable: "#{{id}} - {{type}} - origjinale {{amount}} - e disponueshme {{available}} - {{documentType}}",
                register: "Regjistro",
                saving: "Duke ruajtur...",
                receivedSuccess: "Parapagimi u regjistrua.",
                refundSuccess: "Rimbursimi u regjistrua.",
                reverseSuccess: "Parapagimi u stornua.",
                fullReversalInfo: "Ky parapagim fiskal do te stornohet plotesisht: {{amount}}.",
                invoiceDelivery: {
                  SENT: "Fatura #{{invoiceId}} u ruajt dhe u dergua.",
                  FAILED: "Levizja dhe fatura #{{invoiceId}} u ruajten, por dergimi deshtoi. Provoje nga dokumentet e leshuara. {{message}}",
                  SKIPPED: "Levizja u ruajt. Fatura #{{invoiceId}} eshte derguar ose eshte ne proces.",
                },
                paymentMethods: {
                  cash: "Cash",
                  card: "Karte",
                  bankTransfer: "Transferte bankare",
                  voucher: "Voucher",
                  roomCharge: "Ngarkese dhome",
                },
                documentTypes: {
                  commercialDocument: "Dokument komercial",
                  invoiceTd02: "Fature parapagimi TD02",
                  plainReceiptRefund: "Fature rimbursimi",
                  commercialCancellation: "Anulim komercial",
                  commercialReturn: "Kthim komercial",
                  creditNoteTd04: "Note krediti TD04",
                },
                vatNatureOptions: {
                  N1: "N1",
                  N2: "N2",
                  N3: "N3",
                  N4: "N4",
                  N5: "N5",
                  N6: "N6",
                  N7: "N7",
                },
                validation: {
                  validAmountRequired: "Vendos nje shume te vlefshme.",
                  sourceRequired: "Zgjidh levizjen qe do rimbursohet.",
                  td04IdRequired: "Vendos ID-ne e notes se kreditit TD04.",
                  refundDocumentRequired: "Ploteso numrin dhe daten e dokumentit te rimbursimit.",
                  vatRateRequired: "Vendos nje norme TVSH te vlefshme.",
                  descriptionRequired: "Vendos pershkrimin e parapagimit fiskal.",
                  td02IdRequired: "Vendos ID-ne e fatures TD02.",
                  vatNatureRequired: "Zgjidh natyren TVSH per nje TD02 me TVSH zero.",
                  commercialDocumentRequired: "Ploteso numrin dhe daten e dokumentit komercial.",
                },
                errors: {
                  exceedsTotal: "Parapagimet tejkalojne totalin e praktikes. Totali: {{practiceTotal}}, te regjistruara: {{currentPrepayments}}, e kerkuar: {{requestedAmount}}.",
                  refundExceeds: "Rimbursimi tejkalon shumen e disponueshme. E disponueshme: {{refundableAmount}}, e kerkuar: {{requestedAmount}}.",
                  idempotencyKeyReused: "Kjo kerkese eshte perdorur me te dhena te ndryshme. Provo perseri veprimin.",
                  invalidReversalDocument: "Ky parapagim kerkon {{documentType}}.",
                  td02NotSent: "Fatura TD02 duhet te dergohet me sukses para se te stornohet me TD04.",
                  generic: "Gabim ne regjistrimin e parapagimit.",
                },
              },
            },
            orderSummary: "Përmbledhja e Porosisë",
            noProductPresent: "Nuk ka produkte në këtë porosi",
            perPerson: "për person",
            description: "Përshkrim",
            visible: "I dukshëm",
            wait: "Kohë pritje",
            guests: "Mysafirë",
            noOrders: "Nuk ka Porosi Aktive",
            realTimeOrders: "Porosi në Kohë Reale",
            newOrder: "Porosi e Re",
            closeBill: "Mbyll Llogarinë",
            togglePasswordVisibility: "Shfaq/fshih fjalëkalimin",
            addTable: "Shto Tavolinë",
            noTable: "Nuk ka Tavolina",
            No_table_selected: "Asnjë tavolinë e zgjedhur",
            tableSession: {
              inUse: "Në ngarkim të një operatori tjetër",
            },
            menu: "Menu",
            yes: "Po",
            no: "Jo",
            support: "Ndihmë",
            dailySales: "Shitjet ditore (ditët e fundit)",
            total: "Total",
            occupiedTables: "Tavolina të Zëna",
            noTableOccupied: "Asnjë Tavolinë e Zënë",
            confirmReservationClient: "Konfirmoni që ky është klienti i rezervimit?",
            syncRequests: "Sinkronizo {{count}} kërkesa",
            confirmSeats: "Konfirmo numrin e vendeve",
            addTableQuestion: "Shto tavolinë?",
            activeOrders: "Porosi Aktive",
            avgTime: "Koha Mesatare",
            revenueToday: "Të Ardhurat e Sotme",
            split: "Ndaj Porosinë",
            mostSold: "Produktet Më të Shitura",
            sold: "Shitur",
            checkoutPage: "Arka",
            tableMapPage: {
              columnNames: {
                name: "EMRI",
                seats: "VENDET",
                status: "STATUSI"
              },
              print: "Printo",
              reprintOrders: "Riprinto Porosite",
              transferOrders: "Transfero Porosite",
              transferFrom: "Transfero nga:",
              transferTo: "Transfero tek:",
              transferButton: "Transfero",
              noTableInWaiting: "Asnjë Tavolinë në Pritje",
              noTableOccupied: "Asnjë Tavolinë e Zënë",
              draftPayment: "Parakonto",
              roomChargeCheckout: "Addebito dhome",
              CRMclients: "Klientë CRM",
              seeOrders: "Shiko Porosite",
              minute: "Minutë",
              minutes: "Minuta",
              course: "Pjatë",
              details: "Detaje",
              close: "Mbyll",
              open: "Hap",
              sendToCheckout: "Dërgo në Arkë",
              error_move_product_1: "Gabim gjatë lëvizjes së produktit:",
              error_delete_order_1: "Gabim gjatë fshirjes së porosisë:",
              error_patch_order_1: "Gabim gjatë përditësimit të porosisë:",
              error_coordinates_table_1: "Gabim gjatë marrjes së koordinatave:",
              error_coordinates_table_2: "Gabim gjatë ruajtjes së koordinatave:",
              error_categories_1: "Gabim gjatë marrjes së kategorive:",
              error_transfer_order_1: "Gabim gjatë transferimit të porosisë",
              unknown_error: "Gabim i panjohur",
              error_print_1: "Gabim gjatë printimit të porosisë",
            },
            sortName: "Rendit sipas Emrit",
            sortPrice: "Rendit sipas Çmimit",
            showDetails: "Shiko",
            blankname: 'Emri nuk mund të jetë bosh',
            editLayout: "Ndrysho Paraqitjen",
            editLayoutTitle: "Ndrysho Paraqitjen e Tavolinave",
            cancel: "Anullo",
            clearAllTablesAndPay: "[DEV] LIRO TAVOLINAT DHE PAGUAJ POROSITE",
            courseAddedSuccess: "Pjata u shtua me sukses!",
            invalidRoleSelected: "Roli i zgjedhur është i pavlefshëm",
            save: "Ruaj",
            confirm: "Konfirmo",
            select: "Zgjidh",
            work_selection: "Zgjidh Zonën e Punës për Sot",
            operator: "Operatori",
            freetables: "Tavolina të Lira",
            activetables: "Tavolina Aktive",
            selectTable: "Zgjidh Tavolinën",
            noTableSelected: "Nuk ka të dhëna. Zgjidh një tavolinë.",
            formats: "Formatet e Mbështetura",
            generalstatus: "Statusi i Përgjithshëm i Shërbimit",
            active: "Aktive",
            products: 'Produkte',
            orders: 'Porosi',
            select_orders: 'Zgjidh Porositë',
            selected_articles: 'Artikujt e Zgjedhur',
            variants: 'Variante',
            reservations: 'Rezervime',
            reservation: 'Rezervim',
            confirmClientQuestion: "Konfirmoni që ky është klienti i rezervimit?",
            selectedOrders_alert: {
              successAddProduct: "Pjata u shtua me sukses!",
              orderSaved: "Porosia u mor dhe u ruajt me sukses!",
              errExceedSeatingCapacity: "Numri i vendeve të zgjedhura tejkalon kufirin maksimal të lejuar nga tavolina",
            },
            booking: {
              name: "Emri i klientit",
              guests: "Numri i mysafirëve",
              calendar_help: "Zgjidh një interval në kalendar ose rregullo orarin manualisht më poshtë",
              today: "Sot",
              back: "Prapa",
              next: "Tjetër",
              week: "Javë",
              day: "Ditë",
              event: "Ngjarje",
              allDay: 'Gjithë ditën',
              work_week: 'Java e Punës',
              month: 'Muaj',
              tomorrow: 'Nesër',
              yesterday: 'Dje',
              agenda: 'Axhendë',
              date: "Data",
              time: "Ora",
              room: "Sallë",
              table: "Tavolinë",
              notes: "Shënime",
              submit: "Dërgo rezervimin",
        packagesLabel: "Paketat (opsionale)",
        packagesSelect: "Zgjidh paketat",
        packagesBookedNoteTitle: "Paketat e rezervuara",
        packageFallbackName: "Paketë",
      },
      orderPackages: {
        label: "Paketë",
        tastingMenu: "Menu degustimi",
        select: "Zgjidh paketën",
        add: "Shto paketë",
        invalidSelection: "Nuk u zgjodh asnjë paketë e vlefshme",
        addedSuccess: "Paketa u shtua në porosi",
            },
            list_reservation: "Lista e rezervimeve",
            
            reservations_details: {
              title: "Rezervimet",
              client: "Klient",
              table: "Tavolinë",
              room: "Dhomë",
              date: "Data e Rezervimit",
              status: "Statusi",
              change_status: "Ndrysho statusin",
              status_update_error: "Gabim në përditësimin e statusit",
              status_values: {
                TO_CONFIRM: "Për konfirmim",
                CONFIRMED: "E konfirmuar",
                COMPLETED: "E përfunduar",
                CANCELLED: "E anuluar",
                NO_SHOW: "Nuk u paraqit",
              },
              cancellation_reason: "Arsyeja e anulimit",
              cancellation_reason_placeholder: "Shkruaj arsyen pse u anulua rezervimi",
              provide_cancellation_reason: "Ju lutem vendosni arsyen e anulimit",
              add_cancellation_reason: "Për ta vendosur statusin në anuluar, shkruani arsyen.",
              createdAt: "Krijuar më",
              clientDetails: "Detajet e Klientit",
              edit_pending_hint: "Ky rezervim është për konfirmim. Mund të ndryshoni datën, orën, mysafirët, tavolinën dhe shënimet.",
              edit_booking: "Ndrysho rezervimin",
              save_booking: "Ruaj ndryshimet e rezervimit",
              save_booking_error: "Gabim në përditësimin e rezervimit",
              error: "Gabim",
              none: "Nuk u gjet asnjë rezervim",
              noClient: "Asnjë Klient",
              noOrder: "Asnjë Porosi"
            },
            clearModal: {
              dialogTitle: "Konfirmo lirimin e tavolinës",
              dialogAlert: "Jeni i sigurt që doni të lironi tavolinën",
            },
            chart: {
              title: "Shpërndarja e Porosive",
              noData: "Nuk u gjet asnjë porosi për sallën e zgjedhur",
              loading: "Duke ngarkuar të dhënat...",
            },
            selectRoom: "Zgjidh sallën",
            hello: "Mirësevini",
            selected: "Zgjedhur",
            quantity: "Sasia",
            no_room: 'Nuk ka sallë disponibile',
            add_product: 'Shto Produkt',
            noEventsInRange: 'Nuk ka ngjarje në këtë interval.',
            new_product: 'Produkt i Ri',
            delete_product: "Fshi produktin",
            edit_product: 'Ndrysho Produktin',
            delete_button: 'Fshi',
            allTablesAlreadyFree: "Të gjitha tavolinat janë tashmë të lira dhe/ose të gjitha porositë janë paguar!",
            allTablesCleared: "Të gjitha tavolinat janë liruar dhe/ose të gjitha porositë janë paguar!",
            tables: 'Harta e Tavolinave',
            new_room_name: 'Emri i Ri i Sallës',
            new_table: 'Tavolinë e Re',
            add_table: 'Shto Tavolinë',
            edit_table: 'Ndrysho Tavolinën',
            table_name: 'Emri i Tavolinës',
            table_name_prefix: 'Prefiksi i Emrit',
            table_name_suffix: 'Sufiksi i Emrit',
            table_quantity: 'Sasia e Tavolinave',
            selected_table: 'Tavolina e Zgjedhur',
            deleteTableRequestTitle: "Konfirmo Fshirjen e Tavolinës",
            deleteTableRequest: "Jeni i sigurt që doni të fshini këtë tavolinë? Veprimi nuk mund të zhbëhet.",
            deleteRoomRequestTitle: "Konfirmo Fshirjen e Sallës",
            deleteRoomRequest: "Kujdes! Duke fshirë këtë sallë do të fshihen edhe të gjitha tavolinat e lidhura me të. Doni të vazhdoni?",
            addRoom: 'Shto Sallë',
            editRoom: 'Ndrysho Sallën',
            deleteRoom: 'Fshi Sallën',
            roomName: "Emri i Sallës",
            seatNumber: "Numri i Vendeve",
            seats: "vend(e)",
            occupiedSeats: "Vendet e Zëna",
            add_button: 'Shto',
            update_button: "Përditëso",
            cancel_button: 'Anullo',
            changeTo_it: 'Kalo në IT',
            changeTo_en: 'Kalo në ENG',
            changeTo_sq: 'Kalo në SQ',
            dashboard: 'Paneli',
            welcome_message: 'Mirë se vini në faqen kryesore',
            email: 'Email',
            password: "Fjalëkalim",
            product_name: 'Emri',
            price: 'Çmimi',
            category: 'Kategoria',
            subcategory: 'Nënkategoria',
            cover_room: 'Salla e lidhur',
            cover_room_default: 'Të gjitha sallat (parazgjedhur)',
            product_room: 'Salla e lidhur',
            product_room_all: 'Të gjitha sallat',
            product_printer_targets: 'Printerat e artikullit',
            bulkPrinters: {
              selectVisible: 'Zgjidh te dukshmet',
              deselectVisible: 'Hiq zgjedhjen nga te dukshmet',
              selectedCount: '{{count}} te zgjedhura',
              assignPrinters: 'Cakto printerat',
              title: 'Cakto printerat e repartit',
              productsSelected: '{{count}} produkte te zgjedhura',
              noPrintersConfigured: 'Nuk ka printera te konfiguruar. Konfiguro fillimisht printerat e repartit.',
              printers: 'Printerat',
              saving: 'Duke ruajtur...',
              assign: 'Cakto',
              selectProductFirst: 'Zgjidh te pakten nje produkt.',
              selectPrinterFirst: 'Zgjidh te pakten nje printer.',
              updatedSuccess: 'Printerat u perditesuan per {{count}} produkte.',
              assignError: 'Gabim gjate caktimit te printerave.',
            },
            bulkDelete: {
              selectVisible: 'Zgjidh te dukshmet',
              deselectVisible: 'Hiq zgjedhjen nga te dukshmet',
              selectedCount: '{{count}} te zgjedhura',
              deleteSelected: 'Fshi te zgjedhurat',
              productsTitle: 'Fshi produktet',
              productsConfirm: 'Te fshihen perfundimisht {{count}} produktet e zgjedhura?',
              categoriesTitle: 'Fshi kategorite',
              categoriesConfirm: 'Te fshihen perfundimisht {{count}} kategorite e zgjedhura?',
              confirm: 'Fshi',
              deleting: 'Duke fshire...',
              productsDeleted: '{{count}} produkte u fshine.',
              categoriesDeleted: '{{count}} kategori u fshine.',
              deleteProductsError: 'Gabim gjate fshirjes se produkteve.',
              deleteCategoriesError: 'Gabim gjate fshirjes se kategorive.',
            },
            NoCategory: "Pa Kategori",
            waiter: 'Kamerier',
            time: 'Koha',
            no_products: 'Nuk u gjet asnjë produkt',
            addImage: "Shto Imazh",
            changeImage: "Ndrysho Imazhin",
            fromTime: 'Nga',
            toTime: 'Deri',
            Standard: "Pamja Standarde",
            Detailed: "Pamja e Detajuar",
            stats: { page: "Statistika" },
            allRoom: "Të gjitha Sallët",
            selectDate: "Zgjidh Datën dhe Orën nga Kalendari",
            user_management: {
              page: "Përdoruesit",
              title: "Menaxhimi i Përdoruesve",
              add_edit_title: "Shto / Ndrysho Përdoruesin",
              name: "Emri",
              surname: "Mbiemri",
              email: "Email",
              role: "Roli",
              password: "Fjalëkalim",
              new_password: "Fjalëkalim i Ri",
              cancel_button: "Anullo",
              active: "Aktiv",
              inactive: "Joaktiv",
              add_button: "Shto",
              update_button: "Përditëso",
              user_list: "Lista e Përdoruesve",
              noUserAvailable: "Asnjë përdorues i disponueshëm",
            },
            manage_categories: {
              page: "Kategoritë",
              title: "Konfigurimi i Menysë - Kategoritë dhe Nënkategoritë",
              category_name: "Emri i Kategorisë",
              new_category: "Kategori e Re",
              add_category: "Shto Kategori",
              add_subcategory: "Shto Nënkategori",
              add_button: "Shto",
              vat_rate: "TVSH (%)",
              vat_short: "TVSH",
              vat_default: "TVSH e parazgjedhur",
              vat_default_help: "Lere bosh per te perdorur TVSH-ne e parazgjedhur te tenant-it.",
              vat_invalid: "Vendos nje norme TVSH-je nga 0 deri ne 100.",
              order_help: "Terhiq kategorite ose perdor shigjetat per te zgjedhur renditjen ne porosi.",
              drag: "Terhiq per ta levizur",
              move_up: "Leviz lart",
              move_down: "Leviz poshte",
              order_error: "Renditja e kategorive nuk mund te ruhet: ",
            },
            checkout_page: {
              delete: "Fshi",
              invoice: "Faturë",
              surcharge: "Shtesë",
              edit_price: "Ndrysho Çmimin",
              clear_percent: "Hiq %",
              remove_discount: "Hiq Zbritjen",
              move_to_pending: "Kalo Te Pending",
              edit_qty: "Ndrysho Sasinë",
              split: "Ndaj",
              print: "Printo",
              subtotal: "Nëntotali",
              closeCheckout: "Mbyll Arkën",
              partialPayment: "Pagese parciale",
              totalPayment: "Pagese totale",
              printInvoice: "Krijo fature",
              invoiceCloseConfirmTitle: "Fatura u krijua",
              invoiceCloseConfirmNote: "Mbyll arken pa pagese, ose dil dhe leje porosine hapur per pagesen.",
              closeCheckoutWithoutPayment: "Mbyll arken",
              exitInvoiceCloseConfirm: "Dil",
              invoiceCheckoutClosed: "Arka u mbyll pa pagese.",
              toPay: "Për të Paguar",
              searchProduct: "Kërko Produkt",
              noRegisteredOrders: "Asnjë Porosi e Regjistruar",
              NoCategory: "Asnjë Kategori e gjetur",
              totalPaid: "Totali i Paguar",
              confirmedPayment: "Pagesa u Konfirmua!",
              confirmedPayment_note: "Pagesa u krye me sukses.",
              referenceNumber: "Numri i Referencës",
              paymentDate: "Data e Pagesës",
              paymentMethod: "Metoda e Pagesës",
              send: "Dërgo",
              pending: "Në Pritje",
              occupied: "E Zënë",
              toCheckout: "Në Arkë",
              editPrice_note_1: "Asnjë produkt i zgjedhur për ndryshimin e çmimit",
              editPrice_note_2: "Zgjidh produktet për ndryshim, ose lëri pa zgjedhur për t'i aplikuar te të gjitha",
              splitWeightProductWarning: "Nuk mund te ndash produktet me peshe",
              editQty_note_1: "Asnjë produkt i zgjedhur për ndryshimin e sasisë",
              editQty_note_2: "Zgjidh një produkt në të njëjtën kohë për të ndryshuar sasinë",
              delete_title: "Konfirmo Fshirjen e Porosive",
              delete_note_1: "Asnjë produkt i zgjedhur për fshirje",
              delete_note_2: "Vazhdoni me fshirjen? Porosia nuk mund të restaurohet",
              delete_note_3: "Gabim gjatë heqjes",
              delete_note_4: "Gabim gjatë fshirjes së porosisë",
              delete_note_5: "Gabim gjatë heqjes së porosisë (të ndara)",
              delete_note_6: "Gabim gjatë heqjes së porosisë (të bashkuara)",
              fetch_note_1: "Gabim gjatë marrjes së rezervimeve",
              selectPaymentMethode: "Zgjidh metoden e pageses",
              cash: "Para ne dore",
              cards: "Karte",
              other: "Tjeter",
              newCounterSale: "Shitje e re ne banak",
              counterSale: "Shitje ne banak",
              noBookedClient: "Asnje klient i rezervuar",
              notBookedClient: "Nuk eshte ky klienti i rezervuar",
              multipleCheckout: "Arke e perbashket",
              multipleCheckoutHelp: "Zgjidh porosite per t'i bashkuar ne nje llogari pa levizur artikujt mes sallave.",
              multipleCheckoutActiveWarning: "Arka e perbashket eshte ne proces: zgjidh nje tavoline per te shtuar artikuj",
              multipleCheckoutMinOrders: "Zgjidh te pakten dy porosi per t'i bashkuar",
              invalidCheckoutTotal: "Totali i arkes nuk eshte i vlefshem",
              multipleCheckoutOrderCount: "Arke e perbashket ({{count}} porosi)",
              orderColumn: "Porosia",
              itemsColumn: "Artikuj",
              amount: "Shuma",
              given: "Dhenia",
              rowChange: "Kusuri i rreshtit",
              addPaymentMethod: "+ Metode",
              romanSplit: "Ndaje ne pjese te barabarta",
              romanSplitParts: "Numri i pjeseve",
              remaining: "Mbetet",
              totalChange: "Kusuri total",
              confirmPayment: "Konfirmo pagesen",
              cashGiven: "Para te dhena",
              change: "Kusuri",
              prepaymentsLoading: "Duke ngarkuar parapagimet e disponueshme...",
              prepaymentsApplied: "Parapagime te aplikuara",
              amountDueAfterPrepayments: "Shuma per pagese pas parapagimeve",
              prepaymentsWillApply: "{{amount}} do te aplikohet para mbylljes.",
              noAvailablePrepayments: "Nuk ka parapagim te disponueshem per kete mbyllje.",
              zeroBalanceCovered: "Bilanci final eshte mbuluar. Nuk duhet pagese tjeter.",
              prepaymentsCovered: "Mbuluar nga parapagimet",
              prepaymentApplyNote: "Aplikuar gjate mbylljes finale",
              prepaymentsLoadError: "Nuk mund te ngarkohen parapagimet per kete event.",
              prepaymentApplyError: "Nuk mund te aplikohen parapagimet ne mbylljen finale.",
              prepaymentCommercialVatBlocked: "Parapagimi tejkalon totalin e dokumentit tregtar final me te njejten TVSH.",
              prepaymentExceedsOrder: "Parapagimet e zgjedhura tejkalojne totalin e porosise.",
              prepaymentOrderNotApplicable: "Parapagimet nuk mund te aplikohen sepse porosia eshte mbyllur.",
              prepaymentSourceMissing: "Nje ose me shume parapagime te zgjedhura nuk jane me te disponueshme.",
              prepaymentSourceInvalid: "Vetem parapagimet e marra mund te aplikohen ne mbyllje.",
              prepaymentAdvanceAlreadyApplied: "Ky parapagim fiskal eshte aplikuar tashme.",
              prepaymentApplicationExceedsAvailable: "Shuma e zgjedhur tejkalon bilancin e disponueshem te parapagimit.",
              prepaymentAdvanceMustApplyInFull: "Parapagimet fiskale duhet te aplikohen te plota.",
              prepaymentInvalidFinalInvoice: "Fatura e parapagimit ose nota e kreditit nuk mund te perdoret si fature finale.",
              prepaymentFinalInvoiceAlreadySent: "Parapagimet nuk mund te ndryshojne nje fature qe eshte derguar tashme.",
              prepaymentInvoiceNotFound: "Fatura finale nuk u gjet.",
              prepaymentInvoiceVatBlocked: "Parapagimi tejkalon totalin e fatures finale me te njejten TVSH.",
              prepaymentInvoiceVatWarning: "Nje parapagim tejkalon grupin perkates te TVSH-se ne faturen finale. Te vazhdojme?",
              invoicePrepaymentsWillApply: "{{amount}} parapagime do te aplikohen te fatura finale para mbylljes.",
              prepaymentPos: {
                deposits: "Depozita",
                advances: "Parapagime fiskale",
                depositProducts: "Sherbime depozite",
                advanceProducts: "Sherbime parapagimi",
                subtitle: "Dhome e dedikuar per parapagimet e kesaj praktike.",
                receive: "Regjistro",
                refund: "Rimburso",
                reverse: "Storno",
                totalDeposits: "Totali depozitave",
                totalAdvances: "Totali parapagimeve",
                paymentMethod: "Metoda e pageses",
                vatRate: "TVSH",
                vatNature: "Natyra TVSH",
                documentType: "Tipi i dokumentit",
                sourceMovement: "Levizja origjinale",
                invoiceId: "ID fature",
                documentNumber: "Numri dokumentit",
                documentDate: "Data dokumentit",
                description: "Pershkrimi",
                note: "Shenim",
                noEvent: "Zgjidh nje praktike Sale Congressi para se te hapesh Depozita ose Parapagime.",
                noProducts: "Nuk u gjeten sherbime depozite/parapagimi. Kontrollo emrat e produkteve/kategorive.",
                saved: "Levizja e parapagimit u ruajt.",
                fiscalPending: "Printimi automatik i dokumentit fiskal eshte ende pending; vendos referencat manualisht pas printimit.",
                invoiceDelivery: {
                  SENT: "Fatura #{{invoiceId}} u ruajt dhe u dergua.",
                  FAILED: "Levizja dhe fatura #{{invoiceId}} u ruajten, por dergimi deshtoi. Provoje nga dokumentet e leshuara. {{message}}",
                  SKIPPED: "Levizja u ruajt. Fatura #{{invoiceId}} eshte derguar ose eshte ne proces.",
                },
                paymentMethods: {
                  CASH: "Cash",
                  CARD: "Karte",
                  BANK_TRANSFER: "Transferte bankare",
                  VOUCHER: "Voucher",
                  ROOM_CHARGE: "Debitim dhome",
                },
                documentTypes: {
                  COMMERCIAL_DOCUMENT: "Dokument tregtar parapagimi",
                  INVOICE_TD02: "Fature parapagimi TD02",
                  COMMERCIAL_CANCELLATION: "Anulim tregtar",
                  COMMERCIAL_RETURN: "Kthim tregtar",
                  CREDIT_NOTE_TD04: "Note krediti TD04",
                },
                vatNatureOptions: {
                  N1: "N1",
                  N2: "N2",
                  N3: "N3",
                  N4: "N4",
                  N5: "N5",
                  N6: "N6",
                  N7: "N7",
                },
                errors: {
                  amountRequired: "Vendos shumen.",
                  sourceRequired: "Zgjidh levizjen origjinale.",
                  documentRequired: "Vendos numrin dhe daten e dokumentit.",
                  invoiceRequired: "Vendos ID e fatures.",
                  vatNatureRequired: "Zgjidh natyren TVSH per nje TD02 me TVSH zero.",
                  vatRequired: "Vendos TVSH.",
                  descriptionRequired: "Vendos pershkrimin e parapagimit.",
                  exceedsTotal: "Parapagimet tejkalojne totalin e praktikes.",
                  refundExceeds: "Rimbursimi tejkalon shumen e disponueshme.",
                  advanceProcessed: "Ky parapagim ka tashme rimbursim ose storno.",
                  td02NotSent: "Fatura TD02 duhet te dergohet me sukses para se te stornohet me TD04.",
                  generic: "Gabim ne ruajtjen e levizjes se parapagimit.",
                },
              },
              warning: "Paralajmerim",
              incompleteBillingWarning: "Te dhenat e ofruesit per faturim nuk jane te plota. Rregulloji te Faturimi ne Cilesimet e Sistemit para se te krijosh nje fature.",
            },
            menu_config: {
              page: "Menu",
              categories: "Kategoritë",
              category_name: "Emri i Kategorisë",
              select_category: "Zgjidh një kategori",
              product_ordering: "Renditja e Produkteve",
              lunch: "Drekë",
              dinner: "Darkë",
              noProductsMenuFound: "Nuk u gjet asnjë produkt. Ju lutemi kontrolloni disponueshmërinë kohore të produkteve.",
              save_order: "Ruaj renditjen",
            },
            quickActions: {
              quickActions: "Veprime të Shpejta",
              closeOrder: "Mbyll Porosinë",
              cashRegister: "Arka",
              directAccess: "Akses i Drejtpërdrejtë",
            },
            modalVariant: {
              title: "Variantet e Produktit",
            },
            variantManagement: {
              title: "Variantet gjenerike",
              subtitle: "Krijo nje variant dhe lidhe me artikujt.",
              addVariant: "Shto variant",
              noVariants: "Nuk ka variante te konfiguruara",
              priceLabel: "Cmimi: {{price}} EUR",
              linkedProductsCount: "{{count}} artikuj te lidhur",
              linkProducts: "Lidh artikuj",
              editVariant: "Ndrysho variantin",
              newVariant: "Variant i ri",
              variantName: "Emri i variantit",
              notes: "Shenime",
              linkedProducts: "Artikuj te lidhur",
              searchProduct: "Kerko artikull",
              close: "Mbyll",
              deleteVariant: "Fshi variantin",
              deleteConfirm: "Te fshihet \"{{name}}\"? Do hiqen edhe lidhjet me artikujt.",
              linkedToProduct: "I lidhur me kete artikull",
              notLinkedToProduct: "Jo i lidhur me kete artikull",
              linkProductsTitle: "Lidh artikuj - {{name}}",
            },
            error_password_length: 'Fjalëkalimi duhet të ketë të paktën 8 karaktere.',
            error_password_upper: 'Fjalëkalimi duhet të përmbajë të paktën një shkronjë të madhe.',
            error_password_lower: 'Fjalëkalimi duhet të përmbajë të paktën një shkronjë të vogël.',
            error_password_number: 'Fjalëkalimi duhet të përmbajë të paktën një numër.',
            error_password_special: 'Fjalëkalimi duhet të përmbajë të paktën një karakter special.',
            error_username_required: 'Kërkohet emri i përdoruesit',
            error_password_required: 'Kërkohet fjalëkalimi',
            error_password_incorrect: 'Fjalëkalim i gabuar',
            error_products_load: 'Gabim gjatë ngarkimit të produkteve',
            error_number_of_seats: "Numri i Vendeve Nuk Mund të Jetë 0 ose Më i Vogël",
            Logout: 'Dil',
            LIBERO: "E Lirë",
            IN_ATTESA: "Në Pritje",
            OCCUPATO: "E Zënë",
            RISERVATO: "E Rezervuar",
            NON_DISPONIBILE: "E Padisponueshme",
            common: {
              actions: {
                create: "Krijo",
                delete: "Fshi",
                cancel: "Anullo",
                save: "Ruaj",
                edit: "Ndrysho",
                refresh: "Rifresko",
                retry: "Provo Përsëri",
                clearFilter: "Pastro filtrin",
              },
              status: { active: "aktiv", inactive: "joaktiv" },
              pagination: {
                rowsPerPage: "Rreshta për faqe:",
                displayedRows: "{{from}}-{{to}} nga {{count}}"
              },
              errors: { loading: "Gabim gjatë ngarkimit", updateFailed: "Përditësimi dështoi" },
              loading: "Duke ngarkuar...",
              changeLanguage: "Ndrysho gjuhen",
              noResults: "Asnje rezultat",
            },
            admin: {
              smtp: {
                title: "Vlerat e parazgjedhura SMTP",
                help: "Keto vlera kopjohen te tenantet e rinj kur backendi i krijon. Tenanti mund t'i ndryshoje me vone.",
              },
              tenants: {
                title: "Menaxhimi i Tenantëve",
                actions: { newTenant: "Tenant i ri" },
                search: { placeholder: "Kërko tenantë..." },
                empty: {
                  noneTitle: "Asnjë tenant ende",
                  noneSubtitle: "Krijo tennantin tuaj të parë për të filluar.",
                  noResultsTitle: "Asnjë rezultat",
                  noResultsSubtitle: "Asnjë tenant nuk përputhet me filtrat aktualë."
                },
                table: { tenantId: "ID Tenant", id: "Id", tenantType: "Lloji i Tenantit", status: "Statusi", createdAt: "Krijuar", actions: "Veprime" },
                switchAria: "Vendos tenant {{id}} {{state}}",
                dialogs: {
                  create: { title: "Krijo tenant të ri", label: "ID Tenant" },
                  edit: { title: "Ndrysho tenantin" },
                  delete: {
                    title: "Konfirmo fshirjen e tenantit",
                    subtitle: "Për të fshirë tennantin \"{{id}}\" ju lutemi vendosni fjalëkalimin tuaj.",
                    passwordLabel: "Fjalëkalimi i administratorit"
                  }
                },
                confirm: { delete: "Fshi përfundimisht tennantin {{id}}? DB-ja e tij do të hiqet gjithashtu." },
                notifications: {
                  created: "Tenant u krijua",
                  deleted: "Tenant u fshi",
                  activated: "Tenant {{id}} u aktivizua",
                  deactivated: "Tenant {{id}} u çaktivizua"
                }
              },
              users: {
                title: "Menaxhimi i Përdoruesve",
                tabs: { superadmin: "Superadmin", adminByTenant: "Admin sipas tenantit" },
                search: { superadmin: "Kërko superadmin...", admin: "Kërko admin..." },
                buttons: {
                  newSuperadmin: "Superadmin i Ri",
                  createSuperadmin: "Krijo Superadmin",
                  newAdmin: "Admin i Ri",
                  createAdmin: "Krijo Admin"
                },
                empty: {
                  noSuperadminTitle: "Asnjë superadmin",
                  noSuperadminSubtitle: "Krijo superadmin-in e parë për të aksesuar menaxhimin global.",
                  noAdminTitle: "Asnjë admin",
                  noAdminSubtitle: "Ky tenant nuk ka ende administratorë.",
                  noResultsTitle: "Asnjë rezultat",
                  noResultsSubtitleSuperadmin: "Asnjë superadmin nuk përputhet me filtrat aktualë.",
                  noResultsSubtitleAdmin: "Asnjë admin nuk përputhet me filtrat aktualë."
                },
                table: { name: "Emri", surname: "Mbiemri", email: "Email", actions: "Veprime" },
                dialogs: {
                  createUser: {
                    titleSuperadmin: "Krijo Superadmin",
                    titleAdmin: "Krijo Admin Tenanti",
                    fields: { name: "Emri", surname: "Mbiemri", email: "Email", password: "Fjalëkalim", tenant: "Tenant" }
                  }
                },
                confirm: { deleteUser: "Fshi {{email}}?" },
                notifications: {
                  superadminCreated: "Superadmin u krijua",
                  superadminDeleted: "Superadmin u fshi",
                  adminCreated: "Admin u krijua",
                  adminDeleted: "Admin u fshi"
                },
              },
            },
      allestimenti: {
        pageTitle: "Menaxhimi i paketave",
        pageSubtitle: "Krijo paketa per rezervime ose shitje direkte. Te sallat e kongresit perdoren ne rezervim, te restoranti mund te shtohen direkt ne tavoline (p.sh. menu degustimi).",
        pageTitleShort: "Paketa",
        summaryTotalPackages: "Paketa totale",
        summaryActivePackages: "Paketa aktive",
        summaryInactivePackages: "Paketa joaktive",
        searchPlaceholder: "Kerko paketa ose sherbime...",
        newPackage: "Pakete e re",
        productsAvailable: "Sherbime te disponueshme",
        noProductsAvailable: "Nuk ka sherbime te disponueshme",
        noProductsAvailableHint: "Krijo sherbime nga faqja e produkteve per t'i perdorur ketu.",
        packageStatusInactive: "Jo aktive",
        packageStatusActiveNow: "Aktive tani",
        packageStatusOutOfTime: "Jashte orarit",
        packagePrice: "Cmimi",
        packageCapacity: "Kapaciteti",
        packageCapacityPeople: "pjesemarres",
        packageTimeRange: "Orari aktiv",
        includedProducts: "Sherbime te perfshira",
        packageContent: "Permbajtja e paketes",
        noPackagesFound: "Nuk u gjet asnje pakete",
        noPackagesHint: "Krijo nje pakete me sherbimet e disponueshme.",
        editPackage: "Ndrysho paketen",
        newPackageModal: "Pakete e re",
        packageName: "Emri i paketes",
        packageType: "Lloji",
        packageTypeStandard: "Pakete",
        packageTypeTastingMenu: "Menu degustimi",
        courseIndex: "Pjata",
        courseName: "Emri i pjates",
        currentCourse: "Pjata aktuale",
        courseNameOptional: "Emri i pjates (opsional)",
        nextCourse: "Vazhdo / Pjata e re",
        courseFlowHint: "Shto artikujt e kesaj pjate, pastaj vazhdo te pjata tjeter.",
        capacity: "Kapaciteti",
        manualPriceOptional: "Cmim manual (opsional)",
        packageActive: "Paketa aktive",
        activeFrom: "Aktive nga",
        activeTo: "Aktive deri ne",
        description: "Pershkrimi",
        selectIncludedProducts: "Zgjidh sherbimet e perfshira",
        remove: "Hiq",
        add: "Shto",
        quantityShort: "Sasi",
        uploadImages: "Ngarko imazhe",
        uploadingImages: "Duke ngarkuar imazhet...",
        imageFormats: "JPG, PNG, WEBP",
        selectionSummary: "Permbledhja e zgjedhjes",
        selectedProducts: "Sherbime te zgjedhura",
        productsTotal: "Totali i sherbimeve",
        finalPackagePrice: "Cmimi final i paketes",
        cancel: "Anullo",
        saveChanges: "Ruaj ndryshimet",
        createPackage: "Krijo paketen",
        deletePackageTitle: "Fshi paketen",
        deletePackageConfirm: "Je i sigurt qe do ta fshish kete pakete?",
        delete: "Fshi",
      },
            billing: {
              page: "Faturimi",
              subtitle: "Menaxho faturat, dokumentet tregtare dhe faturat provizore",
              actions: {
                newDocument: "Dokument i ri",
                export: "Eksporto",
                exportSelected: "Eksporto ({{count}})",
                exporting: "Duke eksportuar...",
                view: "Shiko",
                duplicate: "Dupliko",
                print: "Printo",
                download: "Download",
                sendSelectedInvoices: "Dergo te zgjedhurat ({{count}})",
                sendingInvoices: "Duke derguar...",
                sendInvoice: "Dergo faturen",
                cancelInvoice: "Anullo faturen",
                printCourtesyCopy: "Printo kopje fature",
              },
              export: {
                selectAtLeastOne: "Zgjidh te pakten nje fature per eksport",
                success: "{{count}} fatura u eksportuan",
                partialError: "U eksportuan {{success}} fatura, {{failed}} nuk u eksportuan",
              },
              summary: {
                totalDocuments: "Dokumente gjithsej",
                totalDocumentsSubtitle: "Të gjitha dokumentet e lëshuara dhe draft",
                invoices: "Fatura",
                invoicesSubtitle: "Fatura tatimore",
                commercialDocuments: "Dokumente tregtare",
                commercialDocumentsSubtitle: "Kupona dhe dokumente të ngjashme",
                totalAmount: "Shuma totale",
                totalAmountSubtitle: "Shuma e totalit të dukshëm",
                title: "Faturë u krijua me sukses",
                subtitle: "Fatura u krijua me sukses. Mund ta shikoni tani.",
                fileName: "Emri i skedarit",
                name: "emri",
                date: "data e skadencës"
              },
              filters: {
                searchPlaceholder: "Kërko sipas numrit, klientit, NIPT/kodit fiskal, referencës, lokacionit, operatorit",
                documentType: "Lloji i dokumentit",
                status: "Statusi",
                from: "Nga",
                to: "Deri",
                reset: "Rivendos",
              },
              table: {
                recordsFound: "rezultate",
                columns: {
                  isSent: "I dërguari",
                  isSent_notes: "Mesazh",
                  documentType: "Lloji i Dokumentit",
                  number: "Numri",
                  date: "Data",
                  customer: "Klienti",
                  vatOrFiscalCode: "NIPT/Kodi Fiskal",
                  taxableAmount: "Baza e Tatueshme",
                  vat: "TVSH",
                  total: "Totali",
                  paymentMethod: "Mënyra e Pagesës",
                  status: "Statusi",
            incassoStatus: "Statusi i arketimit",
            paymentDate: "Data e arketimit",
                  reference: "Referenca",
                  locationTable: "Dhoma",
                  operator: "Operatori",
                  actions: "Veprime",
                },
              },
        incassoOptions: {
          collected: "I arketuar",
          notCollected: "I paarketuar",
          postponed: "I paarketuar me arketim të shtyrë",
        },
              empty: {
                title: "Nuk u gjet asnjë dokument",
                subtitle: "Provoni të ndryshoni filtrat ose krijoni një dokument të ri.",
              },
              documentTypes: {
                all: "Të gjitha",
                invoice: "Faturë",
                commercialDocument: "Dokument Tregtar",
                draftBill: "Faturë Provizore",
                creditNote: "Notë Krediti",
              },
              status: {
                all: "Të gjitha",
                draft: "Draft",
                issued: "I lëshuar",
                paid: "I paguar",
                cancelled: "I anuluar",
                reversed: "I stornuar",
                sending: "Duke derguar",
                sent: "E derguar",
                error: "Gabim",
                cancelling: "Duke anulluar",
              },
              creditNote: {
                originalInvoice: "Stornon faturen {{id}}",
                creditNote: "Note krediti {{number}}",
              },
              batchResults: {
                title: "Rezultati i dergimit te faturave",
                invoice: "Fatura #{{id}}",
                generic: "Dergim",
              },
              cancelDialog: {
                title: "Anullo faturen",
                draftMessage: "Ky draft do te fshihet.",
                sentMessage: "Kjo fature eshte derguar. Do te krijohet nje note krediti draft.",
                confirm: "Konfirmo",
                cancelling: "Duke anulluar...",
              },
              errors: {
                fetchClients: "Gabim në marrjen e klientëve",
                missingAuth: "Tokeni i autentifikimit nuk u gjet",
              },
              createDialog: {
                title: "Krijo fature",
                fields: {
                  sdiCode: "Kodi SdI",
                  subjectType: "Lloji i Subjektit",
                  invoiceLineDiscountSurcharge: "Zbritje/Shtesë",
                  subjectTypeOptions: {
                    private: "Privat",
                    company: "Kompani",
                  },
                  client: "Klienti",
                  customerName: "Emri i klientit",
                  emailPec: "Email / PEC",
                  customerId: "ID e klientit",
                  companyId: "ID e kompanise",
                  documentType: "Lloji i dokumentit",
                  customerAddress: "Adresa e klientit",
                  streetNumber: "Numri i rruges",
                  zip: "Kodi postar",
                  city: "Qyteti",
                  province: "Qarku",
                  taxCode: "Kodi fiskal",
                  vatNumber: "Numri i TVSH",
                  reaOffice: "Zyra e REA-s",
                  reaNumber: "Numri i REA-s",
                  taxableAmount: "Baza e tatueshme",
                  vatPercent: "TVSH %",
                  vatAmount: "Shuma e TVSH",
                  total: "Totali",
                  paymentConditions: "Kushtet e pageses",
                  paymentMethod: "Menyra e pageses",
                  dueDate: "Data e afatit",
                  paymentAmount: "Shuma e pageses",
                  reason: "Arsyeja",
                  invoiceLines: "Rreshtat e faturës",
                  invoiceLineDescription: "Përshkrimi",
                  invoiceLineQuantity: "Sasia",
                  invoiceLineUnitPrice: "Çmimi për njësi",
                },
                actions: {
                  cancel: "Anullo",
                  save: "Ruaj faturen",
                  saving: "Duke ruajtur...",
                  addInvoiceLine: "Shto rresht",
                  removeLine: "Hiq",
                },
              },
            },
            month: {
              jan: "Jan", feb: "Shk", mar: "Mar", apr: "Pri",
              may: "Maj", jun: "Qer", jul: "Kor", aug: "Gus",
              sep: "Sht", oct: "Tet", nov: "Nën", dec: "Dhj",
              error: "Gabim gjatë kërkimit të muajit",
            },
            price_per_weight: "Çmimi sipas peshës",
            weight_unit: "Njësia e matjes",
          },
        },
      };

      Object.entries(spaWaitlistTranslations).forEach(([language, waitlist]) => {
        resources[language].translation.spa.waitlist = waitlist;
      });
      Object.entries(spaCommunicationTranslations).forEach(([language, communications]) => {
        resources[language].translation.spa.communications = communications;
      });
      Object.entries(spaDailyDashboardTranslations).forEach(([language, daily]) => {
        resources[language].translation.spa.daily = daily;
      });
      Object.entries(spaClinicalTranslations).forEach(([language, clinical]) => {
        resources[language].translation.spa.clinical = clinical;
      });

      i18n
        .use(initReactI18next)
        .init({
          resources,
          lng: defaultLng,
          fallbackLng: 'en',
          supportedLngs: ['en', 'it', 'sq'],
          interpolation: {
            escapeValue: false,
            returnEmptyString: false,
          },
        });

      Object.entries(spaWorkflowTranslations).forEach(([language, spa]) => {
        i18n.addResourceBundle(language, 'translation', { spa }, true, true);
      });

      // Sincronizza <html lang> e persisti scelta utente
      if (typeof document !== 'undefined') {
        document.documentElement.lang = i18n.language;
      }
      i18n.on('languageChanged', (lng) => {
        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem('appLang', lng);
        }
        if (typeof document !== 'undefined') {
          document.documentElement.lang = lng;
        }
      });

      export default i18n;
